/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Thatch API for web components
 * OpenAPI spec version: 0.0.1
 */
/**
 * access_requests.AccessRequestList model
 */
export interface AccessRequestsAccessRequestList {
  /** The resulting page of access requests */
  data?: AccessRequestsAccessRequestListItem[];
  pagination?: Pagination;
}

/**
 * The current state of the access request
 */
export type AccessRequestsAccessRequestListItemState = typeof AccessRequestsAccessRequestListItemState[keyof typeof AccessRequestsAccessRequestListItemState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessRequestsAccessRequestListItemState = {
  submitted: 'submitted',
  granted: 'granted',
  denied: 'denied',
  revoked: 'revoked',
} as const;

export interface AccessRequestsAccessRequestListItem {
  /** The access request's unique identifier */
  id: string;
  /** The user ID of the user who made the access request */
  requested_by_id: string;
  /** The end time of the access window, if access is granted */
  requested_end_time?: string;
  /** The identifier for the resource that access was requested for */
  requested_resource: string;
  /** The start time of the access window, if access is granted */
  requested_start_time?: string;
  /** The current state of the access request */
  state: AccessRequestsAccessRequestListItemState;
}

export interface Pagination {
  /** Total number of records */
  total_records: number;
  /** Current page number */
  current_page: number;
  /** Total number of pages */
  total_pages: number;
  /**
   * Next page number
   * @nullable
   */
  next_page: number | null;
  /**
   * Previous page number
   * @nullable
   */
  prev_page: number | null;
}

/**
 * Create an access request
 */
export interface PostAccessRequests {
  /** The requested start of the permitted access window, in iso8601 format */
  requested_end_time?: string;
  requested_reason: string;
  requested_resource: string;
  /** The requested end of the permitted access window, in iso8601 format */
  requested_start_time?: string;
}

/**
 * The current state of the access request
 */
export type AccessRequestsAccessRequestState = typeof AccessRequestsAccessRequestState[keyof typeof AccessRequestsAccessRequestState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessRequestsAccessRequestState = {
  submitted: 'submitted',
  granted: 'granted',
  denied: 'denied',
  revoked: 'revoked',
} as const;

/**
 * access_requests.AccessRequest model
 */
export interface AccessRequestsAccessRequest {
  /** When the request was granted or denied, if it was granted or denied */
  granted_or_denied_at?: string;
  /** The reason the request was granted or denied, if it was granted or denied */
  granted_or_denied_reason?: string;
  /** The access request's unique identifier */
  id: string;
  /** When the request was submitted */
  requested_at: string;
  /** The user ID of the user who made the access request */
  requested_by_id: string;
  /** The end time of the access window, if access is granted */
  requested_end_time?: string;
  /** The reason given for needing to access the resource */
  requested_reason: string;
  /** The identifier for the resource that access was requested for */
  requested_resource: string;
  /** The start time of the access window, if access is granted */
  requested_start_time?: string;
  /** The time at which an access grant was revoked, if it was revoked */
  revoked_at?: string;
  /** The reason revoking an access grant, if it was revoked */
  revoked_reason?: string;
  /** The current state of the access request */
  state: AccessRequestsAccessRequestState;
}

/**
 * Current state of the compliance check
 */
export type AdminComplianceCheckState = typeof AdminComplianceCheckState[keyof typeof AdminComplianceCheckState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminComplianceCheckState = {
  initiated: 'initiated',
  failed: 'failed',
  passed: 'passed',
  errored: 'errored',
  expired: 'expired',
  processing: 'processing',
  queued_for_invite: 'queued_for_invite',
  invite_sent: 'invite_sent',
  invite_opened: 'invite_opened',
} as const;

/**
 * Provider of the compliance check
 */
export type AdminComplianceCheckProvider = typeof AdminComplianceCheckProvider[keyof typeof AdminComplianceCheckProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminComplianceCheckProvider = {
  Footprint: 'Footprint',
} as const;

/**
 * Type of entity being checked
 */
export type AdminComplianceCheckEntityType = typeof AdminComplianceCheckEntityType[keyof typeof AdminComplianceCheckEntityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminComplianceCheckEntityType = {
  'Compliance::Owner': 'Compliance::Owner',
  Employer: 'Employer',
} as const;

/**
 * Type of compliance policy
 */
export type AdminComplianceCheckPolicyType = typeof AdminComplianceCheckPolicyType[keyof typeof AdminComplianceCheckPolicyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminComplianceCheckPolicyType = {
  KYB: 'KYB',
  KYC: 'KYC',
} as const;

/**
 * admin.ComplianceCheck model
 */
export interface AdminComplianceCheck {
  /** Compliance check ID */
  id: string;
  /** Current state of the compliance check */
  state: AdminComplianceCheckState;
  /** Provider of the compliance check */
  provider?: AdminComplianceCheckProvider;
  /** Type of entity being checked */
  entity_type: AdminComplianceCheckEntityType;
  /** ID of the entity being checked */
  entity_id: string;
  /** Name of the entity being checked */
  entity_name: string;
  /** ID of the compliance policy */
  policy_id: string;
  /** Type of compliance policy */
  policy_type: AdminComplianceCheckPolicyType;
  /** Remote ID from the compliance provider */
  remote_id?: string;
  /** Timestamp when the compliance check was completed remotely */
  remote_completed_at?: string;
  /** Link to the compliance check in the compliance provider */
  remote_link?: string;
  /** ID of the employer */
  employer_id: string;
  /** Timestamp when the compliance check was created */
  created_at?: string;
  /** Timestamp when check was last updated */
  updated_at?: string;
}

/**
 * Override a failing compliance check to passing
 */
export interface PostAdminComplianceChecksCheckIdOverrideFailingCheck {
  /** Reason for overriding the check */
  override_reason: string;
  /** Compliance provider to use */
  provider: string;
}

/**
 * Create and execute a new Compliance::Check
 */
export interface PostAdminComplianceChecks {
  /** ID of the entity to check */
  entity_id: string;
  /** Type of entity (Employer or Owner) */
  entity_type: string;
  /** Compliance provider to use */
  provider: string;
  /** Type of compliance policy */
  policy_type: string;
}

/**
 * admin.ComplianceOwner model
 */
export interface AdminComplianceOwner {
  /** Compliance owner ID */
  id: string;
  /** Email address of the compliance owner */
  email: string;
  /** First name of the compliance owner */
  first_name: string;
  /** Last name of the compliance owner */
  last_name: string;
  /** ID of the employer */
  employer_id: string;
  /** ID of the associated user (if any) */
  user_id?: string;
  /** Timestamp when the compliance owner was created */
  created_at?: string;
  /** Remote ID of the compliance owner */
  remote_id?: string;
  /** Remote link of the compliance owner */
  remote_link?: string;
  /** Indicates whether Owner is a controlling officer */
  is_controlling_officer: boolean;
  /** Indicates whether Owner is a beneficial owner */
  is_beneficial_owner: boolean;
  /** Title of the compliance owner */
  title: string;
}

/**
 * Update a compliance owner
 */
export interface PutAdminComplianceOwnersOwnerId {
  /** Email address of the owner */
  email: string;
  /** Title of the owner */
  title: string;
}

/**
 * Create a new compliance owner
 */
export interface PostAdminComplianceOwners {
  /** ID of the employer */
  employer_id: string;
  /** First name of the owner */
  first_name: string;
  /** Last name of the owner */
  last_name: string;
  /** Email address of the owner */
  email: string;
  /** Whether Owner has significant control over the business */
  is_controlling_officer: boolean;
  /** Title of the owner */
  title: string;
  /** Whether Owner is a beneficial owner */
  is_beneficial_owner: boolean;
  /** ID of the associated user */
  user_id?: string;
}

/**
 * Type of compliance policy
 */
export type AdminCompliancePolicyPolicyType = typeof AdminCompliancePolicyPolicyType[keyof typeof AdminCompliancePolicyPolicyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminCompliancePolicyPolicyType = {
  KYB: 'KYB',
  KYC: 'KYC',
} as const;

/**
 * Provider of the compliance policy
 */
export type AdminCompliancePolicyProvider = typeof AdminCompliancePolicyProvider[keyof typeof AdminCompliancePolicyProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminCompliancePolicyProvider = {
  Footprint: 'Footprint',
} as const;

/**
 * admin.CompliancePolicy model
 */
export interface AdminCompliancePolicy {
  /** Compliance policy ID */
  id: string;
  /** Type of compliance policy */
  policy_type: AdminCompliancePolicyPolicyType;
  /** Provider of the compliance policy */
  provider: AdminCompliancePolicyProvider;
  /** Timestamp when the compliance policy was created */
  created_at?: string;
  /** Timestamp when the compliance policy was last updated */
  updated_at?: string;
}

/**
 * admin.EmployerData model
 */
export interface AdminEmployerData {
  employer?: AdminEmployer;
}

/**
 * Review Status
 */
export type AdminEmployerReviewStatus = typeof AdminEmployerReviewStatus[keyof typeof AdminEmployerReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerReviewStatus = {
  pending: 'pending',
  approved: 'approved',
  denied: 'denied',
  inactive_duplicate: 'inactive_duplicate',
  inactive_withdrawn: 'inactive_withdrawn',
  inactive_ineligible: 'inactive_ineligible',
  inactive_churned: 'inactive_churned',
} as const;

/**
 * Bank onboarding status based on audit states
 */
export type AdminEmployerBankOnboardingStatus = typeof AdminEmployerBankOnboardingStatus[keyof typeof AdminEmployerBankOnboardingStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerBankOnboardingStatus = {
  none: 'none',
  passing: 'passing',
  pending: 'pending',
  failing: 'failing',
} as const;

/**
 * Whether the employer has a connected bank account through Plaid
 */
export type AdminEmployerPlaidAccountVerificationStatus = typeof AdminEmployerPlaidAccountVerificationStatus[keyof typeof AdminEmployerPlaidAccountVerificationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerPlaidAccountVerificationStatus = {
  pending: 'pending',
  verified: 'verified',
  failed: 'failed',
  none: 'none',
} as const;

/**
 * Employer onboarding status
 */
export type AdminEmployerOnboardingStatus = typeof AdminEmployerOnboardingStatus[keyof typeof AdminEmployerOnboardingStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerOnboardingStatus = {
  open: 'open',
  launched: 'launched',
  quoted: 'quoted',
  quote_accepted: 'quote_accepted',
  payroll_connected: 'payroll_connected',
  bank_account_created: 'bank_account_created',
  completed: 'completed',
} as const;

/**
 * admin.Employer model
 */
export interface AdminEmployer {
  /** Employer ID */
  id: string;
  /** Stripe Price ID */
  stripe_price_id: string;
  /** Stripe Price IDs */
  stripe_price_ids: string[];
  payroll_config?: AdminPayrollConfig;
  profile?: AdminEmployerProfile;
  /** Review Status */
  review_status?: AdminEmployerReviewStatus;
  /** Date and time the employer was reviewed */
  reviewed_at?: string;
  /** ID of the user who reviewed the employer */
  reviewed_by_id?: string;
  /** Date and time the employer was created */
  created_at: string;
  /** Compliance audits for this employer */
  compliance_audits?: AdminComplianceAudit[];
  /** Bank onboarding status based on audit states */
  bank_onboarding_status?: AdminEmployerBankOnboardingStatus;
  /** Whether the employer has a connected bank account through Plaid */
  plaid_account_verification_status: AdminEmployerPlaidAccountVerificationStatus;
  /** Billing status of the employer */
  billing_status?: string;
  /** Whether the employer has any employees with non-nil last_invited_at */
  invited_employees: boolean;
  /** Whether the employer has at least one confirmed enrollment for one of their employees */
  has_confirmed_enrollments: boolean;
  /** Employer name */
  name: string;
  /** Whether the employer has a connected bank account through Plaid */
  has_plaid_account: boolean;
  /** Employer onboarding status */
  onboarding_status: AdminEmployerOnboardingStatus;
  brokers?: BrokersBroker[];
  /** Attributes that current user is authorized to write */
  permitted_attributes: string[];
}

export interface AdminPayrollConfig {
  /** Payroll Config ID */
  id: string;
  payroll_finch_config?: AdminPayrollFinchConfig;
  payroll_merge_config?: AdminPayrollMergeConfig;
}

/**
 * Finch Provider ID
 */
export type AdminPayrollFinchConfigFinchConnectionStatus = typeof AdminPayrollFinchConfigFinchConnectionStatus[keyof typeof AdminPayrollFinchConfigFinchConnectionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPayrollFinchConfigFinchConnectionStatus = {
  connected: 'connected',
  disconnected: 'disconnected',
  paused: 'paused',
  pending_disconnection: 'pending_disconnection',
} as const;

export interface AdminPayrollFinchConfig {
  /** Payroll Finch Config ID */
  id: string;
  /** Finch Connection ID */
  connection_id?: string;
  /** Finch Client ID */
  client_id?: string;
  /** Finch Provider ID */
  finch_provider_id?: string;
  /** Finch Provider ID */
  finch_connection_status?: AdminPayrollFinchConfigFinchConnectionStatus;
  /** Last Employee Sync Date/Time */
  last_employee_sync?: string;
  /** Payroll Config creation Date/Time */
  created_at: string;
}

/**
 * Merge Connection Status
 */
export type AdminPayrollMergeConfigStatus = typeof AdminPayrollMergeConfigStatus[keyof typeof AdminPayrollMergeConfigStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPayrollMergeConfigStatus = {
  COMPLETE: 'COMPLETE',
  IDLE: 'IDLE',
  INCOMPLETE: 'INCOMPLETE',
  RELINK_NEEDED: 'RELINK_NEEDED',
} as const;

export interface AdminPayrollMergeConfig {
  /** Payroll Merge Config ID */
  id: string;
  /** Integration Name */
  integration_name: string;
  /** Merge Connection Status */
  status: AdminPayrollMergeConfigStatus;
  /** Status Detail */
  status_detail: string;
  /** Linked Account ID */
  linked_account_id: string;
  /** Completion Date/Time */
  completed_at?: string;
  /** Creation Date/Time */
  created_at: string;
  /** Last Update Date/Time */
  updated_at: string;
}

/**
 * Employer Industry
 */
export type AdminEmployerProfileIndustry = typeof AdminEmployerProfileIndustry[keyof typeof AdminEmployerProfileIndustry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerProfileIndustry = {
  accommodation_and_food_services: 'accommodation_and_food_services',
  administrative_and_support_and_waste_management_services: 'administrative_and_support_and_waste_management_services',
  agriculture_forestry_fishing_and_hunting: 'agriculture_forestry_fishing_and_hunting',
  arts_entertainment_and_recreation: 'arts_entertainment_and_recreation',
  construction: 'construction',
  educational_services: 'educational_services',
  finance_and_insurance: 'finance_and_insurance',
  health_care_and_social_assistance: 'health_care_and_social_assistance',
  information_and_technology: 'information_and_technology',
  management_of_companies_and_enterprises: 'management_of_companies_and_enterprises',
  manufacturing: 'manufacturing',
  mining_quarrying_and_oil_and_gas_extraction: 'mining_quarrying_and_oil_and_gas_extraction',
  other_services_except_public_administration: 'other_services_except_public_administration',
  professional_scientific_and_technical_services: 'professional_scientific_and_technical_services',
  public_administration: 'public_administration',
  real_estate_and_rental_and_leasing: 'real_estate_and_rental_and_leasing',
  retail_trade: 'retail_trade',
  transportation_and_warehousing: 'transportation_and_warehousing',
  utilities: 'utilities',
  wholesale_trade: 'wholesale_trade',
  other: 'other',
} as const;

/**
 * Business Type
 */
export type AdminEmployerProfileBusinessType = typeof AdminEmployerProfileBusinessType[keyof typeof AdminEmployerProfileBusinessType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerProfileBusinessType = {
  c_corp: 'c_corp',
  s_corp: 's_corp',
  llc: 'llc',
  llp: 'llp',
  partnership: 'partnership',
  sole_proprietorship: 'sole_proprietorship',
  non_profit: 'non_profit',
} as const;

/**
 * admin.EmployerProfile model
 */
export interface AdminEmployerProfile {
  /** Employer Profile ID */
  id: string;
  /** Employer Name */
  name?: string;
  /** Employer DBA */
  dba?: string;
  /** Employer Industry */
  industry?: AdminEmployerProfileIndustry;
  /** Employer Phone Number */
  phone_number?: string;
  /** Address Line 1 */
  address_line1?: string;
  /** Address Line 2 */
  address_line2?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** ZIP Code */
  zip?: string;
  /** Attribution */
  attribution?: string;
  /** Employer EIN */
  ein?: string;
  /** Business Type */
  business_type?: AdminEmployerProfileBusinessType;
  /** Number of Employees */
  number_of_employees?: number;
}

/**
 * Audit state
 */
export type AdminComplianceAuditState = typeof AdminComplianceAuditState[keyof typeof AdminComplianceAuditState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminComplianceAuditState = {
  pending: 'pending',
  passed: 'passed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

/**
 * admin.ComplianceAudit model
 */
export interface AdminComplianceAudit {
  /** Compliance Audit ID */
  id: string;
  /** Audit state */
  state: AdminComplianceAuditState;
  /** Date and time the Audit was created */
  created_at: string;
  /** Date and time the audit was last updated */
  updated_at: string;
  /** Reason for override (if cancelled) */
  override_reason?: string;
  /** Results of progress rules */
  progress_rule_results: AdminRuleResult[];
  /** Results of final rules */
  final_rule_results: AdminRuleResult[];
  /** Partner name based on Audit type */
  partner_name: string;
}

export interface AdminRuleResult {
  /** The rule name */
  rule: string;
  /** Whether the rule passes */
  passes: boolean;
}

export interface BrokersBroker {
  /** Broker ID */
  id: string;
  /** Broker name */
  broker_name?: string;
  /** Brokerage ID */
  brokerage_id: string;
}

/**
 * admin.EmployeesData model
 */
export interface AdminEmployeesData {
  employees?: AdminEmployee[];
}

export interface AdminEmployee {
  /** Employee ID */
  id: string;
  /** Employee First Name */
  first_name: string;
  /** Employee Last Name */
  last_name: string;
  /** Employee date of birth */
  integration_employee_id: string;
  /** User ID of the employee */
  user_id?: string;
  /** Member ID of the employee */
  member_id?: string;
  /** Email of the employee */
  personal_email?: string;
}

/**
 * Sync employer directory with Finch
 */
export interface PostAdminFinchEmployerSync {
  /** The ID of the employer */
  employer_id: string;
}

/**
 * Update the Employers Finch connection status
 */
export interface PutAdminFinchEmployerUpdateFinchConnectionStatus {
  /** The ID of the employer */
  employer_id: string;
  /** The new connection status to set on the Payroll Config */
  new_connection_status: string;
}

/**
 * Merge employees with duplicates
 */
export interface PostAdminFinchEmployerMergeEmployees {
  /** The ID of the employer */
  employer_id: string;
}

/**
 * Finch output
 */
export type AdminFinchOutputOutput = { [key: string]: unknown };

/**
 * admin.FinchOutput model
 */
export interface AdminFinchOutput {
  /** Finch output */
  output?: AdminFinchOutputOutput;
  status?: string;
}

/**
 * admin.MergeIsolvedClientsList model
 */
export interface AdminMergeIsolvedClientsList {
  clients?: AdminMergeIsolvedClient[];
}

export interface AdminMergeIsolvedClient {
  /** The client ID */
  client_id?: string;
  /** The client code */
  client_code?: string;
  /** The client name */
  client_name?: string;
}

/**
 * Update the company ID for the employer's Merge config
 */
export interface PutAdminMergeEmployerUpdateCompanyId {
  /** The ID of the employer */
  employer_id: string;
  /** The company ID to set (empty string to clear) */
  company_id?: string;
}

/**
 * admin.MergeUpdateResponse model
 */
export interface AdminMergeUpdateResponse {
  /** Response message */
  message?: string;
  /** Updated company IDs */
  company_ids?: string[];
}

/**
 * admin.EmployerOpenEnrollmentList model
 */
export interface AdminEmployerOpenEnrollmentList {
  /** List of employers with open enrollment information */
  employers?: AdminEmployerOpenEnrollment[];
  pagination?: Pagination;
}

/**
 * admin.EmployerOpenEnrollment model
 */
export interface AdminEmployerOpenEnrollment {
  /** Employer ID */
  id: string;
  /** Billing status */
  billing_status: string;
  profile?: AdminEmployerProfile;
  open_enrollment_config?: AdminEmployerOpenEnrollmentConfig;
  ichra_config?: AdminEmployerICHRAConfig;
}

/**
 * OEP cohort
 */
export type AdminEmployerOpenEnrollmentConfigCohort = typeof AdminEmployerOpenEnrollmentConfigCohort[keyof typeof AdminEmployerOpenEnrollmentConfigCohort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerOpenEnrollmentConfigCohort = {
  renewal_self_serve: 'renewal_self_serve',
  renewal_high_touch: 'renewal_high_touch',
  renewal_custom: 'renewal_custom',
  renewal_sales: 'renewal_sales',
  new_employer_self_serve: 'new_employer_self_serve',
  new_employer_sales: 'new_employer_sales',
  new_employer_unknown_source: 'new_employer_unknown_source',
} as const;

/**
 * Current renewal status
 */
export type AdminEmployerOpenEnrollmentConfigStatus = typeof AdminEmployerOpenEnrollmentConfigStatus[keyof typeof AdminEmployerOpenEnrollmentConfigStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerOpenEnrollmentConfigStatus = {
  not_ready: 'not_ready',
  ready_for_open_enrollment: 'ready_for_open_enrollment',
  employees_confirmed: 'employees_confirmed',
  accepted_preliminary_quote: 'accepted_preliminary_quote',
  accepted_final_quote: 'accepted_final_quote',
} as const;

/**
 * admin.EmployerOpenEnrollmentConfig model
 */
export interface AdminEmployerOpenEnrollmentConfig {
  /** Open enrollment config ID */
  id: string;
  /** Employer ID */
  employer_id: string;
  /** Open enrollment year */
  open_enrollment_year: number;
  /** OEP cohort */
  cohort: AdminEmployerOpenEnrollmentConfigCohort;
  current_year_monthly_employer_contribution?: Money;
  open_enrollment_year_monthly_employer_contribution?: Money;
  monthly_employer_contribution_delta?: Money;
  /** Current renewal status */
  status: AdminEmployerOpenEnrollmentConfigStatus;
  /** Number of eligible employees */
  eligible_employee_count: number;
  /** Percentage of employees with final rates */
  percentage_of_employees_with_final_rates: number;
  /** States with final rates */
  states_with_final_rates: string[];
  /** States with preliminary rates */
  states_with_preliminary_rates: string[];
  employer_renewal_config?: EmployersRenewalsRenewalConfig;
}

export interface Money {
  /** Formatted amount */
  formatted_amount: string;
  /** minor currency unit */
  subunits: number;
  /** Currency code */
  currency: string;
}

/**
 * employers.renewals.RenewalConfig model
 */
export interface EmployersRenewalsRenewalConfig {
  /** Renewal config ID */
  id: string;
  /** Renewal year */
  renewal_year: number;
  /** Prospect ID */
  prospect_id: string;
  /** Employee census ID */
  employee_census_id: string;
  /** Employee census updates ID */
  employee_census_updates_id?: string;
  current_year_quote: QuotingQuote;
  renewal_year_quote: QuotingQuote;
  /** Whether any employees are missing yearly_pay, zip, or date_of_birth attributes */
  missing_required_employee_information: boolean;
  /** Whether the employer has accepted the preliminary quote */
  has_accepted_preliminary_quote: boolean;
  /** Whether the employer has accepted the finalized quote */
  has_accepted_finalized_quote: boolean;
}

/**
 * Benchmark
 */
export type QuotingQuoteBenchmark = typeof QuotingQuoteBenchmark[keyof typeof QuotingQuoteBenchmark];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteBenchmark = {
  all_plans_silver_plus: 'all_plans_silver_plus',
  on_thatch_bronze: 'on_thatch_bronze',
  on_thatch_silver: 'on_thatch_silver',
  on_thatch_gold: 'on_thatch_gold',
  on_thatch_platinum: 'on_thatch_platinum',
  score_tier_0: 'score_tier_0',
  score_tier_1: 'score_tier_1',
  score_tier_2: 'score_tier_2',
  score_tier_3: 'score_tier_3',
} as const;

export type QuotingQuoteMetalTiersItem = typeof QuotingQuoteMetalTiersItem[keyof typeof QuotingQuoteMetalTiersItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteMetalTiersItem = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
} as const;

/**
 * Quote type
 */
export type QuotingQuoteQuoteType = typeof QuotingQuoteQuoteType[keyof typeof QuotingQuoteQuoteType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteQuoteType = {
  public_tool: 'public_tool',
  internal_tool: 'internal_tool',
  quoting_v2: 'quoting_v2',
  self_serve_tool: 'self_serve_tool',
  renewal: 'renewal',
} as const;

/**
 * Target metal tier
 */
export type QuotingQuoteTargetMetalTier = typeof QuotingQuoteTargetMetalTier[keyof typeof QuotingQuoteTargetMetalTier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteTargetMetalTier = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
} as const;

/**
 * quoting.Quote model
 */
export interface QuotingQuote {
  /** Quote ID */
  id: string;
  /** Quote name */
  name?: string;
  /** Benchmark */
  benchmark?: QuotingQuoteBenchmark;
  /** Coverage percentile */
  coverage_percentile?: number;
  /** Coverage percentiles */
  coverage_percentiles?: number[];
  /**
   * Coverage start date
   * @nullable
   */
  coverage_start_date?: string | null;
  /** Version */
  version: number;
  /** Year */
  year: number;
  /** Employee multiplier */
  employee_multiplier?: number;
  /** First dependent multiplier */
  first_dependent_multiplier?: number;
  /** Additional dependent multiplier */
  additional_dependent_multiplier?: number;
  /** Metal tiers */
  metal_tiers?: QuotingQuoteMetalTiersItem[];
  /** Quote type */
  quote_type: QuotingQuoteQuoteType;
  /** Whether the quote has any flat allowances. It should not be the case that a quote has a mix of flat and dynamic allowances. */
  has_flat_allowances: boolean;
  /** Target individual deductible */
  target_individual_deductible?: number;
  /** Target individual out-of-pocket maximum */
  target_individual_oop_max?: number;
  /** Target metal tier */
  target_metal_tier?: QuotingQuoteTargetMetalTier;
  /** Target network type */
  target_network_type?: string;
  /** Quote generation errors */
  quote_errors?: string[];
  /** Quote generation status */
  status?: string;
  /** Created at */
  created_at: string;
  /** Updated at */
  updated_at: string;
  /** Number of employees in the associated census */
  eligible_employee_count?: number;
  /** File name of the census used for this quote */
  census_file_name?: string;
  /** Prospect employee census ID associated with this quote */
  quoting_prospect_employee_census_id?: string;
  /** Prospect ID associated with this quote */
  quoting_prospect_id: string;
  /** Prospect name */
  quoting_prospect_name?: string;
  /** Quote allowances */
  allowances?: QuotingQuoteAllowance[];
  /** Download link for the quote's raw results */
  download_link?: string;
  total_monthly_employer_contribution?: Money;
  /** Whether the quote has a pricing configured */
  pricing_configured: boolean;
  /** Whether the quote is out of date (based on a newer allowance config) */
  out_of_date?: boolean;
  /** Whether the quote is preliminary (based on estimated rate data) */
  preliminary?: boolean;
  /** States that the quote was delivered to */
  delivered_data_state_codes?: string[];
  /** States that the quote was projected to be delivered to */
  projected_data_state_codes?: string[];
  /** Whether the quote is using an outdated granular allowance configuration */
  outdated_granular_allowance_config?: boolean;
  /** Max employee contribution percentage */
  max_employee_contribution_percentage?: number;
}

/**
 * Benchmark for dynamic allowances
 */
export type QuotingQuoteAllowanceBenchmark = typeof QuotingQuoteAllowanceBenchmark[keyof typeof QuotingQuoteAllowanceBenchmark];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteAllowanceBenchmark = {
  all_plans_silver_plus: 'all_plans_silver_plus',
  on_thatch_bronze: 'on_thatch_bronze',
  on_thatch_silver: 'on_thatch_silver',
  on_thatch_gold: 'on_thatch_gold',
  on_thatch_platinum: 'on_thatch_platinum',
  score_tier_0: 'score_tier_0',
  score_tier_1: 'score_tier_1',
  score_tier_2: 'score_tier_2',
  score_tier_3: 'score_tier_3',
} as const;

/**
 * Employment type
 */
export type QuotingQuoteAllowanceEmploymentType = typeof QuotingQuoteAllowanceEmploymentType[keyof typeof QuotingQuoteAllowanceEmploymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteAllowanceEmploymentType = {
  part_time: 'part_time',
  full_time: 'full_time',
} as const;

/**
 * Location type
 */
export type QuotingQuoteAllowanceLocationType = typeof QuotingQuoteAllowanceLocationType[keyof typeof QuotingQuoteAllowanceLocationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteAllowanceLocationType = {
  rating_area: 'rating_area',
  state: 'state',
} as const;

/**
 * Pay type
 */
export type QuotingQuoteAllowancePayType = typeof QuotingQuoteAllowancePayType[keyof typeof QuotingQuoteAllowancePayType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteAllowancePayType = {
  hourly: 'hourly',
  salary: 'salary',
} as const;

/**
 * QME treatment
 */
export type QuotingQuoteAllowanceQmeTreatment = typeof QuotingQuoteAllowanceQmeTreatment[keyof typeof QuotingQuoteAllowanceQmeTreatment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteAllowanceQmeTreatment = {
  all_allowed: 'all_allowed',
  disabled: 'disabled',
  copay_only: 'copay_only',
} as const;

/**
 * quoting.QuoteAllowance model
 */
export interface QuotingQuoteAllowance {
  /** Quote allowance ID */
  id: string;
  /** Benchmark for dynamic allowances */
  benchmark?: QuotingQuoteAllowanceBenchmark;
  /** Coverage percentile for dynamic allowances */
  coverage_percentile?: number;
  dependent_amount?: Money;
  /** Dependent contribution percentage for dynamic allowances */
  dependent_contribution_percentage?: number;
  employee_amount?: Money;
  /** Employee contribution percentage for dynamic allowances */
  employee_contribution_percentage?: number;
  /** Employment type */
  employment_type?: QuotingQuoteAllowanceEmploymentType;
  /** Location type */
  location_type?: QuotingQuoteAllowanceLocationType;
  /** Maximum age */
  max_age?: number;
  /** Maximum dependent count for flat allowances */
  max_dependent_count?: number;
  /** Minimum age */
  min_age?: number;
  /** Pay type */
  pay_type?: QuotingQuoteAllowancePayType;
  /** QME treatment */
  qme_treatment: QuotingQuoteAllowanceQmeTreatment;
  spouse_amount?: Money;
  /** Spouse contribution percentage for dynamic allowances */
  spouse_contribution_percentage?: number;
  /** Created at */
  created_at: string;
  /** Updated at */
  updated_at: string;
  /** Location ID */
  location_id?: string;
  /** Quote ID */
  quoting_quote_id: string;
}

/**
 * Whether the ICHRA config has allowances defined
 */
export type AdminEmployerICHRAConfigAllowanceType = typeof AdminEmployerICHRAConfigAllowanceType[keyof typeof AdminEmployerICHRAConfigAllowanceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmployerICHRAConfigAllowanceType = {
  flat: 'flat',
  dynamic: 'dynamic',
  not_set: 'not_set',
} as const;

export interface AdminEmployerICHRAConfig {
  /** Employer ICHRA Config ID */
  id: string;
  /** Employer ID */
  employer_id: string;
  coverage_start_date?: string;
  hide_allowances?: boolean;
  include_dental?: boolean;
  include_vision?: boolean;
  offer_dental_plan_selection?: boolean;
  offer_vision_plan_selection?: boolean;
  plan_year?: number;
  quote?: AdminQuote;
  /** Whether the ICHRA config has allowances defined */
  allowance_type?: AdminEmployerICHRAConfigAllowanceType;
}

/**
 * Quote type
 */
export type AdminQuoteQuoteType = typeof AdminQuoteQuoteType[keyof typeof AdminQuoteQuoteType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuoteQuoteType = {
  public_tool: 'public_tool',
  internal_tool: 'internal_tool',
  quoting_v2: 'quoting_v2',
  self_serve_tool: 'self_serve_tool',
} as const;

export interface AdminQuote {
  /** Quote ID */
  id: string;
  /** Quote name */
  name?: string;
  /** Coverage percentiles */
  coverage_percentiles?: number[];
  /**
   * Coverage start date
   * @nullable
   */
  coverage_start_date?: string | null;
  /** Version */
  version: number;
  /** Year */
  year: number;
  /** Quote type */
  quote_type: AdminQuoteQuoteType;
}

/**
 * The new cohort value
 */
export type PostAdminEmployerOpenEnrollmentIdCohortCohort = typeof PostAdminEmployerOpenEnrollmentIdCohortCohort[keyof typeof PostAdminEmployerOpenEnrollmentIdCohortCohort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAdminEmployerOpenEnrollmentIdCohortCohort = {
  renewal_self_serve: 'renewal_self_serve',
  renewal_high_touch: 'renewal_high_touch',
  renewal_custom: 'renewal_custom',
  renewal_sales: 'renewal_sales',
  new_employer_self_serve: 'new_employer_self_serve',
  new_employer_sales: 'new_employer_sales',
  new_employer_unknown_source: 'new_employer_unknown_source',
} as const;

/**
 * Update cohort for an employer's open enrollment config
 */
export interface PostAdminEmployerOpenEnrollmentIdCohort {
  /** The new cohort value */
  cohort: PostAdminEmployerOpenEnrollmentIdCohortCohort;
}

/**
 * admin.EnrollmentEvents model
 */
export interface AdminEnrollmentEvents {
  data?: AdminEnrollmentEvent[];
}

/**
 * Enrollment event type
 */
export type AdminEnrollmentEventEnrollmentType = typeof AdminEnrollmentEventEnrollmentType[keyof typeof AdminEnrollmentEventEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEnrollmentEventEnrollmentType = {
  ichra_invite: 'ichra_invite',
  open_enrollment: 'open_enrollment',
  special_enrollment: 'special_enrollment',
} as const;

/**
 * Enrollment event subtype
 * @nullable
 */
export type AdminEnrollmentEventEnrollmentSubtype = typeof AdminEnrollmentEventEnrollmentSubtype[keyof typeof AdminEnrollmentEventEnrollmentSubtype] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEnrollmentEventEnrollmentSubtype = {
  loss_of_coverage: 'loss_of_coverage',
  relocation: 'relocation',
  birth_or_adoption: 'birth_or_adoption',
  marriage: 'marriage',
  divorce_or_legal_separation: 'divorce_or_legal_separation',
  death_of_dependent: 'death_of_dependent',
  cobra_expiration: 'cobra_expiration',
  loss_of_subsidy_eligibility: 'loss_of_subsidy_eligibility',
  thatch_incident: 'thatch_incident',
  other: 'other',
  renewal: 'renewal',
} as const;

/**
 * Status
 */
export type AdminEnrollmentEventStatus = typeof AdminEnrollmentEventStatus[keyof typeof AdminEnrollmentEventStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEnrollmentEventStatus = {
  active: 'active',
  in_progress: 'in_progress',
  completed: 'completed',
  inactive: 'inactive',
} as const;

/**
 * admin.EnrollmentEvent model
 */
export interface AdminEnrollmentEvent {
  /** Enrollment Event ID */
  id: string;
  /** Enrollment event type */
  enrollment_type: AdminEnrollmentEventEnrollmentType;
  /**
   * Enrollment event subtype
   * @nullable
   */
  enrollment_subtype?: AdminEnrollmentEventEnrollmentSubtype;
  /** Enrollment window start date */
  enrollment_window_start_date: string;
  /** Enrollment window end date */
  enrollment_window_end_date: string;
  /** Plan year */
  plan_year: number;
  /** Status */
  status: AdminEnrollmentEventStatus;
  /** Enrollment event creation Date/Time */
  created_at: string;
  /** Enrollment event last updated Date/Time */
  updated_at: string;
}

/**
 * Update employee enrollment event
 */
export interface PutAdminEnrollmentEventEnrollmentEventId {
  /** The ID of the employee */
  employee_id: string;
  /** The start date of the enrollment window */
  enrollment_window_start_date?: string;
  /** The end date of the enrollment window */
  enrollment_window_end_date?: string;
  /** The status of the enrollment event */
  status?: string;
}

/**
 * Create employee enrollment event
 */
export interface PostAdminEnrollmentEvent {
  /** The ID of the employee */
  employee_id: string;
  /** The type of enrollment event */
  enrollment_type: string;
  /** The subtype of enrollment event */
  enrollment_subtype?: string;
  /** The start date of the enrollment window */
  enrollment_window_start_date: string;
  /** The end date of the enrollment window */
  enrollment_window_end_date: string;
  /** The plan year of the enrollment event */
  plan_year: number;
  /** Do not schedule email campaigns for this event */
  prevent_invite?: boolean;
}

/**
 * admin.EmployerICHRAConfigAllowanceStructure model
 */
export interface AdminEmployerICHRAConfigAllowanceStructure {
  /** EmployerICHRAConfig ID */
  ichra_config_id: string;
  /** List of granular allowances (up to 20) */
  granular_allowances?: AdminEmployerICHRAAllowanceAmount[];
  /** Whether there are any granular allowances that specify participant-type multipliers */
  include_multiplier_columns?: boolean;
  /** Total count of granular allowances */
  granular_allowance_count: number;
  /** List of flat allowances (up to 60) */
  flat_allowances?: AdminEmployerICHRAAllowanceAmount[];
  /** Total count of flat allowances */
  flat_allowance_count: number;
  /** Whether there are any flat allowances that specify household size */
  show_household_size_column?: boolean;
  /** Whether these allowances were custom-made and need to display custom columns */
  include_custom_columns: boolean;
  /** Total count of all allowances */
  total_allowance_count: number;
}

export interface AdminEmployerICHRAAllowanceAmount {
  /** EmployerICHRAAllowanceAmount ID */
  id: string;
  amount: Money;
  benchmark: string;
  coverage_percentile?: number;
  employment_type?: string;
  granular_employee_multiplier?: number;
  granular_spouse_multiplier?: number;
  granular_dependent_multiplier?: number;
  household_size?: string;
  location_type?: string;
  location_id?: string;
  max_age?: number;
  max_dependent_count?: number;
  min_age?: number;
  participant_type?: string;
  pay_type?: string;
  qme_treatment?: string;
  version?: number;
  /** Updated datetime in ISO 8601 format with UTC timezone, returned as a string */
  updated_at: string;
}

/**
 * admin.PaginatedEmployers model
 */
export interface AdminPaginatedEmployers {
  data?: AdminEmployer[];
  pagination?: Pagination;
}

/**
 * Modify Brokers assigned to Employers
 */
export interface PatchAdminEmployers {
  /** IDs of Employers */
  employer_ids: string[];
  /** IDs of Brokers to add as assignees */
  broker_ids_to_add?: string[];
  /** IDs of Brokers to remove as assignees */
  broker_ids_to_remove?: string[];
}

/**
 * Review status to set
 */
export type PatchAdminEmployersEmployerIdReviewStatus = typeof PatchAdminEmployersEmployerIdReviewStatus[keyof typeof PatchAdminEmployersEmployerIdReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchAdminEmployersEmployerIdReviewStatus = {
  pending: 'pending',
  approved: 'approved',
  denied: 'denied',
  inactive_duplicate: 'inactive_duplicate',
  inactive_withdrawn: 'inactive_withdrawn',
  inactive_ineligible: 'inactive_ineligible',
  inactive_churned: 'inactive_churned',
} as const;

/**
 * Update employer review status
 */
export interface PatchAdminEmployersEmployerId {
  /** Review status to set */
  review_status: PatchAdminEmployersEmployerIdReviewStatus;
}

/**
 * employers.EmployerAdmin model
 */
export interface EmployersEmployerAdmin {
  /** The employer admin's unique identifier */
  id: string;
  /** The employer admin's first name */
  first_name?: string;
  /** The employer admin's last name */
  last_name?: string;
  /** The employer admin's job title */
  job_title?: string;
  /** The employer admin's email */
  email?: string;
  /** The date this admin last signed in */
  last_signed_in?: string;
}

/**
 * Type of audit to create
 */
export type PostAdminEmployersEmployerIdComplianceAuditsAuditType = typeof PostAdminEmployersEmployerIdComplianceAuditsAuditType[keyof typeof PostAdminEmployersEmployerIdComplianceAuditsAuditType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAdminEmployersEmployerIdComplianceAuditsAuditType = {
  Unit: 'Unit',
  Bangor: 'Bangor',
} as const;

/**
 * Create new compliance audit for an employer
 */
export interface PostAdminEmployersEmployerIdComplianceAudits {
  /** Type of audit to create */
  audit_type: PostAdminEmployersEmployerIdComplianceAuditsAuditType;
}

/**
 * admin.PlaidAccount model
 */
export interface AdminPlaidAccount {
  /**
   * The name of the institution the account is with
   * @nullable
   */
  institution_name: string | null;
  /** The masked account number */
  mask: string;
  /** The name of the account */
  name: string;
  /** The verification status of the account */
  verification_status: string;
  /** The type of error that occurred */
  error_type: string;
  /** The code of the error that occurred */
  error_code: string;
  /** The item ID of the account */
  item_id: string;
}

/**
 * admin.GranularAllowanceConfigList model
 */
export interface AdminGranularAllowanceConfigList {
  /** List of granular allowance configurations */
  data: AdminGranularAllowanceConfig[];
}

/**
 * Current status of the configuration
 */
export type AdminGranularAllowanceConfigStatus = typeof AdminGranularAllowanceConfigStatus[keyof typeof AdminGranularAllowanceConfigStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGranularAllowanceConfigStatus = {
  pending: 'pending',
  generating: 'generating',
  generated: 'generated',
  failed: 'failed',
} as const;

/**
 * admin.GranularAllowanceConfig model
 */
export interface AdminGranularAllowanceConfig {
  /** Granular Allowance Config ID */
  id: string;
  /** Year for the allowance configuration */
  year: number;
  /** Version number for the configuration (auto-incremented) */
  version: number;
  /** State codes that will use delivered (current year) pricing data */
  delivered_data_state_codes: string[];
  /** State codes that will use projected (previous year) pricing data */
  projected_data_state_codes: string[];
  /** Current status of the configuration */
  status: AdminGranularAllowanceConfigStatus;
  /** Whether this configuration is currently active */
  is_active: boolean;
  /** Timestamp when allowance generation started */
  generation_started_at?: string;
  /** Timestamp when allowance generation completed */
  generation_completed_at?: string;
  /** Timestamp when the configuration was created */
  created_at: string;
  /** Timestamp when the configuration was last updated */
  updated_at: string;
}

/**
 * Create a new Granular Allowance Config
 */
export interface PostAdminGranularAllowanceConfigs {
  /** Year for the config */
  year: number;
  /** State codes for delivered data */
  delivered_data_state_codes: string[];
  /** State codes for projected data */
  projected_data_state_codes: string[];
}

/**
 * Update a Granular Allowance Config
 */
export interface PatchAdminGranularAllowanceConfigsId {
  /** State codes for delivered data */
  delivered_data_state_codes?: string[];
  /** State codes for projected data */
  projected_data_state_codes?: string[];
}

/**
 * admin.Partner model
 */
export interface AdminPartner {
  /** Partner ID */
  id: string;
  display_name: string;
  slug: string;
  relationship: AdminPartnerRelationship;
}

export interface AdminPartnerRelationship {
  id: string;
  fee_type: string;
  monthly_commission_per_member: number;
}

/**
 * The method of API connection
 */
export type PayrollProviderConfigApiConnectionMethod = typeof PayrollProviderConfigApiConnectionMethod[keyof typeof PayrollProviderConfigApiConnectionMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollProviderConfigApiConnectionMethod = {
  finch: 'finch',
  merge_dev: 'merge_dev',
  kombo: 'kombo',
  adp: 'adp',
} as const;

/**
 * The name of the shared connection
 */
export type PayrollProviderConfigSharedConnectionName = typeof PayrollProviderConfigSharedConnectionName[keyof typeof PayrollProviderConfigSharedConnectionName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollProviderConfigSharedConnectionName = {
  newtek: 'newtek',
} as const;

/**
 * PayrollProviderConfig model
 */
export interface PayrollProviderConfig {
  /** Payroll Provider ID */
  id: string;
  /** The name of the payroll provider */
  name: string;
  /** The method of API connection */
  api_connection_method: PayrollProviderConfigApiConnectionMethod;
  /** The API method's remote ID for the payroll provider */
  api_connection_remote_id: string;
  /** The name of the shared connection */
  shared_connection_name?: PayrollProviderConfigSharedConnectionName;
  /** The image URL for the payroll provider logo */
  logo_image_url: string;
  /** The image URL for the payroll provider icon */
  icon_image_url: string;
  /** Whether the payroll provider is one of the promoted providers in the employer onboarding process */
  promoted_in_onboarding?: boolean;
  /** Whether the payroll provider is enabled */
  enabled?: boolean;
  /** Whether Thatch supports automatic deductions for this payroll provider */
  supports_automatic_deductions?: boolean;
  /** Whether Thatch supports automatic roster sync for this payroll provider */
  supports_automatic_roster_sync?: boolean;
  /** The Finch authentication methods supported by this provider */
  finch_authentication_methods?: string[];
  /** The Finch authentication methods that support deductions for this provider */
  finch_deduction_authentication_methods?: string[];
}

/**
 * Update the payroll provider config
 */
export interface PutAdminPayrollProviderConfigsId {
  /** Whether the payroll provider config is enabled */
  enabled?: boolean;
  /** Whether the payroll provider config is promoted in the onboarding process */
  promoted_in_onboarding?: boolean;
  /** Whether the payroll provider supports automatic deductions */
  supports_automatic_deductions?: boolean;
}

/**
 * admin.PaginatedLedgerAccounts model
 */
export interface AdminPaginatedLedgerAccounts {
  data?: AdminLedgerAccount[];
  pagination?: Pagination;
}

export type AdminLedgerAccountMetadata = { [key: string]: unknown };

export interface AdminLedgerAccount {
  id?: string;
  account_type?: string;
  balance?: number;
  path?: string;
  owner_id?: string;
  metadata?: AdminLedgerAccountMetadata;
  created_at?: string;
  updated_at?: string;
  entry_sum?: number;
}

/**
 * admin.PaginatedLedgerEntries model
 */
export interface AdminPaginatedLedgerEntries {
  data?: AdminLedgerEntry[];
  pagination?: Pagination;
}

export type AdminLedgerEntryMetadata = { [key: string]: unknown };

export interface AdminLedgerEntry {
  id?: string;
  amount?: number;
  description?: string;
  idempotency_key?: string;
  metadata?: AdminLedgerEntryMetadata;
  source_type?: string;
  source_id?: string;
  ledger_account_id?: string;
  created_at?: string;
  updated_at?: string;
  ledger_account_path?: string;
}

/**
 * admin.MedicalPlanData.StateIngestionStatusList model
 */
export interface AdminMedicalPlanDataStateIngestionStatusList {
  states?: AdminMedicalPlanDataStateIngestionStatus[];
}

export interface AdminMedicalPlanDataStateIngestionStatus {
  /** Full state name */
  name: string;
  /** State abbreviation */
  abbreviation: string;
  /** Last date when medical plan data was ingested for this state */
  last_ingestion_date?: string;
  /** Whether the S3 file containing plan data is available */
  s3_file_available?: boolean;
  /** Last modified date of the S3 file containing plan data */
  s3_file_last_modified?: string;
  /** Whether this state needs medical plan data ingestion */
  needs_ingestion: boolean;
  /** Whether the medical plan data for this state is up to date */
  is_up_to_date: boolean;
}

export type PostAdminMedicalPlanDataRefreshStateStatusReportStatesItem = typeof PostAdminMedicalPlanDataRefreshStateStatusReportStatesItem[keyof typeof PostAdminMedicalPlanDataRefreshStateStatusReportStatesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAdminMedicalPlanDataRefreshStateStatusReportStatesItem = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * Refresh ingestion status of medical plan data for selected states
 */
export interface PostAdminMedicalPlanDataRefreshStateStatusReport {
  /** Plan year */
  year: number;
  /** State abbreviations to check */
  states?: PostAdminMedicalPlanDataRefreshStateStatusReportStatesItem[];
  /** Check all states */
  all_states?: boolean;
}

/**
 * Map of state abbreviations and their ingestion status
 */
export type AdminMedicalPlanDataStatusReportData = { [key: string]: unknown };

/**
 * admin.MedicalPlanData.StatusReport model
 */
export interface AdminMedicalPlanDataStatusReport {
  /** Human-readable status message to show to the admin */
  message: string;
  /** Map of state abbreviations and their ingestion status */
  data: AdminMedicalPlanDataStatusReportData;
}

export type PostAdminMedicalPlanDataRunIngestionStatesItem = typeof PostAdminMedicalPlanDataRunIngestionStatesItem[keyof typeof PostAdminMedicalPlanDataRunIngestionStatesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostAdminMedicalPlanDataRunIngestionStatesItem = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * Run medical plan data ingestion jobs
 */
export interface PostAdminMedicalPlanDataRunIngestion {
  /** Plan year */
  year: number;
  /** State abbreviations to ingest */
  states?: PostAdminMedicalPlanDataRunIngestionStatesItem[];
  /** Ingest all states */
  all_states?: boolean;
}

/**
 * Details about the enqueued ingestion job
 */
export type AdminMedicalPlanDataIngestionJobsScheduledData = { [key: string]: unknown };

/**
 * admin.MedicalPlanData.IngestionJobsScheduled model
 */
export interface AdminMedicalPlanDataIngestionJobsScheduled {
  /** Human-readable status message */
  message?: string;
  /** Details about the enqueued ingestion job */
  data: AdminMedicalPlanDataIngestionJobsScheduledData;
}

/**
 * Pagination metadata
 */
export type AdminMedicalPlanIngestionsIngestionJobsListPagination = { [key: string]: unknown };

/**
 * admin.MedicalPlanIngestions.IngestionJobsList model
 */
export interface AdminMedicalPlanIngestionsIngestionJobsList {
  jobs: AdminMedicalPlanIngestionsIngestionJob;
  /** Pagination metadata */
  pagination: AdminMedicalPlanIngestionsIngestionJobsListPagination;
}

export interface AdminMedicalPlanIngestionsIngestionJob {
  /** GoodJob ID */
  job_id: string;
  /** Plan year */
  year: number;
  /** Overall job status */
  status: string;
  /** How the job was triggered */
  trigger_type: string;
  /** Email of user who triggered the job (if manual) */
  triggered_by?: string;
  /** When job started */
  started_at?: string;
  /** When job completed */
  completed_at?: string;
  /** Total number of states in this job */
  total_states: number;
  /** Expected number of states from job arguments */
  expected_states_count?: number;
  /** Number of successful state ingestions */
  succeeded_count: number;
  /** Number of failed state ingestions */
  failed_count: number;
  /** Number of currently processing state ingestions */
  processing_count: number;
  /** Number of pending state ingestions */
  pending_count: number;
  /** Number of cancelled state ingestions */
  cancelled_count: number;
  /** URL to view job in GoodJob dashboard */
  good_job_url?: string;
  /** Individual state ingestion details */
  ingestions: AdminMedicalPlanIngestionsIngestionState[];
}

/**
 * Error details if failed
 */
export type AdminMedicalPlanIngestionsIngestionStateErrorDetails = { [key: string]: unknown };

/**
 * Summary of ingested data
 */
export type AdminMedicalPlanIngestionsIngestionStateDataSummary = { [key: string]: unknown };

/**
 * Metadata about processed files
 */
export type AdminMedicalPlanIngestionsIngestionStateFileMetadata = { [key: string]: unknown };

export interface AdminMedicalPlanIngestionsIngestionState {
  /** PlanDataIngestion ID */
  id: string;
  /** State abbreviation */
  state_code: string;
  /** Full state name */
  state_name: string;
  /** Ingestion status */
  status: string;
  /** When ingestion started */
  started_at?: string;
  /** When ingestion completed */
  completed_at?: string;
  /** Duration in seconds */
  duration_seconds?: number;
  /** Error details if failed */
  error_details?: AdminMedicalPlanIngestionsIngestionStateErrorDetails;
  /** Summary of ingested data */
  data_summary?: AdminMedicalPlanIngestionsIngestionStateDataSummary;
  /** Whether changes were rolled back */
  rolled_back: boolean;
  /** Metadata about processed files */
  file_metadata?: AdminMedicalPlanIngestionsIngestionStateFileMetadata;
}

/**
 * admin.ConsistentDeductionList model
 */
export interface AdminConsistentDeductionList {
  data?: AdminConsistentDeduction[];
}

/**
 * Consistent deduction status
 */
export type AdminConsistentDeductionStatus = typeof AdminConsistentDeductionStatus[keyof typeof AdminConsistentDeductionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminConsistentDeductionStatus = {
  unchanged: 'unchanged',
  created: 'created',
  updated: 'updated',
  corrected: 'corrected',
} as const;

export interface AdminConsistentDeduction {
  /** Consistent deduction ID */
  id: string;
  /** Deduction amount */
  amount: number;
  /** Allowance amount */
  allowance_amount: number;
  /** Total premiums amount */
  total_premiums: number;
  /** Employer contribution amount */
  employer_contribution?: number;
  /** Correction amount */
  correction?: number;
  /** Expected amount for the span */
  expected_span_amount?: number;
  /** Number of pay periods in the span */
  pay_periods_in_span?: number;
  /** Expected year-to-date amount */
  expected_ytd_amount?: number;
  /** Whether the deduction is pretax */
  pretax: boolean;
  /** Consistent deduction status */
  status: AdminConsistentDeductionStatus;
  /** Creation timestamp */
  created_at: string;
  /** Span start date */
  span_start_date?: string;
  /** Span end date */
  span_end_date?: string;
  /** Expected annual amount */
  expected_annual_amount?: number;
  pay_period?: AdminPayPeriod;
  reported_deduction?: string;
  benefit_enrollment?: string;
}

export interface AdminPayPeriod {
  /** Pay period ID */
  id: string;
  /** Pay date */
  pay_date: string;
  /** End date */
  end_date: string;
  /** Pay period status */
  status: string;
  pay_schedule?: AdminPaySchedule;
}

export interface AdminPaySchedule {
  /** Pay schedule ID */
  id: string;
  /** Pay schedule name */
  name: string;
  /** Pay schedule frequency */
  frequency: string;
  /** Start date */
  start_date: string;
}

/**
 * Update employer stripe price ids and sync with Stripe
 */
export interface PutAdminStripePricesEmployerId {
  /** Stripe price IDs */
  stripe_price_ids: string[];
}

/**
 * admin.PaginatedSubstantiations model
 */
export interface AdminPaginatedSubstantiations {
  data?: AdminSubstantiation[];
  pagination?: Pagination;
}

/**
 * Status of the substantiation review
 */
export type AdminSubstantiationReviewStatus = typeof AdminSubstantiationReviewStatus[keyof typeof AdminSubstantiationReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSubstantiationReviewStatus = {
  waiting_for_review: 'waiting_for_review',
  approved: 'approved',
  rejected: 'rejected',
  inactive: 'inactive',
} as const;

/**
 * Medical care requirement type
 */
export type AdminSubstantiationMedicalCare = typeof AdminSubstantiationMedicalCare[keyof typeof AdminSubstantiationMedicalCare];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSubstantiationMedicalCare = {
  receipt: 'receipt',
  recurring_transaction: 'recurring_transaction',
  medical_care_manual: 'medical_care_manual',
  enrollment: 'enrollment',
} as const;

/**
 * Ongoing coverage requirement type
 */
export type AdminSubstantiationOngoingCoverage = typeof AdminSubstantiationOngoingCoverage[keyof typeof AdminSubstantiationOngoingCoverage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSubstantiationOngoingCoverage = {
  substantiated_premium_transaction: 'substantiated_premium_transaction',
  ongoing_coverage_manual: 'ongoing_coverage_manual',
} as const;

export type AdminSubstantiationTransactionType = typeof AdminSubstantiationTransactionType[keyof typeof AdminSubstantiationTransactionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSubstantiationTransactionType = {
  medical: 'medical',
  ancillary: 'ancillary',
  unknown: 'unknown',
  qme: 'qme',
} as const;

/**
 * Payment method used for the transaction
 */
export type AdminSubstantiationPaymentMethod = typeof AdminSubstantiationPaymentMethod[keyof typeof AdminSubstantiationPaymentMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSubstantiationPaymentMethod = {
  unit_card: 'unit_card',
  unit_received_ach: 'unit_received_ach',
  unit_reimbursement: 'unit_reimbursement',
  stripe_card: 'stripe_card',
} as const;

/**
 * admin.Substantiation model
 */
export interface AdminSubstantiation {
  /** Substantiation ID */
  id: string;
  /** Status of the substantiation review */
  review_status: AdminSubstantiationReviewStatus;
  /** Medical care requirement type */
  medical_care?: AdminSubstantiationMedicalCare;
  /** Ongoing coverage requirement type */
  ongoing_coverage?: AdminSubstantiationOngoingCoverage;
  is_health_insurance_premium: boolean;
  is_dental_insurance_premium: boolean;
  is_vision_insurance_premium: boolean;
  is_other_insurance_premium: boolean;
  is_qme: boolean;
  transaction_type: AdminSubstantiationTransactionType;
  amount: BrokersMoney;
  description?: string;
  transaction_date?: string;
  /** Payment method used for the transaction */
  payment_method?: AdminSubstantiationPaymentMethod;
  reviewed_by_id?: string;
  reviewed_by_name?: string;
  has_receipts?: boolean;
  /** Timestamp of when the last receipt was uploaded for this transaction */
  receipt_last_uploaded_at?: string;
  member_id?: string;
  member_name?: string;
  employer_id?: string;
  employer_name?: string;
  review_notes?: string;
  created_at?: string;
  updated_at?: string;
  reviewed_at?: string;
  brokers?: BrokersBroker[];
}

export interface BrokersMoney {
  value?: string;
  currency?: string;
}

/**
 * Modify Substantiation
 */
export interface PatchAdminSubstantiations {
  /** IDs of Substantiations */
  substantiation_ids: string[];
  /** IDs of Brokers to assign as assignees */
  broker_ids_to_add?: string[];
  /** IDs of Brokers to remove as assignees */
  broker_ids_to_remove?: string[];
}

/**
 * Match receipt to a substantiation transaction
 */
export interface PatchAdminSubstantiationsSubstantiationIdMatchReceipt {
  /** Receipt Blob ID */
  blob_id: string;
}

/**
 * admin.PaginatedReimbursements model
 */
export interface AdminPaginatedReimbursements {
  data?: AdminReimbursement[];
  pagination?: Pagination;
}

/**
 * Reimbursement Purpose
 */
export type AdminReimbursementPurpose = typeof AdminReimbursementPurpose[keyof typeof AdminReimbursementPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminReimbursementPurpose = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
  qme: 'qme',
  premium: 'premium',
} as const;

/**
 * State of the reimbursement
 */
export type AdminReimbursementState = typeof AdminReimbursementState[keyof typeof AdminReimbursementState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminReimbursementState = {
  draft: 'draft',
  waiting_for_review: 'waiting_for_review',
  confirmed: 'confirmed',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  canceled: 'canceled',
  rejected: 'rejected',
  returned: 'returned',
} as const;

/**
 * admin.Reimbursement model
 */
export interface AdminReimbursement {
  /** Reimbursement ID */
  id: string;
  /** Reimbursement Purpose */
  purpose: AdminReimbursementPurpose;
  /** State of the reimbursement */
  state: AdminReimbursementState;
  amount?: number;
  reviewed_by_id?: string;
  reviewed_by_name?: string;
  has_receipts?: boolean;
  member_id?: string;
  member_name?: string;
  employer_id?: string;
  employer_name?: string;
  brokers?: BrokersBroker[];
  insurance_enrollment_id?: string;
  member_description?: string;
  created_at?: string;
  updated_at?: string;
}

/**
 * Modify Broker Attention Needed Items
 */
export interface PatchAdminReimbursements {
  /** IDs of Reimbursements */
  reimbursement_ids: string[];
  /** IDs of Brokers to add */
  broker_ids_to_add?: string[];
  /** IDs of Brokers to remove */
  broker_ids_to_remove?: string[];
}

/**
 * admin.PaginatedMedicalPlanProjections model
 */
export interface AdminPaginatedMedicalPlanProjections {
  data?: AdminMedicalPlanProjection[];
  pagination?: Pagination;
}

export interface AdminMedicalPlanProjection {
  /** Medical Plan Projection ID */
  id: string;
  /** Insurance carrier name */
  carrier_name?: string;
  /** Insurance carrier HIOS ID */
  carrier_hios_id?: string;
  /** Year the projection is based on */
  projected_from_year: number;
  /** Projected rate multiplier */
  projected_rate_mult?: number;
  /** State abbreviation */
  state: string;
  created_at?: string;
  updated_at?: string;
}

/**
 * admin.ReplaceProjectionsResponse model
 */
export interface AdminReplaceProjectionsResponse {
  /** Year for which projections were replaced */
  year: number;
  /** Number of projections replaced */
  replaced_count: number;
  /** Number of new projections created */
  created_count: number;
  /** Comma separated warning messages from projection validation */
  warnings?: string[];
  /** Array of warning messages from validation, if any */
  errors?: string[];
}

/**
 * Generate Projected Prices
 */
export interface PostAdminMedicalPlanProjectionsGenerateProjectedPrices {
  /** Year to generate projections for */
  year: number;
}

/**
 * admin.GenerateProjectedPricesResponse model
 */
export interface AdminGenerateProjectedPricesResponse {
  /** Response message indicating the status of the projection generation */
  message: string;
  /** URL for the background job processing the projections */
  job_url: string;
  /** Array of warning messages from validation, if any */
  warnings?: string[];
}

/**
 * admin.IneligibleSpendEmployersList model
 */
export interface AdminIneligibleSpendEmployersList {
  /** List of employers with draft ineligible spend reports */
  employers: AdminIneligibleSpendEmployer[];
  pagination: Pagination;
}

export interface AdminIneligibleSpendEmployer {
  /** Employer ID */
  id: string;
  /** Employer name */
  name: string;
  /** Filename of the draft ineligible spend report attachment */
  draft_report_attachment_filename: string;
  /** Filename of the draft ineligible spend transaction list attachment */
  draft_transaction_list_attachment_filename: string;
}

/**
 * Generate ineligible spend reports for all employers
 */
export interface PostAdminIneligibleSpendReportsGenerateAll {
  /** Year for the report */
  year?: number;
}

/**
 * admin.IneligibleSpendGenerationResponse model
 */
export interface AdminIneligibleSpendGenerationResponse {
  /** Success message describing the generation result */
  message: string;
  /** ID of the employer for which the report was generated */
  employer_id?: string;
  /** Year for which the report was generated */
  year: number;
}

/**
 * Generate ineligible spend report for a specific employer
 */
export interface PostAdminIneligibleSpendReportsEmployerIdGenerate {
  /** Year for the report */
  year?: number;
}

/**
 * admin.IneligibleSpendPublishResponse model
 */
export interface AdminIneligibleSpendPublishResponse {
  /** Success message describing the publish result */
  message: string;
  /** ID of the employer for which the report was published */
  employer_id: string;
  /** List of filenames that were published */
  published_files: string[];
}

/**
 * admin.PaginatedUnmappedPlans model
 */
export interface AdminPaginatedUnmappedPlans {
  data?: AdminUnmappedPlan[];
  pagination?: Pagination;
}

export interface AdminUnmappedPlan {
  /** Ancestor Plan ID */
  ancestor_plan_id: string;
  /** Ancestor Plan HIOS ID */
  ancestor_plan_hios_id: string;
  /** Ancestor Plan Carrier Name */
  ancestor_plan_carrier_name: string;
  /** Ancestor Plan Display Name */
  ancestor_plan_display_name: string;
  /** State */
  state: string;
  /** Number of members enrolled in plan */
  member_count: number;
}

/**
 * admin.PaginatedMappedPlans model
 */
export interface AdminPaginatedMappedPlans {
  data?: AdminMappedPlan[];
  pagination?: Pagination;
}

export interface AdminMappedPlan {
  /** Plan Mapping ID */
  plan_mapping_id?: string;
  /** Whether the plan mapping is active */
  is_active?: boolean;
  /** Ancestor Plan ID */
  ancestor_plan_id: string;
  /** Ancestor Plan HIOS ID */
  ancestor_plan_hios_id: string;
  /** Ancestor Plan Carrier Name */
  ancestor_plan_carrier_name: string;
  /** Ancestor Plan Display Name */
  ancestor_plan_display_name: string;
  /** State */
  state: string;
  /** Number of members enrolled in plan */
  member_count: number;
  /** Ideon Descendant Plan ID */
  ideon_descendant_plan_id?: string;
  /** Ideon Descendant Plan HIOS ID */
  ideon_descendant_plan_hios_id?: string;
  /** Ideon Descendant Plan Carrier Name */
  ideon_descendant_plan_carrier_name?: string;
  /** Ideon Descendant Plan Display Name */
  ideon_descendant_plan_display_name?: string;
  /** Thatch Mapped Plan ID */
  thatch_mapped_plan_id?: string;
  /** Thatch Mapped Plan HIOS ID */
  thatch_mapped_plan_hios_id?: string;
  /** Thatch Mapped Plan Carrier Name */
  thatch_mapped_plan_carrier_name?: string;
  /** Thatch Mapped Plan Display Name */
  thatch_mapped_plan_display_name?: string;
}

/**
 * Errors grouped by error type, with array of row details for each error
 */
export type AdminCsvUploadResultErrors = { [key: string]: unknown };

/**
 * admin.CsvUploadResult model
 */
export interface AdminCsvUploadResult {
  /** Summary message of the upload result */
  message: string;
  /** Errors grouped by error type, with array of row details for each error */
  errors?: AdminCsvUploadResultErrors;
}

/**
 * Toggle plan mapping activation (deactivate or reactivate)
 */
export interface PostAdminPlanMappingsAction {
  /** Plan mapping ID to toggle */
  plan_mapping_id: string;
}

/**
 * admin.SidebarPromoCardList model
 */
export interface AdminSidebarPromoCardList {
  /** List of sidebar promo cards */
  data: AdminSidebarPromoCard[];
}

/**
 * Target audience for the card
 */
export type AdminSidebarPromoCardTargetAudience = typeof AdminSidebarPromoCardTargetAudience[keyof typeof AdminSidebarPromoCardTargetAudience];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSidebarPromoCardTargetAudience = {
  employer: 'employer',
  member: 'member',
  partner: 'partner',
} as const;

/**
 * admin.SidebarPromoCard model
 */
export interface AdminSidebarPromoCard {
  /** Sidebar Promo Card ID */
  id: string;
  /** Card title */
  title: string;
  /** Card content text */
  content: string;
  /** Alt text for the image */
  image_alt: string;
  /** Call-to-action button text */
  cta_text: string;
  /** Call-to-action button link URL */
  cta_href: string;
  /** Target audience for the card */
  target_audience: AdminSidebarPromoCardTargetAudience;
  /** Whether this card is currently active */
  active: boolean;
  /** Expiration date for the card (null if no expiration) */
  expires_at?: string;
  /** URL to the card image */
  image_url?: string;
  /** Timestamp when the card was created */
  created_at: string;
  /** Timestamp when the card was last updated */
  updated_at: string;
}

/**
 * brokers.PaginatedAuditList model
 */
export interface BrokersPaginatedAuditList {
  data?: BrokersAudit[];
  pagination?: Pagination;
}

export interface BrokersAudit {
  id?: string;
  auditable_type?: string;
  auditable_id?: string;
  action?: string;
  audited_changes?: string;
  version?: string;
  comment?: string;
  remote_address?: string;
  request_uuid?: string;
  created_at?: string;
  user?: BrokersAuditUser;
}

export interface BrokersAuditUser {
  id?: string;
  email?: string;
  role_name?: string;
}

/**
 * brokers.PaginatedEmployerList model
 */
export interface BrokersPaginatedEmployerList {
  data?: BrokersEmployer[];
  pagination?: Pagination;
}

/**
 * Status
 */
export type BrokersEmployerStatus = typeof BrokersEmployerStatus[keyof typeof BrokersEmployerStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEmployerStatus = {
  completed: 'completed',
  in_progress: 'in_progress',
} as const;

export interface BrokersEmployer {
  /** Employer ID */
  id: string;
  /** Name */
  name: string;
  /** Location */
  location: string;
  /** Status */
  status: BrokersEmployerStatus;
}

/**
 * brokers.PaginatedEmployeeList model
 */
export interface BrokersPaginatedEmployeeList {
  data?: BrokersEmployee[];
  pagination?: Pagination;
}

/**
 * Employment type
 * @nullable
 */
export type BrokersEmployeeEmploymentType = typeof BrokersEmployeeEmploymentType[keyof typeof BrokersEmployeeEmploymentType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEmployeeEmploymentType = {
  employee: 'employee',
  contractor: 'contractor',
} as const;

/**
 * Pay type
 * @nullable
 */
export type BrokersEmployeePayType = typeof BrokersEmployeePayType[keyof typeof BrokersEmployeePayType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEmployeePayType = {
  yearly: 'yearly',
  monthly: 'monthly',
  semi_monthly: 'semi_monthly',
  bi_weekly: 'bi_weekly',
  weekly: 'weekly',
  hourly: 'hourly',
  salary: 'salary',
  fixed: 'fixed',
} as const;

/**
 * Enrollment status
 */
export type BrokersEmployeeEnrollmentStatus = typeof BrokersEmployeeEnrollmentStatus[keyof typeof BrokersEmployeeEnrollmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEmployeeEnrollmentStatus = {
  cobra: 'cobra',
  terminated: 'terminated',
  termination_scheduled: 'termination_scheduled',
  payroll_deactivated: 'payroll_deactivated',
  not_invited: 'not_invited',
  invited: 'invited',
  in_progress: 'in_progress',
  enrolled: 'enrolled',
  unknown: 'unknown',
} as const;

export interface BrokersEmployee {
  /** Employee ID */
  id: string;
  /** Employee first name */
  first_name: string;
  /** Employee last name */
  last_name: string;
  /** Employee email */
  email: string;
  /**
   * Employment type
   * @nullable
   */
  employment_type: BrokersEmployeeEmploymentType;
  /**
   * Pay type
   * @nullable
   */
  pay_type: BrokersEmployeePayType;
  /**
   * Employment start date
   * @nullable
   */
  start_date: string | null;
  /**
   * Employment end date
   * @nullable
   */
  end_date: string | null;
  /**
   * Last invited at
   * @nullable
   */
  last_invited_at: string | null;
  /** Enrollment status */
  enrollment_status: BrokersEmployeeEnrollmentStatus;
  /**
   * Thatch member ID
   * @nullable
   */
  member_id: string | null;
  /**
   * Employee onboarding link
   * @nullable
   */
  onboard_link: string | null;
  /** Employee onboarding link */
  terminate_link: string;
}

/**
 * Invite employees
 */
export interface PostBrokersEmployersEmployerIdEmployeesInvite {
  /** Employee IDs to invite */
  employee_ids: string[];
  /** The type of enrollment event */
  enrollment_type: string;
  /** The start date of the enrollment window */
  enrollment_window_start_date: string;
  /** The end date of the enrollment window */
  enrollment_window_end_date: string;
  /** The plan year of the enrollment event */
  plan_year: number;
}

/**
 * brokers.EmployerICHRAConfig model
 */
export interface BrokersEmployerICHRAConfig {
  /** Employer ICHRA Config ID */
  id: string;
  /** Employer ID */
  employer_id: string;
  coverage_start_date?: string;
  hide_allowances?: boolean;
  include_dental?: boolean;
  include_vision?: boolean;
  offer_dental_plan_selection?: boolean;
  offer_vision_plan_selection?: boolean;
  plan_year?: number;
}

/**
 * brokers.PaginatedMemberList model
 */
export interface BrokersPaginatedMemberList {
  data?: BrokersBrokerMember[];
  pagination?: Pagination;
}

export interface BrokersBrokerMember {
  /** Member ID */
  id?: string;
  /** Given name */
  given_name?: string;
  /** Family name */
  family_name?: string;
  /** Name */
  name?: string;
  /**
   * Date of birth
   * @nullable
   */
  date_of_birth?: string | null;
  /**
   * Email address
   * @nullable
   */
  email?: string | null;
  /**
   * State abbreviation
   * @nullable
   */
  state?: string | null;
  /** @nullable */
  employer_name?: string | null;
}

/**
 * Employer review status
 * @nullable
 */
export type BrokersBrokerMemberDenormalizedEmployerReviewStatus = typeof BrokersBrokerMemberDenormalizedEmployerReviewStatus[keyof typeof BrokersBrokerMemberDenormalizedEmployerReviewStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersBrokerMemberDenormalizedEmployerReviewStatus = {
  pending: 'pending',
  approved: 'approved',
  denied: 'denied',
  inactive_duplicate: 'inactive_duplicate',
  inactive_withdrawn: 'inactive_withdrawn',
  inactive_ineligible: 'inactive_ineligible',
  inactive_churned: 'inactive_churned',
} as const;

/**
 * brokers.BrokerMemberDenormalized model
 */
export interface BrokersBrokerMemberDenormalized {
  /** Member ID */
  id?: string;
  /** Given name */
  given_name?: string;
  /** Family name */
  family_name?: string;
  /** Name */
  name?: string;
  /**
   * Date of birth
   * @nullable
   */
  date_of_birth?: string | null;
  /**
   * Email address
   * @nullable
   */
  email?: string | null;
  /**
   * State abbreviation
   * @nullable
   */
  state?: string | null;
  /** @nullable */
  employer_name?: string | null;
  /** Legal full name */
  legal_full_name?: string;
  /**
   * Preferred name (if different from given name)
   * @nullable
   */
  preferred_name?: string | null;
  /**
   * Phone number in E.164 format
   * @nullable
   */
  phone_number?: string | null;
  /**
   * Address line 1
   * @nullable
   */
  address_line1?: string | null;
  /**
   * Address line 2
   * @nullable
   */
  address_line2?: string | null;
  /**
   * City
   * @nullable
   */
  city?: string | null;
  /**
   * ZIP code
   * @nullable
   */
  zip?: string | null;
  /**
   * County name
   * @nullable
   */
  county_name?: string | null;
  /** Paperless billing opt-in status */
  paperless_opt_in?: boolean;
  /** Paperless renewal notice opt-in status */
  paperless_renewals_opt_in?: boolean;
  /** @nullable */
  employment_status?: string | null;
  termination_config?: BrokersTerminationConfig;
  /** @nullable */
  employer_id?: string | null;
  /**
   * Employer review status
   * @nullable
   */
  employer_review_status?: BrokersBrokerMemberDenormalizedEmployerReviewStatus;
  /**
   * Whether the member has a VIP employer
   * @nullable
   */
  vip_employer?: boolean | null;
  /** Whether the member has been approved by the unit */
  approved_by_unit?: boolean;
  /** Whether the member needs Unit instruments */
  needs_unit_instruments?: boolean;
  /** Whether the member needs Unit physical card */
  needs_unit_physical_card?: boolean;
  /** @nullable */
  brokerage_id?: string | null;
  /** @nullable */
  brokerage_name?: string | null;
  /**
   * Employee ID
   * @nullable
   */
  employee_id?: string | null;
  /**
   * The employee's personal email address
   * @nullable
   */
  employee_personal_email?: string | null;
  /**
   * The employee's work email address
   * @nullable
   */
  employee_work_email?: string | null;
  /** All ICHRA configs associated with the member */
  ichra_configs?: MemberICHRAConfig[];
  /**
   * All ICHRA configs associated with the member's employer
   * @nullable
   */
  employer_ichra_configs?: BrokersEmployerICHRAConfig[] | null;
  /** The suggested password for use when enrolling a member */
  suggested_password?: string;
  /** All documents associated with the member */
  documents?: BrokersDocument[];
}

export interface BrokersTerminationConfig {
  /** Termination config ID */
  id: string;
  /** Whether the member is eligible for COBRA coverage */
  cobra_eligible: boolean;
  /** Length of COBRA coverage in months */
  cobra_length_in_months: number;
  /** Date when termination becomes effective (ISO 8601 format) */
  effective_date: string;
  /** Monthly employer allowance amount in dollars */
  employer_allowance_amount: string;
  /** Percentage of employer allowance that applies */
  employer_allowance_percentage: number;
  /** Payment status (active, insufficient_funds, account_disconnected, deposit_account_error) */
  payment_status: string;
  /** Post-termination coverage selection (unselected, decline, cobra) */
  post_termination_coverage: string;
  /** Processing status (pending, completed, skipped) */
  processing_status: string;
  /** Qualifying event type (termination, death_of_employee, legal_separation, loss_of_dependent_status) */
  qualifying_event: string;
  /** Timestamp when termination communications were sent (ISO 8601 format) */
  termination_comms_sent_at?: string;
  /** Creation timestamp (ISO 8601 format) */
  created_at: string;
  /** Last update timestamp (ISO 8601 format) */
  updated_at: string;
  /** Monthly COBRA premium amount in dollars */
  monthly_cobra_premium: string;
  /** Date when COBRA coverage starts (ISO 8601 format) */
  cobra_start_date: string;
  /** Date when COBRA coverage ends (ISO 8601 format) */
  cobra_end_date: string;
  /** Date when existing coverage ends (ISO 8601 format) */
  existing_coverage_end_date: string;
  /** Date when COBRA enrollment period ends (ISO 8601 format) */
  enrollment_end_date: string;
}

/**
 * QME treatment of the member
 */
export type MemberICHRAConfigQmeTreatment = typeof MemberICHRAConfigQmeTreatment[keyof typeof MemberICHRAConfigQmeTreatment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberICHRAConfigQmeTreatment = {
  all_allowed: 'all_allowed',
  disabled: 'disabled',
  copay_only: 'copay_only',
} as const;

/**
 * MemberICHRAConfig model
 */
export interface MemberICHRAConfig {
  /** Member ICHRA Config ID */
  id: string;
  /** Date at which consistent balances are effective */
  consistent_balances_effective_at?: string;
  /** Household size */
  household_size?: string;
  /** Whether the member has opted into coverage or not */
  opted_in?: boolean;
  /** Plan year of the ICHRA config */
  plan_year: number;
  /** QME treatment of the member */
  qme_treatment: MemberICHRAConfigQmeTreatment;
  /** Member ID associated with the ICHRA config */
  member_id: string;
  /** Creation datetime in ISO 8601 format with UTC timezone, returned as a string */
  created_at: string;
  /** Updated datetime in ISO 8601 format with UTC timezone, returned as a string */
  updated_at: string;
  /** State Confit ID associated with the ICHRA config */
  state_config_id?: string;
}

/**
 * Type of document (member_upload, thatch_upload, broker_upload, broker_private_upload)
 */
export type BrokersDocumentDocumentType = typeof BrokersDocumentDocumentType[keyof typeof BrokersDocumentDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersDocumentDocumentType = {
  member_upload: 'member_upload',
  thatch_upload: 'thatch_upload',
  broker_upload: 'broker_upload',
  broker_private_upload: 'broker_private_upload',
} as const;

export interface BrokersDocument {
  /** Document ID */
  id: string;
  /** Document filename */
  filename: string;
  /** Document content type */
  content_type: string;
  /** Document size in bytes */
  byte_size: number;
  /** Document creation timestamp */
  created_at: string;
  /** Type of document (member_upload, thatch_upload, broker_upload, broker_private_upload) */
  document_type: BrokersDocumentDocumentType;
  /** Whether the document is visible to the member */
  visible_to_member: boolean;
  /** URL to download the document */
  download_url: string;
  /** URL to view the document inline */
  view_url: string;
}

/**
 * QME treatment status
 * @nullable
 */
export type BrokersICHRADataQmeStatus = typeof BrokersICHRADataQmeStatus[keyof typeof BrokersICHRADataQmeStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersICHRADataQmeStatus = {
  all_allowed: 'all_allowed',
  disabled: 'disabled',
  copay_only: 'copay_only',
} as const;

/**
 * Whether ICHRA is estimated to be affordable
 */
export type BrokersICHRADataIchraAffordable = typeof BrokersICHRADataIchraAffordable[keyof typeof BrokersICHRADataIchraAffordable];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersICHRADataIchraAffordable = {
  Yes: 'Yes',
  No: 'No',
  Unknown: 'Unknown',
} as const;

/**
 * brokers.ICHRAData model
 */
export interface BrokersICHRAData {
  /** Plan year for this ICHRA data */
  plan_year?: number;
  /**
   * Employer's coverage start date
   * @nullable
   */
  employer_coverage_start_date?: string | null;
  /**
   * Employer's name
   * @nullable
   */
  employer_name?: string | null;
  /** ICHRA allowance amounts with dates (formatted as strings) */
  ichra_allowance?: string[];
  /**
   * QME treatment status
   * @nullable
   */
  qme_status?: BrokersICHRADataQmeStatus;
  /** Whether member has HSA-eligible enrollment */
  has_hsa_eligible_enrollment?: boolean;
  household_income?: BrokersMoney;
  /** Whether ICHRA is estimated to be affordable */
  ichra_affordable?: BrokersICHRADataIchraAffordable;
  /**
   * ICHRA deposit account number (if available and authorized)
   * @nullable
   */
  deposit_account_number?: string | null;
  /**
   * ICHRA deposit routing number (if available and authorized)
   * @nullable
   */
  deposit_routing_number?: string | null;
  /** URL to view the ICHRA notice for this member */
  ichra_notice_url?: string;
  /**
   * Notice date
   * @nullable
   */
  notice_date?: string | null;
  /**
   * Coverage start date
   * @nullable
   */
  coverage_start_date?: string | null;
}

/**
 * PaginatedChargeOrTxnList model
 */
export interface PaginatedChargeOrTxnList {
  data?: ChargeOrTxn[];
  pagination?: Pagination;
}

/**
 * How the transaction was paid
 */
export type ChargeOrTxnPaymentMethodCategory = typeof ChargeOrTxnPaymentMethodCategory[keyof typeof ChargeOrTxnPaymentMethodCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChargeOrTxnPaymentMethodCategory = {
  ach: 'ach',
  reimbursement: 'reimbursement',
  stripecard: 'stripecard',
  unitcard: 'unitcard',
  unknown: 'unknown',
} as const;

/**
 * ChargeOrTxn model
 */
export interface ChargeOrTxn {
  /** Transaction ID */
  id: string;
  amount: Money;
  /** Summary of the transaction */
  human_readable_summary: string;
  /** Transaction service date */
  service_date?: string;
  /** Transaction creation date */
  created_at: string;
  /** How the transaction was paid */
  payment_method_category: ChargeOrTxnPaymentMethodCategory;
  /** Link to additional information about this transaction from the third party service being used. */
  external_url?: string;
  /** Link to additional information about this transaction's source from the third party service being used. */
  external_source_url?: string;
  /** Last 4 digits of the external source's account number */
  external_source_last_4?: string;
  loss_amount?: Money;
  /** ID of the received payment for this transaction */
  received_payment_id?: string;
  /** State of the received payment for this transaction */
  received_payment_state?: string;
  /** Stage of the JIT ACH transaction */
  jit_ach_stage?: string;
  /** ID of the original transaction that was refunded */
  refund_original_transaction_id?: string;
  substantiation?: Substantiation;
}

/**
 * Status of the substantiation review
 */
export type SubstantiationReviewStatus = typeof SubstantiationReviewStatus[keyof typeof SubstantiationReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubstantiationReviewStatus = {
  waiting_for_review: 'waiting_for_review',
  approved: 'approved',
  rejected: 'rejected',
  inactive: 'inactive',
} as const;

export interface Substantiation {
  /** Substantiation ID */
  id: string;
  /** Status of the substantiation review */
  review_status: SubstantiationReviewStatus;
}

/**
 * Update transaction
 */
export interface PatchBrokersMembersMemberIdTransactionsId {
  /** Enrollment ID to map this transaction to. When 'none', it unmaps the transaction. When 'missing', it marks the transaction as missing an enrollment. */
  enrollment_id: string;
}

/**
 * Mark transaction as loss
 */
export interface PostBrokersMembersMemberIdTransactionsIdMarkLoss {
  /** Loss amount */
  loss_amount: string;
}

/**
 * PaginatedEnrollmentList model
 */
export interface PaginatedEnrollmentList {
  data?: BrokersEnrollment[];
  pagination?: Pagination;
}

/**
 * Enrollment Category
 */
export type BrokersEnrollmentCategory = typeof BrokersEnrollmentCategory[keyof typeof BrokersEnrollmentCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentCategory = {
  general_medical: 'general_medical',
  guardian_dental: 'guardian_dental',
  renaissance_dental: 'renaissance_dental',
  bsca_dental: 'bsca_dental',
  vsp: 'vsp',
  bsca_vision: 'bsca_vision',
  medicare: 'medicare',
  medicare_part_a: 'medicare_part_a',
  medicare_part_b: 'medicare_part_b',
  medicare_part_c: 'medicare_part_c',
  medicare_part_d: 'medicare_part_d',
  medicare_supplement: 'medicare_supplement',
  off_thatch_medical: 'off_thatch_medical',
  subsidy: 'subsidy',
  off_thatch_dental: 'off_thatch_dental',
  off_thatch_vision: 'off_thatch_vision',
  cobra: 'cobra',
  renewal: 'renewal',
} as const;

/**
 * Quoted Premium
 */
export type BrokersEnrollmentQuotedPremium = { [key: string]: unknown };

/**
 * Max Premium Reimbursement Amount
 */
export type BrokersEnrollmentMaxPremiumReimbursementAmount = { [key: string]: unknown };

/**
 * Status
 */
export type BrokersEnrollmentState = typeof BrokersEnrollmentState[keyof typeof BrokersEnrollmentState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentState = {
  in_member_cart: 'in_member_cart',
  member_confirmed: 'member_confirmed',
  submission_processing: 'submission_processing',
  carrier_processing: 'carrier_processing',
  completed: 'completed',
  canceled: 'canceled',
} as const;

/**
 * Coverage Type
 */
export type BrokersEnrollmentCoverageType = typeof BrokersEnrollmentCoverageType[keyof typeof BrokersEnrollmentCoverageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentCoverageType = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
} as const;

export type BrokersEnrollmentAvailableActionsItem = typeof BrokersEnrollmentAvailableActionsItem[keyof typeof BrokersEnrollmentAvailableActionsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentAvailableActionsItem = {
  member_cancel: 'member_cancel',
  member_confirm: 'member_confirm',
  member_self_serve_complete: 'member_self_serve_complete',
  mark_submitted: 'mark_submitted',
  begin_submission_processing: 'begin_submission_processing',
  return_to_submission_processing: 'return_to_submission_processing',
  broker_cancel: 'broker_cancel',
  complete: 'complete',
  reinstate: 'reinstate',
  dangerous_move_back_to_member_confirmed: 'dangerous_move_back_to_member_confirmed',
} as const;

/**
 * brokers.Enrollment model
 */
export interface BrokersEnrollment {
  /** Enrollment ID */
  id: string;
  /** Enrollment Category */
  category: BrokersEnrollmentCategory;
  /** Plan Code */
  plan_code: string;
  /** Off Exchange */
  off_exchange: boolean;
  /** Quoted Premium */
  quoted_premium: BrokersEnrollmentQuotedPremium;
  /** Max Premium Reimbursement Amount */
  max_premium_reimbursement_amount?: BrokersEnrollmentMaxPremiumReimbursementAmount;
  /** Status */
  state: BrokersEnrollmentState;
  /** Submission Method */
  submission_method: string;
  /** Autopay State */
  autopay_state: string;
  /** Expected payment date offset for this enrollment. */
  expected_payment_date_offset?: number;
  /** Ancestor Enrollment ID */
  ancestor_enrollment_id?: string;
  /** Exchange Policy ID */
  exchange_policy_id?: string;
  /** Assignee ID */
  assignee_id: string;
  submitting_brokerage_id?: string;
  brokerage_of_record_id?: string;
  /** Covers Medical */
  covers_medical: boolean;
  /** Covers Dental */
  covers_dental: boolean;
  /** Covers Vision */
  covers_vision: boolean;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  /** Reimbursement Only At */
  reimbursement_only_at?: string;
  /** Member Confirmed At */
  member_confirmed_at?: string;
  /** Member ICHRA Config ID */
  member_ichra_config_id: string;
  /** Carrier Member ID */
  carrier_member_id?: string;
  /** Coverage Type */
  coverage_type: BrokersEnrollmentCoverageType;
  /** Submission Processing At */
  submission_processing_at?: string;
  /** Enrollment Event ID */
  enrollment_event_id?: string;
  /** Available AASM state transition actions for current enrollment state */
  available_actions?: BrokersEnrollmentAvailableActionsItem[];
}

/**
 * Reason for this coverage change
 */
export type PostBrokersMembersMemberIdEnrollmentsCoverageAuditReason = typeof PostBrokersMembersMemberIdEnrollmentsCoverageAuditReason[keyof typeof PostBrokersMembersMemberIdEnrollmentsCoverageAuditReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostBrokersMembersMemberIdEnrollmentsCoverageAuditReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
} as const;

/**
 * Create member enrollment
 */
export interface PostBrokersMembersMemberIdEnrollments {
  /** Reason for this coverage change */
  coverage_audit_reason?: PostBrokersMembersMemberIdEnrollmentsCoverageAuditReason;
  /** Plan year */
  plan_year: number;
  /** Enrollment category */
  category: string;
  /** Plan code */
  plan_code: string;
  /** Quoted premium amount */
  quoted_premium: string;
  /** Exchange status (off_exchange or on_exchange) */
  exchange_status?: string;
  /** Max premium reimbursement amount */
  max_premium_reimbursement_amount?: string;
}

/**
 * Enrollment Category
 */
export type BrokersEnrollmentWithPaymentsOrCoveragesCategory = typeof BrokersEnrollmentWithPaymentsOrCoveragesCategory[keyof typeof BrokersEnrollmentWithPaymentsOrCoveragesCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentWithPaymentsOrCoveragesCategory = {
  general_medical: 'general_medical',
  guardian_dental: 'guardian_dental',
  renaissance_dental: 'renaissance_dental',
  bsca_dental: 'bsca_dental',
  vsp: 'vsp',
  bsca_vision: 'bsca_vision',
  medicare: 'medicare',
  medicare_part_a: 'medicare_part_a',
  medicare_part_b: 'medicare_part_b',
  medicare_part_c: 'medicare_part_c',
  medicare_part_d: 'medicare_part_d',
  medicare_supplement: 'medicare_supplement',
  off_thatch_medical: 'off_thatch_medical',
  subsidy: 'subsidy',
  off_thatch_dental: 'off_thatch_dental',
  off_thatch_vision: 'off_thatch_vision',
  cobra: 'cobra',
  renewal: 'renewal',
} as const;

/**
 * Quoted Premium
 */
export type BrokersEnrollmentWithPaymentsOrCoveragesQuotedPremium = { [key: string]: unknown };

/**
 * Max Premium Reimbursement Amount
 */
export type BrokersEnrollmentWithPaymentsOrCoveragesMaxPremiumReimbursementAmount = { [key: string]: unknown };

/**
 * Status
 */
export type BrokersEnrollmentWithPaymentsOrCoveragesState = typeof BrokersEnrollmentWithPaymentsOrCoveragesState[keyof typeof BrokersEnrollmentWithPaymentsOrCoveragesState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentWithPaymentsOrCoveragesState = {
  in_member_cart: 'in_member_cart',
  member_confirmed: 'member_confirmed',
  submission_processing: 'submission_processing',
  carrier_processing: 'carrier_processing',
  completed: 'completed',
  canceled: 'canceled',
} as const;

export type BrokersEnrollmentWithPaymentsOrCoveragesAvailableActionsItem = typeof BrokersEnrollmentWithPaymentsOrCoveragesAvailableActionsItem[keyof typeof BrokersEnrollmentWithPaymentsOrCoveragesAvailableActionsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentWithPaymentsOrCoveragesAvailableActionsItem = {
  member_cancel: 'member_cancel',
  member_confirm: 'member_confirm',
  member_self_serve_complete: 'member_self_serve_complete',
  mark_submitted: 'mark_submitted',
  begin_submission_processing: 'begin_submission_processing',
  return_to_submission_processing: 'return_to_submission_processing',
  broker_cancel: 'broker_cancel',
  complete: 'complete',
  reinstate: 'reinstate',
  dangerous_move_back_to_member_confirmed: 'dangerous_move_back_to_member_confirmed',
} as const;

/**
 * brokers.EnrollmentWithPaymentsOrCoverages model
 */
export interface BrokersEnrollmentWithPaymentsOrCoverages {
  /** Enrollment ID */
  id: string;
  /** Enrollment Category */
  category: BrokersEnrollmentWithPaymentsOrCoveragesCategory;
  /** Plan Code */
  plan_code: string;
  /** Off Exchange */
  off_exchange: boolean;
  /** Quoted Premium */
  quoted_premium: BrokersEnrollmentWithPaymentsOrCoveragesQuotedPremium;
  /** Max Premium Reimbursement Amount */
  max_premium_reimbursement_amount?: BrokersEnrollmentWithPaymentsOrCoveragesMaxPremiumReimbursementAmount;
  /** Status */
  state: BrokersEnrollmentWithPaymentsOrCoveragesState;
  /** Submission Method */
  submission_method: string;
  /** Autopay State */
  autopay_state: string;
  /** Expected payment date offset for this enrollment. */
  expected_payment_date_offset?: number;
  /** Ancestor Enrollment ID */
  ancestor_enrollment_id?: string;
  /** Exchange Policy ID */
  exchange_policy_id?: string;
  /** Assignee ID */
  assignee_id: string;
  submitting_brokerage_id?: string;
  brokerage_of_record_id?: string;
  /** Covers Medical */
  covers_medical: boolean;
  /** Covers Dental */
  covers_dental: boolean;
  /** Covers Vision */
  covers_vision: boolean;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  /** Reimbursement Only At */
  reimbursement_only_at?: string;
  /** Member Confirmed At */
  member_confirmed_at?: string;
  /** Member ICHRA Config ID */
  member_ichra_config_id: string;
  /** Carrier Member ID */
  carrier_member_id?: string;
  coverage_type?: string;
  /** Submission Processing At */
  submission_processing_at?: string;
  /** Enrollment Event ID */
  enrollment_event_id?: string;
  /** Available AASM state transition actions for current enrollment state */
  available_actions?: BrokersEnrollmentWithPaymentsOrCoveragesAvailableActionsItem[];
  /** Carrier Name */
  carrier_name: string;
  plan_name?: string;
  has_coverage?: boolean;
  plan_year: number;
  /** Title */
  title: string;
  payment_standing: BrokersPaymentStanding;
  loss_amount: BrokersMoney;
  declare_losses_at_transaction_level: boolean;
  coverage_start_date?: string;
  coverage_end_date?: string;
  coverage_start_date_month?: number;
  cost_of_coverage?: BrokersMoney;
  enrollment_payments_total: BrokersMoney;
  max_reimbursable_amount?: BrokersMoney;
  /** The expected monthly cost for this enrollment's premiums */
  monthly_premium?: string;
}

export interface BrokersPaymentStanding {
  possible_payment_amounts: BrokersPaymentAmountOption[];
  paid_amount: BrokersMoney;
  paid_through_month: string;
  status_text?: string;
}

export interface BrokersPaymentAmountOption {
  amount: string;
  month: number;
}

/**
 * Enrollment Category
 */
export type BrokersEnrollmentMappingOptionCategory = typeof BrokersEnrollmentMappingOptionCategory[keyof typeof BrokersEnrollmentMappingOptionCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentMappingOptionCategory = {
  general_medical: 'general_medical',
  guardian_dental: 'guardian_dental',
  renaissance_dental: 'renaissance_dental',
  bsca_dental: 'bsca_dental',
  vsp: 'vsp',
  bsca_vision: 'bsca_vision',
  medicare: 'medicare',
  medicare_part_a: 'medicare_part_a',
  medicare_part_b: 'medicare_part_b',
  medicare_part_c: 'medicare_part_c',
  medicare_part_d: 'medicare_part_d',
  medicare_supplement: 'medicare_supplement',
  off_thatch_medical: 'off_thatch_medical',
  subsidy: 'subsidy',
  off_thatch_dental: 'off_thatch_dental',
  off_thatch_vision: 'off_thatch_vision',
  cobra: 'cobra',
  renewal: 'renewal',
} as const;

/**
 * Quoted Premium
 */
export type BrokersEnrollmentMappingOptionQuotedPremium = { [key: string]: unknown };

/**
 * Max Premium Reimbursement Amount
 */
export type BrokersEnrollmentMappingOptionMaxPremiumReimbursementAmount = { [key: string]: unknown };

/**
 * Status
 */
export type BrokersEnrollmentMappingOptionState = typeof BrokersEnrollmentMappingOptionState[keyof typeof BrokersEnrollmentMappingOptionState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentMappingOptionState = {
  in_member_cart: 'in_member_cart',
  member_confirmed: 'member_confirmed',
  submission_processing: 'submission_processing',
  carrier_processing: 'carrier_processing',
  completed: 'completed',
  canceled: 'canceled',
} as const;

export type BrokersEnrollmentMappingOptionAvailableActionsItem = typeof BrokersEnrollmentMappingOptionAvailableActionsItem[keyof typeof BrokersEnrollmentMappingOptionAvailableActionsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentMappingOptionAvailableActionsItem = {
  member_cancel: 'member_cancel',
  member_confirm: 'member_confirm',
  member_self_serve_complete: 'member_self_serve_complete',
  mark_submitted: 'mark_submitted',
  begin_submission_processing: 'begin_submission_processing',
  return_to_submission_processing: 'return_to_submission_processing',
  broker_cancel: 'broker_cancel',
  complete: 'complete',
  reinstate: 'reinstate',
  dangerous_move_back_to_member_confirmed: 'dangerous_move_back_to_member_confirmed',
} as const;

/**
 * brokers.EnrollmentMappingOption model
 */
export interface BrokersEnrollmentMappingOption {
  /** Enrollment ID */
  id: string;
  /** Enrollment Category */
  category: BrokersEnrollmentMappingOptionCategory;
  /** Plan Code */
  plan_code: string;
  /** Off Exchange */
  off_exchange: boolean;
  /** Quoted Premium */
  quoted_premium: BrokersEnrollmentMappingOptionQuotedPremium;
  /** Max Premium Reimbursement Amount */
  max_premium_reimbursement_amount?: BrokersEnrollmentMappingOptionMaxPremiumReimbursementAmount;
  /** Status */
  state: BrokersEnrollmentMappingOptionState;
  /** Submission Method */
  submission_method: string;
  /** Autopay State */
  autopay_state: string;
  /** Expected payment date offset for this enrollment. */
  expected_payment_date_offset?: number;
  /** Ancestor Enrollment ID */
  ancestor_enrollment_id?: string;
  /** Exchange Policy ID */
  exchange_policy_id?: string;
  /** Assignee ID */
  assignee_id: string;
  submitting_brokerage_id?: string;
  brokerage_of_record_id?: string;
  /** Covers Medical */
  covers_medical: boolean;
  /** Covers Dental */
  covers_dental: boolean;
  /** Covers Vision */
  covers_vision: boolean;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  /** Reimbursement Only At */
  reimbursement_only_at?: string;
  /** Member Confirmed At */
  member_confirmed_at?: string;
  /** Member ICHRA Config ID */
  member_ichra_config_id: string;
  /** Carrier Member ID */
  carrier_member_id?: string;
  coverage_type?: string;
  /** Submission Processing At */
  submission_processing_at?: string;
  /** Enrollment Event ID */
  enrollment_event_id?: string;
  /** Available AASM state transition actions for current enrollment state */
  available_actions?: BrokersEnrollmentMappingOptionAvailableActionsItem[];
  /** Carrier Name */
  carrier_name: string;
  plan_name?: string;
  has_coverage?: boolean;
  plan_year: number;
  /** Title */
  title: string;
}

/**
 * Monthly cost breakdown with month numbers as keys and Money entities as values
 */
export type BrokersMonthlyCostOfCoverageMonthlyCosts = { [key: string]: unknown };

/**
 * brokers.MonthlyCostOfCoverage model
 */
export interface BrokersMonthlyCostOfCoverage {
  /** Plan year for the cost calculations */
  plan_year: number;
  /** Monthly cost breakdown with month numbers as keys and Money entities as values */
  monthly_costs: BrokersMonthlyCostOfCoverageMonthlyCosts;
  total_cost: BrokersMoney;
}

/**
 * Reason for this coverage change
 */
export type PutBrokersMembersMemberIdEnrollmentsIdCoverageAuditReason = typeof PutBrokersMembersMemberIdEnrollmentsIdCoverageAuditReason[keyof typeof PutBrokersMembersMemberIdEnrollmentsIdCoverageAuditReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutBrokersMembersMemberIdEnrollmentsIdCoverageAuditReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
} as const;

/**
 * State transition action to perform
 */
export type PutBrokersMembersMemberIdEnrollmentsIdStateAction = typeof PutBrokersMembersMemberIdEnrollmentsIdStateAction[keyof typeof PutBrokersMembersMemberIdEnrollmentsIdStateAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutBrokersMembersMemberIdEnrollmentsIdStateAction = {
  member_cancel: 'member_cancel',
  member_confirm: 'member_confirm',
  member_self_serve_complete: 'member_self_serve_complete',
  mark_submitted: 'mark_submitted',
  begin_submission_processing: 'begin_submission_processing',
  return_to_submission_processing: 'return_to_submission_processing',
  broker_cancel: 'broker_cancel',
  complete: 'complete',
  reinstate: 'reinstate',
  dangerous_move_back_to_member_confirmed: 'dangerous_move_back_to_member_confirmed',
} as const;

/**
 * Update one or more enrollment fields.
 */
export interface PutBrokersMembersMemberIdEnrollmentsId {
  /** Reason for this coverage change */
  coverage_audit_reason?: PutBrokersMembersMemberIdEnrollmentsIdCoverageAuditReason;
  /** Plan Code */
  plan_code?: string;
  /** Off Exchange */
  off_exchange?: boolean;
  /** Quoted Premium */
  quoted_premium?: string;
  /** Submission Method */
  submission_method?: string;
  /** Autopay State */
  autopay_state?: string;
  /** Ancestor Enrollment ID */
  ancestor_enrollment_id?: string;
  /** Exchange Policy ID */
  exchange_policy_id?: string;
  /** Max Premium Reimbursement Amount */
  max_premium_reimbursement_amount?: string;
  /** Category */
  category?: string;
  /** Category */
  expected_payment_date_offset?: string;
  /** Stripe Issuing Card ID */
  payment_method_id?: string;
  /** Submitting Brokerage ID */
  submitting_brokerage_id?: string;
  /** Brokerage of Record ID */
  brokerage_of_record_id?: string;
  /** Carrier Member ID */
  carrier_member_id?: string;
  /** Reimbursement Only At */
  reimbursement_only_at?: string;
  /** Enrollment Event ID */
  enrollment_event_id?: string;
  /** State transition action to perform */
  state_action?: PutBrokersMembersMemberIdEnrollmentsIdStateAction;
}

/**
 * Enrollment Category
 */
export type BrokersEnrollmentEnrichedCategory = typeof BrokersEnrollmentEnrichedCategory[keyof typeof BrokersEnrollmentEnrichedCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentEnrichedCategory = {
  general_medical: 'general_medical',
  guardian_dental: 'guardian_dental',
  renaissance_dental: 'renaissance_dental',
  bsca_dental: 'bsca_dental',
  vsp: 'vsp',
  bsca_vision: 'bsca_vision',
  medicare: 'medicare',
  medicare_part_a: 'medicare_part_a',
  medicare_part_b: 'medicare_part_b',
  medicare_part_c: 'medicare_part_c',
  medicare_part_d: 'medicare_part_d',
  medicare_supplement: 'medicare_supplement',
  off_thatch_medical: 'off_thatch_medical',
  subsidy: 'subsidy',
  off_thatch_dental: 'off_thatch_dental',
  off_thatch_vision: 'off_thatch_vision',
  cobra: 'cobra',
  renewal: 'renewal',
} as const;

/**
 * Quoted Premium
 */
export type BrokersEnrollmentEnrichedQuotedPremium = { [key: string]: unknown };

/**
 * Max Premium Reimbursement Amount
 */
export type BrokersEnrollmentEnrichedMaxPremiumReimbursementAmount = { [key: string]: unknown };

/**
 * Status
 */
export type BrokersEnrollmentEnrichedState = typeof BrokersEnrollmentEnrichedState[keyof typeof BrokersEnrollmentEnrichedState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentEnrichedState = {
  in_member_cart: 'in_member_cart',
  member_confirmed: 'member_confirmed',
  submission_processing: 'submission_processing',
  carrier_processing: 'carrier_processing',
  completed: 'completed',
  canceled: 'canceled',
} as const;

/**
 * Coverage Type
 */
export type BrokersEnrollmentEnrichedCoverageType = typeof BrokersEnrollmentEnrichedCoverageType[keyof typeof BrokersEnrollmentEnrichedCoverageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentEnrichedCoverageType = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
} as const;

export type BrokersEnrollmentEnrichedAvailableActionsItem = typeof BrokersEnrollmentEnrichedAvailableActionsItem[keyof typeof BrokersEnrollmentEnrichedAvailableActionsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentEnrichedAvailableActionsItem = {
  member_cancel: 'member_cancel',
  member_confirm: 'member_confirm',
  member_self_serve_complete: 'member_self_serve_complete',
  mark_submitted: 'mark_submitted',
  begin_submission_processing: 'begin_submission_processing',
  return_to_submission_processing: 'return_to_submission_processing',
  broker_cancel: 'broker_cancel',
  complete: 'complete',
  reinstate: 'reinstate',
  dangerous_move_back_to_member_confirmed: 'dangerous_move_back_to_member_confirmed',
} as const;

export type BrokersEnrollmentEnrichedPaymentStanding = { [key: string]: unknown };

/**
 * brokers.EnrollmentEnriched model
 */
export interface BrokersEnrollmentEnriched {
  /** Enrollment ID */
  id: string;
  /** Enrollment Category */
  category: BrokersEnrollmentEnrichedCategory;
  /** Plan Code */
  plan_code: string;
  /** Off Exchange */
  off_exchange: boolean;
  /** Quoted Premium */
  quoted_premium: BrokersEnrollmentEnrichedQuotedPremium;
  /** Max Premium Reimbursement Amount */
  max_premium_reimbursement_amount?: BrokersEnrollmentEnrichedMaxPremiumReimbursementAmount;
  /** Status */
  state: BrokersEnrollmentEnrichedState;
  /** Submission Method */
  submission_method: string;
  /** Autopay State */
  autopay_state: string;
  /** Expected payment date offset for this enrollment. */
  expected_payment_date_offset?: number;
  /** Ancestor Enrollment ID */
  ancestor_enrollment_id?: string;
  /** Exchange Policy ID */
  exchange_policy_id?: string;
  /** Assignee ID */
  assignee_id: string;
  submitting_brokerage_id?: string;
  brokerage_of_record_id?: string;
  /** Covers Medical */
  covers_medical: boolean;
  /** Covers Dental */
  covers_dental: boolean;
  /** Covers Vision */
  covers_vision: boolean;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  /** Reimbursement Only At */
  reimbursement_only_at?: string;
  /** Member Confirmed At */
  member_confirmed_at?: string;
  /** Member ICHRA Config ID */
  member_ichra_config_id: string;
  /** Carrier Member ID */
  carrier_member_id?: string;
  /** Coverage Type */
  coverage_type: BrokersEnrollmentEnrichedCoverageType;
  /** Submission Processing At */
  submission_processing_at?: string;
  /** Enrollment Event ID */
  enrollment_event_id?: string;
  /** Available AASM state transition actions for current enrollment state */
  available_actions?: BrokersEnrollmentEnrichedAvailableActionsItem[];
  /** Assignee Name */
  assignee_name: string;
  /** Member ID */
  member_id: string;
  /** Name */
  formatted_member_name: string;
  /** Plan Category */
  coverage: string;
  /** Carrier Name */
  carrier_name: string;
  /** State */
  plan_state: string;
  /** Employer Name */
  employer_name: string;
  /** Employer Approval Status */
  employer_approved?: string;
  /** Coverage Start Date */
  coverage_start_date: string;
  /** Status */
  status: string;
  /** EnrollmentStatus */
  merged_status: string;
  /** Tasks */
  tasks?: BrokersTask[];
  /** Title */
  title: string;
  display_premium?: BrokersMoney;
  reimbursement_only?: boolean;
  payment_standing?: BrokersEnrollmentEnrichedPaymentStanding;
  enrollment_event_type?: string;
  enrollment_event_subtype?: string;
  plan_hsa_eligible?: boolean;
  payment_method_id?: string;
  payment_method_type?: string;
  payment_method_url?: string;
  sbc_url?: string;
  hios_id?: string;
  /** Whether the member's employer is onboarding to Bangor */
  is_bangor_employer?: boolean;
  /** Whether this enrollment needs ACH payment via VBAN (Bangor employer + ACH-required carrier/state) */
  needs_ach_vban?: boolean;
  /** Whether the employer has a Treasury Prime/Bangor account created */
  employer_has_bangor_account?: boolean;
  /** Whether this enrollment has a VBAN configured */
  has_vban?: boolean;
  /** Masked VBAN account number for display */
  vban_masked_account_number?: string;
  /** Masked VBAN routing number for display */
  vban_masked_routing_number?: string;
}

/**
 * Task status
 */
export type BrokersTaskStatus = typeof BrokersTaskStatus[keyof typeof BrokersTaskStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskStatus = {
  pending: 'pending',
  processing: 'processing',
  blocked: 'blocked',
  completed: 'completed',
  canceled: 'canceled',
  excluded: 'excluded',
  failed: 'failed',
} as const;

/**
 * How the task should be executed
 */
export type BrokersTaskExecutionMethod = typeof BrokersTaskExecutionMethod[keyof typeof BrokersTaskExecutionMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskExecutionMethod = {
  automated: 'automated',
  manual: 'manual',
} as const;

/**
 * Where the task should be executed
 */
export type BrokersTaskExecutionContext = typeof BrokersTaskExecutionContext[keyof typeof BrokersTaskExecutionContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskExecutionContext = {
  thatch: 'thatch',
  member: 'member',
} as const;

/**
 * Task-specific metadata
 */
export type BrokersTaskTaskMetadata = { [key: string]: unknown };

export type BrokersTaskCategoriesItem = typeof BrokersTaskCategoriesItem[keyof typeof BrokersTaskCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskCategoriesItem = {
  submission: 'submission',
  payment: 'payment',
  autopay: 'autopay',
} as const;

/**
 * Category of blocker (e.g., 'general_agent', 'member', 'carrier')
 */
export type BrokersTaskBlockedReason = typeof BrokersTaskBlockedReason[keyof typeof BrokersTaskBlockedReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskBlockedReason = {
  general_agent: 'general_agent',
  member: 'member',
  carrier: 'carrier',
  missing_info: 'missing_info',
  incident: 'incident',
  other: 'other',
} as const;

export type BrokersTaskAvailableActionsItem = typeof BrokersTaskAvailableActionsItem[keyof typeof BrokersTaskAvailableActionsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskAvailableActionsItem = {
  cancel: 'cancel',
  uncancel: 'uncancel',
  exclude: 'exclude',
  reinclude: 'reinclude',
  complete: 'complete',
  process: 'process',
  fail: 'fail',
  block: 'block',
  unblock: 'unblock',
  retry: 'retry',
  rollback: 'rollback',
  dangerous_return_to_pending: 'dangerous_return_to_pending',
} as const;

export type BrokersTaskAllowedMethodChangesItem = typeof BrokersTaskAllowedMethodChangesItem[keyof typeof BrokersTaskAllowedMethodChangesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskAllowedMethodChangesItem = {
  automated: 'automated',
  manual: 'manual',
} as const;

/**
 * Workflow Status
 */
export type BrokersTaskWorkflowStatus = typeof BrokersTaskWorkflowStatus[keyof typeof BrokersTaskWorkflowStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskWorkflowStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  canceled: 'canceled',
  paused: 'paused',
} as const;

/**
 * brokers.Task model
 */
export interface BrokersTask {
  /** Task ID */
  id: string;
  /** Task description */
  description: string;
  /** Task message */
  message: string;
  /** Task status */
  status: BrokersTaskStatus;
  /** How the task should be executed */
  execution_method: BrokersTaskExecutionMethod;
  /** Where the task should be executed */
  execution_context: BrokersTaskExecutionContext;
  /** Task sequence order in workflow */
  sequence_order: number;
  /** Task class name */
  task_type: string;
  /** Task-specific metadata */
  task_metadata?: BrokersTaskTaskMetadata;
  /** Task categories */
  categories?: BrokersTaskCategoriesItem[];
  /** Task dependencies for DAG visualization */
  dependencies?: BrokersTaskTaskDependency[];
  /** Human-readable task name */
  display_name: string;
  /** Task Creation Date */
  created_at: string;
  /** Task Last Update Date */
  updated_at: string;
  /** Number of failures */
  fail_count: number;
  job?: BrokersTaskJob;
  /** Whether the task can be executed */
  can_execute: boolean;
  /** Related Member ID */
  member_id?: string;
  /** Related Member Name */
  member_name?: string;
  /** Carrier Name */
  carrier_name?: string;
  /** Assigned Brokers */
  brokers?: BrokersBroker[];
  completed_by_broker?: BrokersBroker;
  /** Task completion date */
  completed_at?: string;
  processed_by_broker?: BrokersBroker;
  /** Task processing start date */
  processed_at?: string;
  /** User/broker ID who blocked the task */
  blocked_by?: string;
  /** Category of blocker (e.g., 'general_agent', 'member', 'carrier') */
  blocked_reason?: BrokersTaskBlockedReason;
  /** When the task was blocked */
  blocked_at?: string;
  /** User/broker ID who unblocked the task */
  unblocked_by?: string;
  /** When the task was unblocked */
  unblocked_at?: string;
  /** Available AASM status events for current task state */
  available_actions?: BrokersTaskAvailableActionsItem[];
  /** Allowed execution method changes for current task state */
  allowed_method_changes?: BrokersTaskAllowedMethodChangesItem[];
  /** Whether this task has an active hold (V2 tasks only) */
  has_active_hold?: boolean;
  /** Tasks that depend on this task (for DAG visualization) */
  dependent_tasks?: BrokersTaskTaskDependency[];
  /** Workflow ID */
  workflow_id?: string;
  /** Workflow Status */
  workflow_status?: BrokersTaskWorkflowStatus;
  /** Coverage Start Date (from workflow) */
  coverage_start_date?: string;
  /** Tasks that this task depends on (prerequisites) - simplified for UI display */
  prerequisite_tasks_summary?: BrokersDependencyTaskSummary[];
  /** Tasks that depend on this task (next tasks) - simplified for UI display */
  dependent_tasks_summary?: BrokersDependencyTaskSummary[];
  /** Whether all dependencies are resolved */
  dependencies_resolved?: boolean;
}

/**
 * Type of dependency (completion, skipped, etc.)
 */
export type BrokersTaskTaskDependencyDependencyType = typeof BrokersTaskTaskDependencyDependencyType[keyof typeof BrokersTaskTaskDependencyDependencyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskTaskDependencyDependencyType = {
  skipped: 'skipped',
  completion: 'completion',
} as const;

export interface BrokersTaskTaskDependency {
  /** Dependency ID */
  id: string;
  /** Task that has the dependency */
  task_id: string;
  /** Task that is being depended on */
  depends_on_task_id: string;
  /** Type of dependency (completion, skipped, etc.) */
  dependency_type: BrokersTaskTaskDependencyDependencyType;
}

/**
 * brokers.Task.Job model
 */
export interface BrokersTaskJob {
  /** Tasks Job ID */
  id: string;
  /** Job Handler Name */
  handler_name: string;
  /** Job Handler Description */
  description: string;
  /** Job Type */
  type: string;
  /** Recurrence Job Start Date */
  period_start_date?: string;
}

/**
 * Current task status
 */
export type BrokersDependencyTaskSummaryStatus = typeof BrokersDependencyTaskSummaryStatus[keyof typeof BrokersDependencyTaskSummaryStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersDependencyTaskSummaryStatus = {
  pending: 'pending',
  processing: 'processing',
  blocked: 'blocked',
  completed: 'completed',
  canceled: 'canceled',
  excluded: 'excluded',
  failed: 'failed',
} as const;

/**
 * Category of blocking reason if task is blocked
 */
export type BrokersDependencyTaskSummaryExclusionCategory = typeof BrokersDependencyTaskSummaryExclusionCategory[keyof typeof BrokersDependencyTaskSummaryExclusionCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersDependencyTaskSummaryExclusionCategory = {
  hold: 'hold',
  external: 'external',
  dependency: 'dependency',
} as const;

/**
 * Whether task is automated or manual
 */
export type BrokersDependencyTaskSummaryExecutionMethod = typeof BrokersDependencyTaskSummaryExecutionMethod[keyof typeof BrokersDependencyTaskSummaryExecutionMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersDependencyTaskSummaryExecutionMethod = {
  automated: 'automated',
  manual: 'manual',
} as const;

/**
 * Who should complete the task
 */
export type BrokersDependencyTaskSummaryExecutionContext = typeof BrokersDependencyTaskSummaryExecutionContext[keyof typeof BrokersDependencyTaskSummaryExecutionContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersDependencyTaskSummaryExecutionContext = {
  thatch: 'thatch',
  member: 'member',
} as const;

export interface BrokersDependencyTaskSummary {
  /** Task ID */
  id: string;
  /** Human-readable task name */
  display_name: string;
  /** Order of task in workflow */
  sequence_order: number;
  /** Current task status */
  status: BrokersDependencyTaskSummaryStatus;
  /** Whether the task is blocked (excluded) rather than ready to execute */
  is_excluded: boolean;
  /** Category of blocking reason if task is blocked */
  exclusion_category?: BrokersDependencyTaskSummaryExclusionCategory;
  /** Specific reason why task is blocked */
  exclusion_reason?: string;
  /** Whether task is automated or manual */
  execution_method: BrokersDependencyTaskSummaryExecutionMethod;
  /** Who should complete the task */
  execution_context: BrokersDependencyTaskSummaryExecutionContext;
}

/**
 * brokers.Coverage model
 */
export interface BrokersCoverage {
  /** Coverage ID */
  id: string;
  /** Covered Participant ID */
  covered_participant_id: string;
  /** Enrollment ID */
  insurance_enrollment_id: string;
  /** Start Date */
  start_date: string;
  /** Requested Start Date */
  requested_start_date: string;
  /** End Date */
  end_date: string;
  /** Covered Participant Name */
  full_name: string;
  /** Covered Participant Date of Birth */
  dob: string;
  /** Covered Participant Relationship */
  relationship: string;
}

/**
 * Reason for this coverage change
 */
export type PutBrokersMembersMemberIdEnrollmentsIdCoveragesCoverageAuditReason = typeof PutBrokersMembersMemberIdEnrollmentsIdCoveragesCoverageAuditReason[keyof typeof PutBrokersMembersMemberIdEnrollmentsIdCoveragesCoverageAuditReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutBrokersMembersMemberIdEnrollmentsIdCoveragesCoverageAuditReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
} as const;

/**
 * Update coverages for an enrollment
 */
export interface PutBrokersMembersMemberIdEnrollmentsIdCoverages {
  /** Reason for this coverage change */
  coverage_audit_reason?: PutBrokersMembersMemberIdEnrollmentsIdCoveragesCoverageAuditReason;
  /** Coverage IDs */
  coverage_ids: string[];
  /** Start Date */
  start_date?: string;
  /** End Date */
  end_date?: string;
}

/**
 * Reason for this coverage change
 */
export type PostBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason = typeof PostBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason[keyof typeof PostBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
} as const;

/**
 * Creates coverages for an enrollment
 */
export interface PostBrokersMembersMemberIdEnrollmentsIdCoverage {
  /** Reason for this coverage change */
  coverage_audit_reason?: PostBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason;
  /** Covered Participant ID */
  covered_participant_id: string;
  /** Start Date */
  start_date: string;
  /** End Date */
  end_date: string;
}

/**
 * brokers.Premium model
 */
export interface BrokersPremium {
  /** Insurance Premium ID */
  id: string;
  loss: Money;
  premium: Money;
  period_end_date: string;
  period_start_date: string;
  source: string;
  insurance_enrollment_id: string;
  consistent_deduction_id?: string;
}

/**
 * Reason for this coverage change
 */
export type PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsCoverageAuditReason = typeof PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsCoverageAuditReason[keyof typeof PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsCoverageAuditReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsCoverageAuditReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
} as const;

/**
 * Update an enrollment's insurance premiums
 */
export interface PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums {
  /** Reason for this coverage change */
  coverage_audit_reason?: PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsCoverageAuditReason;
  /** Premium IDs */
  premium_ids: string[];
  /** Premium Amount */
  premium_amount: string;
  /** Loss Amount */
  loss_amount: string;
}

/**
 * Status of the qualifying life event
 */
export type BrokersCoveredParticipantQleStatus = typeof BrokersCoveredParticipantQleStatus[keyof typeof BrokersCoveredParticipantQleStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersCoveredParticipantQleStatus = {
  in_progress: 'in_progress',
  awaiting_confirmation: 'awaiting_confirmation',
  complete: 'complete',
} as const;

/**
 * brokers.CoveredParticipant model
 */
export interface BrokersCoveredParticipant {
  /** Covered Participant ID */
  id: string;
  dob: string;
  enroll_in_medical: boolean;
  enroll_in_dental: boolean;
  enroll_in_vision: boolean;
  family_name: string;
  gender?: string;
  given_name: string;
  has_disability?: boolean;
  relationship: string;
  ssn?: string;
  age?: number;
  tobacco: boolean;
  member_ichra_config_id: string;
  qualifying_life_event_id?: string;
  /** Status of the qualifying life event */
  qle_status?: BrokersCoveredParticipantQleStatus;
  status?: string;
}

/**
 * Create a new covered participant
 */
export interface PostBrokersMembersMemberIdCoveredParticipants {
  /** Plan Year */
  plan_year: number;
  /** Family name of the participant */
  family_name: string;
  /** Given name of the participant */
  given_name: string;
  /** Gender of the participant */
  gender: string;
  /** Relationship to the primary member */
  relationship: string;
  /** Social Security Number */
  ssn?: string;
  /** Date of birth */
  dob: string;
  /** Whether the participant uses tobacco */
  tobacco: boolean;
  /** Whether the participant has a disability (only valid for children) */
  has_disability?: boolean;
  /** Status of the participant ('pending' or nil for active) */
  status?: string;
}

/**
 * Update a covered participant
 */
export interface PatchBrokersMembersMemberIdCoveredParticipantsId {
  /** Plan Year */
  plan_year: number;
  /** Family name of the participant */
  family_name: string;
  /** Given name of the participant */
  given_name: string;
  /** Gender of the participant */
  gender: string;
  /** Relationship to the primary member */
  relationship: string;
  /** Social Security Number */
  ssn?: string;
  /** Date of birth */
  dob: string;
  /** Whether the participant uses tobacco */
  tobacco: boolean;
  /** Whether the participant has a disability (only valid for children) */
  has_disability?: boolean;
  /** Status of the participant ('pending' or nil for active) */
  status?: string;
}

/**
 * brokers.PaginatedQualifyingLifeEventList model
 */
export interface BrokersPaginatedQualifyingLifeEventList {
  data?: BrokersQualifyingLifeEvent[];
  pagination?: Pagination;
}

/**
 * Qualifying Life Event State
 */
export type BrokersQualifyingLifeEventState = typeof BrokersQualifyingLifeEventState[keyof typeof BrokersQualifyingLifeEventState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersQualifyingLifeEventState = {
  in_progress: 'in_progress',
  awaiting_confirmation: 'awaiting_confirmation',
  complete: 'complete',
} as const;

export interface BrokersQualifyingLifeEvent {
  /** Qualifying Life Event ID */
  id: string;
  /** Qualifying Life Event Type */
  type: string;
  /** Qualifying Life Event Situation */
  situation: string;
  /** Qualifying Life Event State */
  state: BrokersQualifyingLifeEventState;
  /** Effective Date */
  effective_date?: string;
  /** Confirmation Sent At */
  confirmation_sent_at?: string;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  /** Member ICHRA Config ID */
  member_ichra_config_id: string;
  /** Plan Year */
  plan_year: string;
  /** Includes Medical */
  includes_medical: boolean;
  /** Includes Dental */
  includes_dental: boolean;
  /** Includes Vision */
  includes_vision: boolean;
  /** Has Attachments */
  has_attachments: boolean;
}

/**
 * brokers.PaginatedStripeIssuingCardsList model
 */
export interface BrokersPaginatedStripeIssuingCardsList {
  data?: BrokersStripeIssuingCard[];
  pagination?: Pagination;
}

/**
 * brokers.StripeIssuingCard model
 */
export interface BrokersStripeIssuingCard {
  /** Stripe Issuing Card ID */
  id: string;
  /** Last 4 digits of card */
  last4: string;
  /** Card status from Stripe */
  remote_status: string;
  /** Stripe card ID */
  remote_id: string;
  /** Stripe cardholder ID */
  remote_cardholder_id: string;
  /** Card creation timestamp */
  created_at: string;
  /** Card last update timestamp */
  updated_at: string;
  /** URL to view the card in Stripe dashboard */
  view_card_on_stripe_url: string;
  /** Associated enrollments */
  enrollments?: BrokersEnrollmentMappingOption[];
}

/**
 * Create a new Stripe issuing card for a member
 */
export interface PostBrokersMembersMemberIdStripeIssuingCards {
  /** Insurance enrollment ID */
  enrollment_id: string;
}

/**
 * Cardholder billing address
 */
export type BrokersStripeIssuingCardCardholderDetailsCardholderAddress = { [key: string]: unknown };

/**
 * brokers.StripeIssuingCardCardholderDetails model
 */
export interface BrokersStripeIssuingCardCardholderDetails {
  /** Stripe Issuing Card ID */
  id: string;
  /** Last 4 digits of card */
  last4: string;
  /** Card status from Stripe */
  remote_status: string;
  /** Stripe card ID */
  remote_id: string;
  /** Stripe cardholder ID */
  remote_cardholder_id: string;
  /** URL to view the card in Stripe dashboard */
  view_card_on_stripe_url: string;
  /** Name of the cardholder */
  cardholder_name: string;
  /** Cardholder billing address */
  cardholder_address: BrokersStripeIssuingCardCardholderDetailsCardholderAddress;
  /** Card creation timestamp */
  created_at: string;
  /** Card last update timestamp */
  updated_at: string;
}

/**
 * Create ephemeral key for Stripe issuing card elements
 */
export interface PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey {
  /** Ephemeral key nonce from Stripe */
  nonce: string;
}

/**
 * brokers.StripeIssuingCardEphemeralKey model
 */
export interface BrokersStripeIssuingCardEphemeralKey {
  /** Ephemeral key secret from Stripe for accessing card elements */
  ephemeralKeySecret: string;
}

/**
 * Remap Stripe issuing card to a different enrollment
 */
export interface PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap {
  /** Insurance enrollment ID to remap the card to */
  enrollment_id: string;
}

/**
 * brokers.NoteList model
 */
export interface BrokersNoteList {
  data?: BrokersNote[];
}

/**
 * brokers.Note model
 */
export interface BrokersNote {
  /** Note ID */
  id: string;
  /** Author name */
  author_name?: string;
  /** Member ID */
  member_id?: string;
  /** Employer ID */
  employer_id?: string;
  /** Creation date */
  created_at?: string;
  /** Update date */
  updated_at?: string;
  /** Note content as HTML. */
  content?: string;
  /** Whether or not the note can be edited. */
  can_edit?: boolean;
  /** Path to inspect the note. Available to Thatch admins only. */
  inspect_path?: string;
}

/**
 * Create a new note.
 */
export interface PostBrokersNotes {
  member_id?: string;
  employer_id?: string;
  subject_type?: string;
  subject_id?: string;
  content: string;
}

/**
 * Update a note
 */
export interface PatchBrokersNotesId {
  member_id?: string;
  employer_id?: string;
  subject_type?: string;
  subject_id?: string;
  /** Updated note content */
  content: string;
}

/**
 * brokers.PaginatedUnprocessedEnrollmentList model
 */
export interface BrokersPaginatedUnprocessedEnrollmentList {
  data?: BrokersEnrollmentEnriched[];
  pagination?: Pagination;
}

/**
 * Apply a broker action to update an enrollment
 */
export interface PostBrokersUnprocessedEnrollmentsIdAction {
  /** Action name */
  action: string;
}

/**
 * Assign an enrollment to a broker
 */
export interface PostBrokersUnprocessedEnrollmentsIdAssign {
  /** Broker ID */
  broker_id: string;
}

/**
 * brokers.VbanDetails model
 */
export interface BrokersVbanDetails {
  /** Full VBAN account number */
  account_number: string;
  /** Full VBAN routing number */
  routing_number: string;
}

/**
 * brokers.BrokerList model
 */
export interface BrokersBrokerList {
  data?: BrokersBroker[];
}

/**
 * The new value to set on the Member ICHRA Config
 */
export type PutBrokersMemberIchraConfigOptedInValue = typeof PutBrokersMemberIchraConfigOptedInValue[keyof typeof PutBrokersMemberIchraConfigOptedInValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutBrokersMemberIchraConfigOptedInValue = {
  true: 'true',
  false: 'false',
  null: 'null',
} as const;

/**
 * Update Opted In status for a specific Member ICHRA Config
 */
export interface PutBrokersMemberIchraConfigOptedIn {
  /** Member ICHRA Config ID */
  member_ichra_config_id: string;
  /** The new value to set on the Member ICHRA Config */
  value: PutBrokersMemberIchraConfigOptedInValue;
}

/**
 * The new value to set on the Member ICHRA Config for QME Treatment
 */
export type PutBrokersMemberIchraConfigQmeTreatmentValue = typeof PutBrokersMemberIchraConfigQmeTreatmentValue[keyof typeof PutBrokersMemberIchraConfigQmeTreatmentValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutBrokersMemberIchraConfigQmeTreatmentValue = {
  all_allowed: 'all_allowed',
  disabled: 'disabled',
  copay_only: 'copay_only',
} as const;

/**
 * Update QME Treatment for a specific Member ICHRA Config
 */
export interface PutBrokersMemberIchraConfigQmeTreatment {
  /** Member ICHRA Config ID */
  member_ichra_config_id: string;
  /** The new value to set on the Member ICHRA Config for QME Treatment */
  value: PutBrokersMemberIchraConfigQmeTreatmentValue;
}

/**
 * brokers.Brokerage model
 */
export interface BrokersBrokerage {
  /** Brokerage ID */
  id: string;
  name: string;
  dba?: string;
}

/**
 * brokers.Tag model
 */
export interface BrokersTag {
  /** Tag ID */
  id: string;
  /** Tag Category */
  category: string;
  name: string;
  description?: string;
  archived: boolean;
  brokerage_id: string;
}

/**
 * Create tag
 */
export interface PostBrokersTags {
  /** Tag Category */
  category: string;
  /** Tag Name */
  name: string;
  /** Tag Description */
  description?: string;
  /** If a tag is temporary or not */
  temporary?: boolean;
}

/**
 * Edit tag
 */
export interface PatchBrokersTagsId {
  /** Tag Category */
  category: string;
  /** Tag Name */
  name: string;
  /** Tag Description */
  description?: string;
  /** If a tag is temporary or not */
  temporary?: boolean;
}

/**
 * Edit archived status
 */
export interface PatchBrokersTagsIdArchived {
  /** Updated archived status */
  archived: boolean;
}

/**
 * brokers.PaginatedBrokerAttentionNeededItemList model
 */
export interface BrokersPaginatedBrokerAttentionNeededItemList {
  data?: BrokersBrokerAttentionNeededItem[];
  pagination?: Pagination;
}

/**
 * brokers.BrokerAttentionNeededItem model
 */
export interface BrokersBrokerAttentionNeededItem {
  id?: string;
  insurance_enrollment_id?: string;
  member_id?: string;
  brokerage_id?: string;
  employer_id?: string;
  employer_name?: string;
  employee_first_name?: string;
  employee_last_name?: string;
  status?: string;
  silenced_until?: string;
  created_at?: string;
  updated_at?: string;
  amount_paid?: number;
  amount_expected?: number[];
  enrollment_type?: string;
  notes?: string;
  reason?: string;
  silenced_by_name?: string;
  carrier_name?: string;
  submission_method?: string;
  category?: string;
  state?: string;
  brokerage_name?: string;
  tags?: BrokersTag[];
  brokers?: BrokersBroker[];
}

/**
 * Modify Broker Attention Needed Items
 */
export interface PatchBrokersBrokerAttentionNeededItems {
  /** Attempt to resolve the items. */
  attempt_to_resolve?: boolean;
  /** Date to silence the items until. */
  silence_until_date?: string;
  /** Note content to be created while silencing. */
  content?: string;
  /** Expected payment date offset for the enrollment(s). */
  expected_payment_date_offset?: number;
}

/**
 * Create a Broker Attention Needed Item for one or more enrollments
 */
export interface PostBrokersBrokerAttentionNeededItems {
  /** Manual reason for the NAV item */
  reason: string;
  /** Notes for the item to pass along context why the item was created */
  notes: string;
  /** NAV item status */
  status: string;
  /** IDs of enrollments to create the item for */
  enrollment_ids?: string[];
  /** IDs of Brokers to add */
  broker_ids?: string[];
  /** IDs of Tags to add */
  tag_ids?: string[];
}

/**
 * Modify a Broker Attention Needed Item
 */
export interface PatchBrokersBrokerAttentionNeededItemsId {
  /** Manual reason for the NAV item */
  reason: string;
  /** Notes for the item to pass along context why the item was created */
  notes: string;
  /** NAV item status */
  status: string;
  /** IDs of enrollments to create the item for */
  enrollment_ids?: string[];
  /** IDs of Brokers to add */
  broker_ids?: string[];
  /** IDs of Tags to add */
  tag_ids?: string[];
}

/**
 * brokers.PaginatedTaskList model
 */
export interface BrokersPaginatedTaskList {
  data?: BrokersTask[];
  pagination?: Pagination;
}

/**
 * Status event to trigger
 */
export type PatchBrokersTasksStatusEvent = typeof PatchBrokersTasksStatusEvent[keyof typeof PatchBrokersTasksStatusEvent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBrokersTasksStatusEvent = {
  complete: 'complete',
  cancel: 'cancel',
  uncancel: 'uncancel',
  retry: 'retry',
  rollback: 'rollback',
  fail: 'fail',
  process: 'process',
  block: 'block',
  unblock: 'unblock',
} as const;

/**
 * Category of blocker (only for block status event)
 */
export type PatchBrokersTasksBlockedReason = typeof PatchBrokersTasksBlockedReason[keyof typeof PatchBrokersTasksBlockedReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBrokersTasksBlockedReason = {
  general_agent: 'general_agent',
  member: 'member',
  carrier: 'carrier',
  missing_info: 'missing_info',
  incident: 'incident',
  other: 'other',
} as const;

/**
 * Execution method to set
 */
export type PatchBrokersTasksMethod = typeof PatchBrokersTasksMethod[keyof typeof PatchBrokersTasksMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBrokersTasksMethod = {
  automated: 'automated',
  manual: 'manual',
} as const;

/**
 * Execution context to set
 */
export type PatchBrokersTasksExecutionContext = typeof PatchBrokersTasksExecutionContext[keyof typeof PatchBrokersTasksExecutionContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBrokersTasksExecutionContext = {
  thatch: 'thatch',
  member: 'member',
} as const;

/**
 * Modify Broker Tasks
 */
export interface PatchBrokersTasks {
  /** IDs of Tasks */
  task_ids: string[];
  /** IDs of Brokers to add */
  broker_ids_to_add?: string[];
  /** IDs of Brokers to remove */
  broker_ids_to_remove?: string[];
  /** Status event to trigger */
  status_event?: PatchBrokersTasksStatusEvent;
  /** Message for status update */
  status_message?: string;
  /** Category of blocker (only for block status event) */
  blocked_reason?: PatchBrokersTasksBlockedReason;
  /** Reason for unblocking (only for unblock status event) */
  unblock_reason?: string;
  /** Execution method to set */
  method?: PatchBrokersTasksMethod;
  /** Message for method update */
  method_message?: string;
  /** Execution context to set */
  execution_context?: PatchBrokersTasksExecutionContext;
  /** Message for context update */
  context_message?: string;
}

/**
 * Task status breakdown
 */
export type BrokersJobStatisticsTaskStatus = { [key: string]: unknown };

/**
 * Task execution method breakdown
 */
export type BrokersJobStatisticsTaskExecutionMethod = { [key: string]: unknown };

/**
 * Job type breakdown
 */
export type BrokersJobStatisticsJobType = { [key: string]: unknown };

/**
 * Job recurrence breakdown
 */
export type BrokersJobStatisticsJobRecurrence = { [key: string]: unknown };

/**
 * Recent task activity
 */
export type BrokersJobStatisticsRecentActivity = { [key: string]: unknown };

/**
 * brokers.JobStatistics model
 */
export interface BrokersJobStatistics {
  /** Total number of jobs */
  total_jobs: number;
  /** Total number of tasks */
  total_tasks: number;
  /** Number of jobs currently on hold */
  jobs_on_hold: number;
  /** Task status breakdown */
  task_status: BrokersJobStatisticsTaskStatus;
  /** Task execution method breakdown */
  task_execution_method: BrokersJobStatisticsTaskExecutionMethod;
  /** Job type breakdown */
  job_type: BrokersJobStatisticsJobType;
  /** Job recurrence breakdown */
  job_recurrence: BrokersJobStatisticsJobRecurrence;
  /** Default execution method for this task type */
  default_execution_method: string;
  /** Recent task activity */
  recent_activity: BrokersJobStatisticsRecentActivity;
}

/**
 * User who cleared the hold
 */
export type BrokersHoldClearedBy = { [key: string]: unknown };

/**
 * brokers.Hold model
 */
export interface BrokersHold {
  /** Hold ID */
  id: string;
  /** Reason for the hold */
  reason: string;
  /** Whether the hold has been cleared */
  cleared: boolean;
  /** ID of the user who created the hold */
  created_by: string;
  /** When the hold was created */
  created_at: string;
  /** When the hold was cleared */
  cleared_at?: string;
  /** User who cleared the hold */
  cleared_by?: BrokersHoldClearedBy;
}

/**
 * Create a new hold for a specific job
 */
export interface PostBrokersTasksJobsJobIdHolds {
  /** Reason for the hold */
  reason: string;
}

/**
 * Update a hold (clear or unclear)
 */
export interface PatchBrokersTasksJobsJobIdHoldsHoldId {
  /** Whether to clear the hold */
  cleared: boolean;
}

export type BrokersTaskTypeCategoriesItem = typeof BrokersTaskTypeCategoriesItem[keyof typeof BrokersTaskTypeCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskTypeCategoriesItem = {
  submission: 'submission',
  payment: 'payment',
  autopay: 'autopay',
} as const;

/**
 * brokers.TaskType model
 */
export interface BrokersTaskType {
  /** Task type/class name */
  task_type: string;
  /** Human-readable task type name */
  display_name: string;
  /** Optional categories for grouping related tasks (e.g., submission, payment, autopay) */
  categories?: BrokersTaskTypeCategoriesItem[];
}

export type BrokersTaskTypeSummaryCategoriesItem = typeof BrokersTaskTypeSummaryCategoriesItem[keyof typeof BrokersTaskTypeSummaryCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskTypeSummaryCategoriesItem = {
  submission: 'submission',
  payment: 'payment',
  autopay: 'autopay',
} as const;

/**
 * Default execution method for this task type
 */
export type BrokersTaskTypeSummaryDefaultExecutionMethod = typeof BrokersTaskTypeSummaryDefaultExecutionMethod[keyof typeof BrokersTaskTypeSummaryDefaultExecutionMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskTypeSummaryDefaultExecutionMethod = {
  automated: 'automated',
  manual: 'manual',
} as const;

/**
 * brokers.TaskTypeSummary model
 */
export interface BrokersTaskTypeSummary {
  /** Task type/class name */
  task_type: string;
  /** Human-readable task type name */
  display_name: string;
  /** Optional categories for grouping related tasks (e.g., submission, payment, autopay) */
  categories?: BrokersTaskTypeSummaryCategoriesItem[];
  /** Total number of tasks of this type */
  total_tasks: number;
  task_statistics: BrokersTaskTypeSummaryTaskStatistics;
  task_execution_method: BrokersTaskTypeSummaryTaskExecutionMethod;
  /** Whether this task type has an active hold */
  has_active_hold: boolean;
  /** Number of active holds on this task type */
  active_holds_count: number;
  /** Default execution method for this task type */
  default_execution_method: BrokersTaskTypeSummaryDefaultExecutionMethod;
  recent_activity: BrokersTaskTypeSummaryRecentActivity;
}

export interface BrokersTaskTypeSummaryTaskStatistics {
  /** Total number of tasks */
  total: number;
  /** Number of pending tasks */
  pending: number;
  /** Number of processing tasks */
  processing: number;
  /** Number of completed tasks */
  completed: number;
  /** Number of failed tasks */
  failed: number;
  /** Number of canceled tasks */
  canceled: number;
  /** Number of excluded tasks */
  excluded: number;
}

export interface BrokersTaskTypeSummaryTaskExecutionMethod {
  /** Number of automated tasks */
  automated: number;
  /** Number of manual tasks */
  manual: number;
}

export interface BrokersTaskTypeSummaryRecentActivity {
  /** Number of tasks created in the last 24 hours */
  tasks_last_24h: number;
  /** Number of tasks created in the last 7 days */
  tasks_last_7d: number;
  /** Number of tasks created in the last 30 days */
  tasks_last_30d: number;
}

/**
 * Action to perform (add_holds or remove_holds)
 */
export type PatchBrokersTasksTaskTypesAction = typeof PatchBrokersTasksTaskTypesAction[keyof typeof PatchBrokersTasksTaskTypesAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBrokersTasksTaskTypesAction = {
  add_holds: 'add_holds',
  remove_holds: 'remove_holds',
} as const;

/**
 * Bulk update holds for multiple task types
 */
export interface PatchBrokersTasksTaskTypes {
  /** Array of task type class names */
  task_types: string[];
  /** Action to perform (add_holds or remove_holds) */
  action: PatchBrokersTasksTaskTypesAction;
  /** Message/reason for the holds (required for add_holds) */
  message?: string;
}

/**
 * User who cleared the hold
 */
export type BrokersV2HoldClearedBy = { [key: string]: unknown };

/**
 * brokers.V2Hold model
 */
export interface BrokersV2Hold {
  /** Hold ID */
  id: string;
  /** Task type/class that is on hold */
  task_type: string;
  /** Reason for the hold */
  reason: string;
  /** Whether the hold has been cleared */
  cleared: boolean;
  /** ID of the user who created the hold */
  created_by: string;
  /** When the hold was created */
  created_at: string;
  /** When the hold was cleared */
  cleared_at?: string;
  /** User who cleared the hold */
  cleared_by?: BrokersV2HoldClearedBy;
  /** Human-readable task type name */
  display_task_type: string;
  /** Whether the hold is currently active (not cleared) */
  active: boolean;
}

export type BrokersTaskTypeStatisticsCategoriesItem = typeof BrokersTaskTypeStatisticsCategoriesItem[keyof typeof BrokersTaskTypeStatisticsCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskTypeStatisticsCategoriesItem = {
  submission: 'submission',
  payment: 'payment',
  autopay: 'autopay',
} as const;

/**
 * Task status breakdown
 */
export type BrokersTaskTypeStatisticsTaskStatus = { [key: string]: unknown };

/**
 * Task execution method breakdown
 */
export type BrokersTaskTypeStatisticsTaskExecutionMethod = { [key: string]: unknown };

/**
 * Recent task activity
 */
export type BrokersTaskTypeStatisticsRecentActivity = { [key: string]: unknown };

/**
 * brokers.TaskTypeStatistics model
 */
export interface BrokersTaskTypeStatistics {
  /** Task type/class name */
  task_type: string;
  /** Human-readable task type name */
  display_name: string;
  /** Optional categories for grouping related tasks (e.g., submission, payment, autopay) */
  categories?: BrokersTaskTypeStatisticsCategoriesItem[];
  /** Total number of tasks of this type */
  total_tasks: number;
  /** Number of active holds for this task type */
  holds_count: number;
  /** Task status breakdown */
  task_status: BrokersTaskTypeStatisticsTaskStatus;
  /** Task execution method breakdown */
  task_execution_method: BrokersTaskTypeStatisticsTaskExecutionMethod;
  /** Default execution method for this task type */
  default_execution_method: string;
  /** Recent task activity */
  recent_activity: BrokersTaskTypeStatisticsRecentActivity;
}

/**
 * Create a new hold for a specific task type
 */
export interface PostBrokersTasksTaskTypesTaskTypeHolds {
  /** Reason for the hold */
  reason: string;
}

/**
 * Task status breakdown
 */
export type BrokersV2TaskStatisticsTaskStatus = { [key: string]: unknown };

/**
 * Task execution method breakdown
 */
export type BrokersV2TaskStatisticsTaskExecutionMethod = { [key: string]: unknown };

/**
 * Task type breakdown
 */
export type BrokersV2TaskStatisticsTaskTypeBreakdown = { [key: string]: unknown };

/**
 * Recent task activity
 */
export type BrokersV2TaskStatisticsRecentActivity = { [key: string]: unknown };

/**
 * brokers.V2TaskStatistics model
 */
export interface BrokersV2TaskStatistics {
  /** Total number of V2 tasks */
  total_tasks: number;
  /** Number of active V2 holds */
  v2_holds_count: number;
  /** Task status breakdown */
  task_status: BrokersV2TaskStatisticsTaskStatus;
  /** Task execution method breakdown */
  task_execution_method: BrokersV2TaskStatisticsTaskExecutionMethod;
  /** Task type breakdown */
  task_type_breakdown: BrokersV2TaskStatisticsTaskTypeBreakdown;
  /** Default execution method for this task type */
  default_execution_method: string;
  /** Recent task activity */
  recent_activity: BrokersV2TaskStatisticsRecentActivity;
}

/**
 * Create a new V2 hold for a task type
 */
export interface PostBrokersTasksV2Holds {
  /** Task type/class to hold */
  task_type: string;
  /** Reason for the hold */
  reason: string;
}

/**
 * Update a V2 hold (clear or reactivate)
 */
export interface PatchBrokersTasksV2HoldsHoldId {
  /** Whether to clear the hold */
  cleared: boolean;
}

/**
 * Handler-specific arguments
 */
export type BrokersHandlerArgs = { [key: string]: unknown };

/**
 * Job-specific configuration details
 */
export type BrokersHandlerJobDetails = { [key: string]: unknown };

/**
 * Entity rendering options
 */
export type BrokersHandlerEntityOptions = { [key: string]: unknown };

/**
 * brokers.Handler model
 */
export interface BrokersHandler {
  /** Handler unique name */
  name: string;
  /** Handler description */
  description: string;
  /** Job class type */
  type: string;
  /** Executor type for this handler */
  executor_type?: string;
  /** Whether this handler creates recurring jobs */
  recurring: boolean;
  /** Handler-specific arguments */
  args?: BrokersHandlerArgs;
  /** Job-specific configuration details */
  job_details?: BrokersHandlerJobDetails;
  /** Entity rendering options */
  entity_options?: BrokersHandlerEntityOptions;
}

/**
 * Task statistics for this job
 */
export type BrokersJobSummaryTaskStatistics = { [key: string]: unknown };

/**
 * brokers.JobSummary model
 */
export interface BrokersJobSummary {
  /** Job ID */
  id: string;
  /** Handler name */
  handler_name: string;
  /** Job description */
  description: string;
  /** Job type */
  type: string;
  /** Job period start date */
  period_start_date?: string;
  /** Job creation timestamp */
  created_at: string;
  /** Job last update timestamp */
  updated_at: string;
  /** Task statistics for this job */
  task_statistics: BrokersJobSummaryTaskStatistics;
  /** Whether the job has an active hold */
  has_active_hold: boolean;
  /** Number of active holds on this job */
  active_holds_count: number;
}

/**
 * Create a new job for a specific handler
 */
export interface PostBrokersTasksHandlersHandlerNameJobs {
  /** Period start date for recurring jobs (YYYY-MM-DD format) */
  period_start_date?: string;
}

/**
 * Task status
 */
export type BrokersTaskDetailStatus = typeof BrokersTaskDetailStatus[keyof typeof BrokersTaskDetailStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskDetailStatus = {
  pending: 'pending',
  processing: 'processing',
  blocked: 'blocked',
  completed: 'completed',
  canceled: 'canceled',
  excluded: 'excluded',
  failed: 'failed',
} as const;

/**
 * How the task should be executed
 */
export type BrokersTaskDetailExecutionMethod = typeof BrokersTaskDetailExecutionMethod[keyof typeof BrokersTaskDetailExecutionMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskDetailExecutionMethod = {
  automated: 'automated',
  manual: 'manual',
} as const;

/**
 * Where the task should be executed
 */
export type BrokersTaskDetailExecutionContext = typeof BrokersTaskDetailExecutionContext[keyof typeof BrokersTaskDetailExecutionContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskDetailExecutionContext = {
  thatch: 'thatch',
  member: 'member',
} as const;

/**
 * Task-specific metadata
 */
export type BrokersTaskDetailTaskMetadata = { [key: string]: unknown };

export type BrokersTaskDetailCategoriesItem = typeof BrokersTaskDetailCategoriesItem[keyof typeof BrokersTaskDetailCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskDetailCategoriesItem = {
  submission: 'submission',
  payment: 'payment',
  autopay: 'autopay',
} as const;

/**
 * Category of blocker (e.g., 'general_agent', 'member', 'carrier')
 */
export type BrokersTaskDetailBlockedReason = typeof BrokersTaskDetailBlockedReason[keyof typeof BrokersTaskDetailBlockedReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskDetailBlockedReason = {
  general_agent: 'general_agent',
  member: 'member',
  carrier: 'carrier',
  missing_info: 'missing_info',
  incident: 'incident',
  other: 'other',
} as const;

export type BrokersTaskDetailAvailableActionsItem = typeof BrokersTaskDetailAvailableActionsItem[keyof typeof BrokersTaskDetailAvailableActionsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskDetailAvailableActionsItem = {
  cancel: 'cancel',
  uncancel: 'uncancel',
  exclude: 'exclude',
  reinclude: 'reinclude',
  complete: 'complete',
  process: 'process',
  fail: 'fail',
  block: 'block',
  unblock: 'unblock',
  retry: 'retry',
  rollback: 'rollback',
  dangerous_return_to_pending: 'dangerous_return_to_pending',
} as const;

/**
 * Workflow Status
 */
export type BrokersTaskDetailWorkflowStatus = typeof BrokersTaskDetailWorkflowStatus[keyof typeof BrokersTaskDetailWorkflowStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersTaskDetailWorkflowStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  canceled: 'canceled',
  paused: 'paused',
} as const;

/**
 * Task metadata payload
 */
export type BrokersTaskDetailMetadata = { [key: string]: unknown };

/**
 * brokers.TaskDetail model
 */
export interface BrokersTaskDetail {
  /** Task ID */
  id: string;
  /** Task description */
  description: string;
  /** Task message */
  message: string;
  /** Task status */
  status: BrokersTaskDetailStatus;
  /** How the task should be executed */
  execution_method: BrokersTaskDetailExecutionMethod;
  /** Where the task should be executed */
  execution_context: BrokersTaskDetailExecutionContext;
  /** Task sequence order in workflow */
  sequence_order: number;
  /** Task class name */
  task_type: string;
  /** Task-specific metadata */
  task_metadata?: BrokersTaskDetailTaskMetadata;
  /** Task categories */
  categories?: BrokersTaskDetailCategoriesItem[];
  /** Task dependencies for DAG visualization */
  dependencies?: BrokersTaskTaskDependency[];
  /** Human-readable task name */
  display_name: string;
  /** Task Creation Date */
  created_at: string;
  /** Task Last Update Date */
  updated_at: string;
  /** Number of failures */
  fail_count: number;
  job?: BrokersTaskJob;
  /** Whether the task can be executed */
  can_execute: boolean;
  /** Related Member ID */
  member_id?: string;
  /** Related Member Name */
  member_name?: string;
  /** Carrier Name */
  carrier_name?: string;
  /** Assigned Brokers */
  brokers?: BrokersBroker[];
  completed_by_broker?: BrokersBroker;
  /** Task completion date */
  completed_at?: string;
  processed_by_broker?: BrokersBroker;
  /** Task processing start date */
  processed_at?: string;
  /** User/broker ID who blocked the task */
  blocked_by?: string;
  /** Category of blocker (e.g., 'general_agent', 'member', 'carrier') */
  blocked_reason?: BrokersTaskDetailBlockedReason;
  /** When the task was blocked */
  blocked_at?: string;
  /** User/broker ID who unblocked the task */
  unblocked_by?: string;
  /** When the task was unblocked */
  unblocked_at?: string;
  /** Available AASM status events for current task state */
  available_actions?: BrokersTaskDetailAvailableActionsItem[];
  /** Allowed method changes */
  allowed_method_changes: string[];
  /** Whether this task has an active hold (V2 tasks only) */
  has_active_hold?: boolean;
  /** Tasks that depend on this task (for DAG visualization) */
  dependent_tasks?: BrokersTaskTaskDependency[];
  /** Workflow ID */
  workflow_id?: string;
  /** Workflow Status */
  workflow_status?: BrokersTaskDetailWorkflowStatus;
  /** Coverage Start Date (from workflow) */
  coverage_start_date?: string;
  /** Tasks that this task depends on (prerequisites) - simplified for UI display */
  prerequisite_tasks_summary?: BrokersDependencyTaskSummary[];
  /** Tasks that depend on this task (next tasks) - simplified for UI display */
  dependent_tasks_summary?: BrokersDependencyTaskSummary[];
  /** Whether all dependencies are resolved */
  dependencies_resolved?: boolean;
  /** Task Notes */
  notes?: BrokersTaskNote[];
  /** Global ID for the current lease holder */
  lease_holder?: string;
  /** Human-readable identifier for the lease holder */
  lease_holder_name?: string;
  /** Admin URL for inspecting the lease holder */
  lease_holder_url?: string;
  /** Timestamp when the current lease expires */
  lease_expires_at?: string;
  /** Whether the current lease is still active */
  lease_active?: boolean;
  /** Latest Task Result ID */
  result_id?: string;
  task_results_count?: string;
  /** Task metadata payload */
  metadata?: BrokersTaskDetailMetadata;
  /** Playwright execution metadata for automated tasks */
  playwright_execution_key?: string;
  /** Related Entity ID */
  related_id?: string;
  /** Related Entity Type */
  related_type?: string;
  carrier_key?: string;
  /** Allowed status events */
  allowed_status_events: string[];
  can_retry?: string;
}

export interface BrokersTaskNote {
  /** Note ID */
  id: string;
  /** Note content */
  content: string;
  /** Note creation date */
  created_at: string;
  /** Note author */
  author: string;
}

/**
 * Result outputs payload
 */
export type BrokersTaskResultOutputs = { [key: string]: unknown };

/**
 * brokers.Task.Result model
 */
export interface BrokersTaskResult {
  /** Task Result ID */
  id: string;
  /** Associated Task ID */
  task_id: string;
  /** Result status */
  status: string;
  /** Result description */
  description: string;
  /** Result message */
  message?: string;
  /** Result start time */
  start_time: string;
  /** Result duration in milliseconds */
  duration: number;
  /** Result creation timestamp */
  created_at: string;
  /** Result last update timestamp */
  updated_at: string;
  /** Result outputs payload */
  outputs: BrokersTaskResultOutputs;
  /** Attachments captured for this result */
  attachments: BrokersTaskResultAttachment[];
  /** Recorded steps for this result */
  steps?: BrokersTaskResultStep[];
}

export interface BrokersTaskResultAttachment {
  /** Attachment ID */
  id: number;
  /** Attachment filename */
  filename: string;
  /** Attachment MIME type */
  content_type?: string;
  /** Attachment size in bytes */
  byte_size?: number;
  /** When the attachment was created */
  created_at: string;
  /** URL to download the attachment */
  download_url: string;
  /** URL to preview the attachment inline */
  preview_url: string;
}

/**
 * Step options payload
 */
export type BrokersTaskResultStepOptions = { [key: string]: unknown };

/**
 * Structured result payload
 */
export type BrokersTaskResultStepResult = { [key: string]: unknown };

export interface BrokersTaskResultStep {
  /** Step type */
  type: string;
  /** Step description or comment */
  comment?: string;
  /** Step options payload */
  options?: BrokersTaskResultStepOptions;
  /** Step status */
  status: string;
  /** Optional status message */
  message?: string;
  /** Step start time */
  start_time: string;
  /** Step duration in milliseconds */
  duration: number;
  /** Structured result payload */
  result?: BrokersTaskResultStepResult;
  /** Error message if the step failed */
  error?: string;
  /** Additional content (i.e. logs, HTML) */
  content?: string;
}

/**
 * brokers.Task.Command model
 */
export interface BrokersTaskCommand {
  /** Shell command to execute the task */
  command: string;
  /** Automation execution key (if applicable) */
  execution_key?: string;
  /** Additional guidance for executing the command */
  notes?: string;
}

/**
 * brokers.PaginatedCoverageAuditLogList model
 */
export interface BrokersPaginatedCoverageAuditLogList {
  data?: BrokersCoverageAuditLog[];
  pagination?: Pagination;
}

/**
 * Action performed
 */
export type BrokersCoverageAuditLogAction = typeof BrokersCoverageAuditLogAction[keyof typeof BrokersCoverageAuditLogAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersCoverageAuditLogAction = {
  create: 'create',
  update: 'update',
  destroy: 'destroy',
} as const;

/**
 * Reason for the change
 */
export type BrokersCoverageAuditLogReason = typeof BrokersCoverageAuditLogReason[keyof typeof BrokersCoverageAuditLogReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersCoverageAuditLogReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
  thatch_processing: 'thatch_processing',
} as const;

/**
 * Changes made
 */
export type BrokersCoverageAuditLogAuditedChanges = { [key: string]: unknown };

/**
 * brokers.CoverageAuditLog model
 */
export interface BrokersCoverageAuditLog {
  /** Coverage Audit Log ID */
  id: string;
  /** Member ID */
  member_id: string;
  /** Member Name */
  member_name: string;
  /** Insurance Enrollment ID */
  insurance_enrollment_id: string;
  /** Enrollment Title */
  enrollment_title: string;
  /** Action performed */
  action: BrokersCoverageAuditLogAction;
  /** Reason for the change */
  reason: BrokersCoverageAuditLogReason;
  /** Original reason before correction */
  original_reason?: string;
  /** Changes made */
  audited_changes: BrokersCoverageAuditLogAuditedChanges;
  /** Type of the target object */
  target_type?: string;
  /** ID of the target object */
  target_id?: string;
  /** Type of the context object */
  context_type?: string;
  /** ID of the context object */
  context_id?: string;
  /** Creation timestamp */
  created_at: string;
  /** Last update timestamp */
  updated_at: string;
  /** Correction timestamp */
  corrected_at?: string;
  created_by_broker?: BrokersBroker;
  corrected_by_broker?: BrokersBroker;
  /** Additional details about the target (participant name or premium month) */
  target_details?: string;
}

/**
 * New reason for the audit log
 */
export type PatchBrokersCoverageAuditLogsAuditLogIdReason = typeof PatchBrokersCoverageAuditLogsAuditLogIdReason[keyof typeof PatchBrokersCoverageAuditLogsAuditLogIdReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBrokersCoverageAuditLogsAuditLogIdReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
  thatch_processing: 'thatch_processing',
} as const;

/**
 * Update a coverage audit log reason
 */
export interface PatchBrokersCoverageAuditLogsAuditLogId {
  /** New reason for the audit log */
  reason: PatchBrokersCoverageAuditLogsAuditLogIdReason;
}

/**
 * Type of workflow to build
 */
export type PostBrokersTaskWorkflowsWorkflowType = typeof PostBrokersTaskWorkflowsWorkflowType[keyof typeof PostBrokersTaskWorkflowsWorkflowType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostBrokersTaskWorkflowsWorkflowType = {
  submission: 'submission',
  renewal: 'renewal',
  plan_change: 'plan_change',
  dependent_change: 'dependent_change',
  plan_change_and_dependent_change: 'plan_change_and_dependent_change',
  off_thatch: 'off_thatch',
  cancellation: 'cancellation',
  offboarding: 'offboarding',
  medicare: 'medicare',
} as const;

/**
 * Timing context for template selection
 */
export type PostBrokersTaskWorkflowsTiming = typeof PostBrokersTaskWorkflowsTiming[keyof typeof PostBrokersTaskWorkflowsTiming];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostBrokersTaskWorkflowsTiming = {
  mid_year: 'mid_year',
  year_over_year: 'year_over_year',
} as const;

/**
 * Optional workflow metadata (will be merged with generated metadata)
 */
export type PostBrokersTaskWorkflowsMetadata = { [key: string]: unknown };

/**
 * Create or preview a workflow
 */
export interface PostBrokersTaskWorkflows {
  /** Enrollment ID to build workflow for */
  enrollment_id: string;
  /** Type of workflow to build */
  workflow_type: PostBrokersTaskWorkflowsWorkflowType;
  /** Timing context for template selection */
  timing: PostBrokersTaskWorkflowsTiming;
  /** Start date for workflow metadata generation. Will automatically generate enriched metadata using EnrollmentComparator. */
  start_date: string;
  /** Optional workflow metadata (will be merged with generated metadata) */
  metadata?: PostBrokersTaskWorkflowsMetadata;
  /** If true, returns preview without persisting. If false, creates and persists workflow. */
  preview?: boolean;
}

/**
 * brokers.PaginatedWorkflowList model
 */
export interface BrokersPaginatedWorkflowList {
  data?: BrokersWorkflow[];
  pagination?: Pagination;
}

/**
 * Type of workflow
 */
export type BrokersWorkflowWorkflowType = typeof BrokersWorkflowWorkflowType[keyof typeof BrokersWorkflowWorkflowType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersWorkflowWorkflowType = {
  submission: 'submission',
  renewal: 'renewal',
  plan_change: 'plan_change',
  dependent_change: 'dependent_change',
  plan_change_and_dependent_change: 'plan_change_and_dependent_change',
  off_thatch: 'off_thatch',
  cancellation: 'cancellation',
  offboarding: 'offboarding',
  medicare: 'medicare',
} as const;

/**
 * Current workflow status
 */
export type BrokersWorkflowStatus = typeof BrokersWorkflowStatus[keyof typeof BrokersWorkflowStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersWorkflowStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  canceled: 'canceled',
  paused: 'paused',
} as const;

/**
 * Workflow metadata
 */
export type BrokersWorkflowMetadata = { [key: string]: unknown };

/**
 * Coverage type
 */
export type BrokersWorkflowEnrollmentInfoCoverageType = typeof BrokersWorkflowEnrollmentInfoCoverageType[keyof typeof BrokersWorkflowEnrollmentInfoCoverageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersWorkflowEnrollmentInfoCoverageType = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
} as const;

export type BrokersWorkflowEnrollmentInfo = {
  /** Member ID */
  member_id?: string;
  /** Plan year */
  plan_year?: number;
  /** Member name */
  member_name?: string;
  /** Carrier name */
  carrier_name?: string;
  /** Coverage type */
  coverage_type?: BrokersWorkflowEnrollmentInfoCoverageType;
  /** Employer ID */
  employer_id?: string;
  /** Employer name */
  employer_name?: string;
  /** Submitting Brokerage ID */
  submitting_brokerage_id?: string;
  /** Submitting Brokerage name */
  submitting_brokerage_name?: string;
};

/**
 * Source of the workflow (enrollment_event or qualifying_life_event)
 */
export type BrokersWorkflowSource = typeof BrokersWorkflowSource[keyof typeof BrokersWorkflowSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersWorkflowSource = {
  enrollment_event: 'enrollment_event',
  qualifying_life_event: 'qualifying_life_event',
} as const;

export type BrokersWorkflowAvailableActionsItem = typeof BrokersWorkflowAvailableActionsItem[keyof typeof BrokersWorkflowAvailableActionsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersWorkflowAvailableActionsItem = {
  start: 'start',
  complete: 'complete',
  cancel: 'cancel',
  pause: 'pause',
  resume: 'resume',
  reopen: 'reopen',
  rollback: 'rollback',
} as const;

/**
 * brokers.Workflow model
 */
export interface BrokersWorkflow {
  /** Workflow ID (persisted) or temporary preview ID (unpersisted) */
  id: string;
  /** Type of workflow */
  workflow_type: BrokersWorkflowWorkflowType;
  /** Current workflow status */
  status: BrokersWorkflowStatus;
  /** Associated enrollment ID */
  insurance_enrollment_id: string;
  /** Workflow metadata */
  metadata?: BrokersWorkflowMetadata;
  /** Total number of tasks in the workflow */
  task_count: number;
  /** Number of completed tasks */
  completed_task_count: number;
  /** Number of failed tasks */
  failed_task_count: number;
  /** Progress percentage (0-100) */
  progress_percentage: number;
  /** Summary of tasks in the workflow */
  tasks_summary?: BrokersTask[];
  enrollment_info?: BrokersWorkflowEnrollmentInfo;
  /** Workflow creation time */
  created_at: string;
  /** Workflow start time */
  started_at?: string;
  /** Workflow completion time */
  completed_at?: string;
  /** When the workflow was canceled */
  canceled_at?: string;
  /** Reason for workflow cancellation */
  cancellation_reason?: string;
  /** Source of the workflow (enrollment_event or qualifying_life_event) */
  source?: BrokersWorkflowSource;
  /** Coverage start date (processing deadline) based on actual enrollment coverages. For additions: earliest added participant's coverage start. For removals: earliest removal effective date. For mixed workflows: earliest of all relevant dates. */
  coverage_start_date?: string;
  brokers?: BrokersBroker[];
  enrollment_event?: BrokersEnrollmentEvent;
  /** Tasks that are 'next up' - pending, processing, or blocked by holds/external reasons (not dependencies) */
  next_up_tasks?: BrokersDependencyTaskSummary[];
  /** Available AASM state transition actions for current workflow state */
  available_actions?: BrokersWorkflowAvailableActionsItem[];
  qualifying_life_event?: BrokersQualifyingLifeEvent;
}

/**
 * Enrollment event type
 */
export type BrokersEnrollmentEventEnrollmentType = typeof BrokersEnrollmentEventEnrollmentType[keyof typeof BrokersEnrollmentEventEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokersEnrollmentEventEnrollmentType = {
  ichra_invite: 'ichra_invite',
  open_enrollment: 'open_enrollment',
  special_enrollment: 'special_enrollment',
} as const;

export interface BrokersEnrollmentEvent {
  /** Enrollment event type */
  enrollment_type?: BrokersEnrollmentEventEnrollmentType;
  /** Enrollment event subtype */
  enrollment_subtype?: string;
}

/**
 * Trigger workflow state transition
 */
export interface PostBrokersTaskWorkflowsIdAction {
  /** If true, evaluates task execution readiness (ensures fresh data). If false, uses simple status checks (faster but may be stale). */
  evaluate_readiness?: boolean;
  /** Reason for workflow cancellation (only used with 'cancel' action) */
  cancellation_reason?: string;
}

/**
 * Complete workflow metadata payload
 */
export type PatchBrokersTaskWorkflowsIdMetadataMetadata = { [key: string]: unknown };

/**
 * Manually update workflow metadata
 */
export interface PatchBrokersTaskWorkflowsIdMetadata {
  /** If true, evaluates task execution readiness (ensures fresh data). If false, uses simple status checks (faster but may be stale). */
  evaluate_readiness?: boolean;
  /** Complete workflow metadata payload */
  metadata: PatchBrokersTaskWorkflowsIdMetadataMetadata;
}

/**
 * AASM transition to apply
 */
export type PatchBrokersTaskWorkflowsTransition = typeof PatchBrokersTaskWorkflowsTransition[keyof typeof PatchBrokersTaskWorkflowsTransition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBrokersTaskWorkflowsTransition = {
  start: 'start',
  complete_workflow: 'complete_workflow',
  cancel_workflow: 'cancel_workflow',
  pause: 'pause',
  resume: 'resume',
  reopen_workflow: 'reopen_workflow',
} as const;

/**
 * Bulk update workflows with AASM transitions and broker assignments
 */
export interface PatchBrokersTaskWorkflows {
  /** IDs of workflows to update */
  workflow_ids: string[];
  /** AASM transition to apply */
  transition?: PatchBrokersTaskWorkflowsTransition;
  /** Reason for workflow cancellation (only used with 'cancel_workflow' transition) */
  cancellation_reason?: string;
  /** IDs of Brokers to add */
  broker_ids_to_add?: string[];
  /** IDs of Brokers to remove */
  broker_ids_to_remove?: string[];
  /** If true, reassign ALL manual tasks to workflow brokers (overriding explicit assignments) */
  force_reassign_all_tasks?: boolean;
}

/**
 * PayrollProviderConfigList model
 */
export interface PayrollProviderConfigList {
  data?: PayrollProviderConfig[];
}

/**
 * quoting.PaginatedProspectList model
 */
export interface QuotingPaginatedProspectList {
  data?: QuotingProspect[];
  pagination?: Pagination;
}

/**
 * State
 * @nullable
 */
export type QuotingProspectState = typeof QuotingProspectState[keyof typeof QuotingProspectState] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingProspectState = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * Partner metadata
 * @nullable
 */
export type QuotingProspectPartnerMetadata = { [key: string]: unknown } | null;

/**
 * quoting.Prospect model
 */
export interface QuotingProspect {
  /** Prospect ID */
  id: string;
  /** Name */
  name: string;
  /** Email address */
  email?: string;
  /**
   * EIN
   * @nullable
   */
  ein?: string | null;
  /** Employee count */
  employee_count?: number;
  /** Estimated employee count in one year */
  estimated_employee_count_in_one_year?: number;
  /** Expected enrollment */
  expected_enrollment?: number;
  /**
   * External ID
   * @nullable
   */
  external_id?: string | null;
  /**
   * External link
   * @nullable
   */
  external_link?: string | null;
  /** Whether the prospect offers health insurance today */
  offers_health_insurance_today: boolean;
  /** Health insurance effective date */
  health_insurance_effective_date?: string;
  /**
   * Owner's user ID or partner ID
   * @nullable
   */
  owner_id?: string | null;
  /**
   * Owner Name or Email
   * @nullable
   */
  owner_name_or_email?: string | null;
  /**
   * Owner email
   * @nullable
   */
  owner_email?: string | null;
  /**
   * Business type
   * @nullable
   */
  business_type?: string | null;
  /**
   * DBA
   * @nullable
   */
  dba?: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone_number?: string | null;
  /**
   * ZIP
   * @nullable
   */
  zip?: string | null;
  /**
   * Address line 1
   * @nullable
   */
  address_line1?: string | null;
  /**
   * Address line 2
   * @nullable
   */
  address_line2?: string | null;
  /**
   * City
   * @nullable
   */
  city?: string | null;
  /**
   * State
   * @nullable
   */
  state?: QuotingProspectState;
  /**
   * Partner metadata
   * @nullable
   */
  partner_metadata?: QuotingProspectPartnerMetadata;
  /**
   * Suggested flat allowance amount based on employer preferences (in dollars)
   * @nullable
   */
  suggested_allowance_amount?: number | null;
  /** Whether the prospect has employees in multiple states */
  employees_in_multiple_states?: boolean;
  /** Creation datetime */
  created_at: string;
  /** Updated datetime */
  updated_at: string;
  /** Whether the prospect has a census */
  has_census?: boolean;
  /** Reasons for changing insurance */
  reasons_for_changing_insurance?: string[];
  /** Whether the prospect has employees in multiple states */
  census_employees_in_multiple_states?: boolean;
  /** Broker uploads */
  broker_uploads?: QuotingProspectBrokerUploadedDocument[];
  discount?: QuotingProspectDiscount;
}

export interface QuotingProspectBrokerUploadedDocument {
  /** Document ID */
  id: string;
  /** Document filename */
  filename: string;
  /** Document content type */
  content_type: string;
  /** Document size in bytes */
  byte_size: number;
  /** Document creation timestamp */
  created_at: string;
  /** URL to download the document */
  download_url: string;
  /** URL to view the document inline */
  view_url: string;
}

export interface QuotingProspectDiscount {
  /** Discount rate (0.5 = 50% off) */
  rate: number;
  /** Deadline to accept discount (ISO8601 timestamp) */
  deadline: string;
  /** Discount end date (ISO8601 timestamp) */
  end_date: string;
}

/**
 * State
 * @nullable
 */
export type PostQuotingProspectsState = typeof PostQuotingProspectsState[keyof typeof PostQuotingProspectsState] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsState = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * Business type
 */
export type PostQuotingProspectsBusinessType = typeof PostQuotingProspectsBusinessType[keyof typeof PostQuotingProspectsBusinessType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsBusinessType = {
  c_corp: 'c_corp',
  s_corp: 's_corp',
  llc: 'llc',
  llp: 'llp',
  partnership: 'partnership',
  sole_proprietorship: 'sole_proprietorship',
  non_profit: 'non_profit',
} as const;

/**
 * Partner metadata
 * @nullable
 */
export type PostQuotingProspectsPartnerMetadata = { [key: string]: unknown } | null;

export type PostQuotingProspectsReasonsForChangingInsuranceItem = typeof PostQuotingProspectsReasonsForChangingInsuranceItem[keyof typeof PostQuotingProspectsReasonsForChangingInsuranceItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsReasonsForChangingInsuranceItem = {
  make_employees_happier: 'make_employees_happier',
  avoid_rate_increases: 'avoid_rate_increases',
  best_benefits: 'best_benefits',
  visibility_control_of_healthcare_costs: 'visibility_control_of_healthcare_costs',
} as const;

/**
 * Create a prospect
 */
export interface PostQuotingProspects {
  /** Name */
  name: string;
  /**
   * Email
   * @nullable
   */
  email?: string | null;
  /**
   * Employee Count
   * @nullable
   */
  employee_count?: number | null;
  /**
   * Estimated employee count in one year
   * @nullable
   */
  estimated_employee_count_in_one_year?: number | null;
  /**
   * Expected Enrollment
   * @nullable
   */
  expected_enrollment?: number | null;
  /**
   * External ID
   * @nullable
   */
  external_id?: string | null;
  /**
   * External Link
   * @nullable
   */
  external_link?: string | null;
  /**
   * Employer Identification Number
   * @nullable
   */
  ein?: string | null;
  /**
   * When true, create/update relevant SFDC records for the prospect & referring partner.
   * @nullable
   */
  create_sfdc_records?: boolean | null;
  /**
   * When true and :create_sfdc_records is true, notify the sales team to quote this prospect.
   * @nullable
   */
  notify_sales?: boolean | null;
  /**
   * City
   * @nullable
   */
  city?: string | null;
  /**
   * State
   * @nullable
   */
  state?: PostQuotingProspectsState;
  /**
   * Does this company offer health insurance today?
   * @nullable
   */
  offers_health_insurance_today?: boolean | null;
  /**
   * If they do offer health insurance today, when did it go into effect?
   * @nullable
   */
  health_insurance_effective_date?: string | null;
  /** Business type */
  business_type?: PostQuotingProspectsBusinessType;
  /**
   * DBA
   * @nullable
   */
  dba?: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone_number?: string | null;
  /**
   * ZIP
   * @nullable
   */
  zip?: string | null;
  /**
   * Address line 1
   * @nullable
   */
  address_line1?: string | null;
  /**
   * Address line 2
   * @nullable
   */
  address_line2?: string | null;
  /**
   * Partner metadata
   * @nullable
   */
  partner_metadata?: PostQuotingProspectsPartnerMetadata;
  /** Reasons for changing insurance */
  reasons_for_changing_insurance?: PostQuotingProspectsReasonsForChangingInsuranceItem[];
  /**
   * Prospect has employees in multiple states
   * @nullable
   */
  employees_in_multiple_states?: boolean | null;
  /** Broker uploaded documents */
  broker_uploads?: string[];
}

/**
 * State
 * @nullable
 */
export type PutQuotingProspectsIdState = typeof PutQuotingProspectsIdState[keyof typeof PutQuotingProspectsIdState] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutQuotingProspectsIdState = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * Business type
 */
export type PutQuotingProspectsIdBusinessType = typeof PutQuotingProspectsIdBusinessType[keyof typeof PutQuotingProspectsIdBusinessType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutQuotingProspectsIdBusinessType = {
  c_corp: 'c_corp',
  s_corp: 's_corp',
  llc: 'llc',
  llp: 'llp',
  partnership: 'partnership',
  sole_proprietorship: 'sole_proprietorship',
  non_profit: 'non_profit',
} as const;

/**
 * Partner metadata
 * @nullable
 */
export type PutQuotingProspectsIdPartnerMetadata = { [key: string]: unknown } | null;

export type PutQuotingProspectsIdReasonsForChangingInsuranceItem = typeof PutQuotingProspectsIdReasonsForChangingInsuranceItem[keyof typeof PutQuotingProspectsIdReasonsForChangingInsuranceItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutQuotingProspectsIdReasonsForChangingInsuranceItem = {
  make_employees_happier: 'make_employees_happier',
  avoid_rate_increases: 'avoid_rate_increases',
  best_benefits: 'best_benefits',
  visibility_control_of_healthcare_costs: 'visibility_control_of_healthcare_costs',
} as const;

/**
 * Update a prospect
 */
export interface PutQuotingProspectsId {
  /** Name */
  name?: string;
  /**
   * Email
   * @nullable
   */
  email?: string | null;
  /**
   * Employee Count
   * @nullable
   */
  employee_count?: number | null;
  /**
   * Estimated employee count in one year
   * @nullable
   */
  estimated_employee_count_in_one_year?: number | null;
  /**
   * Expected Enrollment
   * @nullable
   */
  expected_enrollment?: number | null;
  /**
   * External ID
   * @nullable
   */
  external_id?: string | null;
  /**
   * External Link
   * @nullable
   */
  external_link?: string | null;
  /**
   * Employer Identification Number
   * @nullable
   */
  ein?: string | null;
  /**
   * When true, create/update relevant SFDC records for the prospect & referring partner.
   * @nullable
   */
  create_sfdc_records?: boolean | null;
  /**
   * When true and :create_sfdc_records is true, notify the sales team to quote this prospect.
   * @nullable
   */
  notify_sales?: boolean | null;
  /**
   * City
   * @nullable
   */
  city?: string | null;
  /**
   * State
   * @nullable
   */
  state?: PutQuotingProspectsIdState;
  /**
   * Does this company offer health insurance today?
   * @nullable
   */
  offers_health_insurance_today?: boolean | null;
  /**
   * If they do offer health insurance today, when did it go into effect?
   * @nullable
   */
  health_insurance_effective_date?: string | null;
  /** Business type */
  business_type?: PutQuotingProspectsIdBusinessType;
  /**
   * DBA
   * @nullable
   */
  dba?: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone_number?: string | null;
  /**
   * ZIP
   * @nullable
   */
  zip?: string | null;
  /**
   * Address line 1
   * @nullable
   */
  address_line1?: string | null;
  /**
   * Address line 2
   * @nullable
   */
  address_line2?: string | null;
  /**
   * Partner metadata
   * @nullable
   */
  partner_metadata?: PutQuotingProspectsIdPartnerMetadata;
  /** Reasons for changing insurance */
  reasons_for_changing_insurance?: PutQuotingProspectsIdReasonsForChangingInsuranceItem[];
  /**
   * Prospect has employees in multiple states
   * @nullable
   */
  employees_in_multiple_states?: boolean | null;
  /** Broker uploaded documents */
  broker_uploads?: string[];
  /** Archived */
  archived?: boolean;
}

/**
 * quoting.PaginatedQuoteList model
 */
export interface QuotingPaginatedQuoteList {
  data?: QuotingQuote[];
  pagination?: Pagination;
}

/**
 * Benchmark
 */
export type PostQuotingProspectsProspectIdQuotesBenchmark = typeof PostQuotingProspectsProspectIdQuotesBenchmark[keyof typeof PostQuotingProspectsProspectIdQuotesBenchmark];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesBenchmark = {
  all_plans_silver_plus: 'all_plans_silver_plus',
  on_thatch_bronze: 'on_thatch_bronze',
  on_thatch_silver: 'on_thatch_silver',
  on_thatch_gold: 'on_thatch_gold',
  on_thatch_platinum: 'on_thatch_platinum',
  score_tier_0: 'score_tier_0',
  score_tier_1: 'score_tier_1',
  score_tier_2: 'score_tier_2',
  score_tier_3: 'score_tier_3',
} as const;

/**
 * Quote type
 */
export type PostQuotingProspectsProspectIdQuotesQuoteType = typeof PostQuotingProspectsProspectIdQuotesQuoteType[keyof typeof PostQuotingProspectsProspectIdQuotesQuoteType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesQuoteType = {
  public_tool: 'public_tool',
  internal_tool: 'internal_tool',
  quoting_v2: 'quoting_v2',
  self_serve_tool: 'self_serve_tool',
  renewal: 'renewal',
} as const;

/**
 * Affordability strategy
 */
export type PostQuotingProspectsProspectIdQuotesAffordabilityStrategy = typeof PostQuotingProspectsProspectIdQuotesAffordabilityStrategy[keyof typeof PostQuotingProspectsProspectIdQuotesAffordabilityStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesAffordabilityStrategy = {
  floor_mec: 'floor_mec',
  individual_mec: 'individual_mec',
} as const;

/**
 * Create a quote
 */
export interface PostQuotingProspectsProspectIdQuotes {
  /** Benchmark */
  benchmark?: PostQuotingProspectsProspectIdQuotesBenchmark;
  /**
   * Coverage percentile
   * @minimum 0
   * @maximum 100
   */
  coverage_percentile?: number;
  /** Employee multiplier */
  employee_multiplier?: number;
  /** First dependent multiplier */
  first_dependent_multiplier?: number;
  /** Additional dependent multiplier */
  additional_dependent_multiplier?: number;
  /** Prospect employee census ID used for the quote */
  quoting_prospect_employee_census_id?: string;
  /** Quote type */
  quote_type?: PostQuotingProspectsProspectIdQuotesQuoteType;
  /** Quote name */
  name?: string;
  /** Coverage start date */
  coverage_start_date?: string;
  /** Affordability strategy */
  affordability_strategy?: PostQuotingProspectsProspectIdQuotesAffordabilityStrategy;
}

/**
 * Notify Slack about large self-serve opportunity
 */
export interface PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity {
  /** Number of employees */
  employee_count: number;
}

export type QuotingQuoteGenerationOptionsMetalTiersItem = typeof QuotingQuoteGenerationOptionsMetalTiersItem[keyof typeof QuotingQuoteGenerationOptionsMetalTiersItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteGenerationOptionsMetalTiersItem = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
} as const;

/**
 * quoting.QuoteGenerationOptions model
 */
export interface QuotingQuoteGenerationOptions {
  /** Coverage percentiles */
  coverage_percentiles: number[];
  /** Coverage start date */
  coverage_start_date: string;
  /** Metal tiers */
  metal_tiers: QuotingQuoteGenerationOptionsMetalTiersItem[];
  /** Year */
  quote_year: number;
}

export type PostQuotingProspectsProspectIdQuotesIdGenerateMetalTiersItem = typeof PostQuotingProspectsProspectIdQuotesIdGenerateMetalTiersItem[keyof typeof PostQuotingProspectsProspectIdQuotesIdGenerateMetalTiersItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesIdGenerateMetalTiersItem = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
  all_plans_silver_plus: 'all_plans_silver_plus',
} as const;

/**
 * Affordability strategy
 */
export type PostQuotingProspectsProspectIdQuotesIdGenerateAffordabilityStrategy = typeof PostQuotingProspectsProspectIdQuotesIdGenerateAffordabilityStrategy[keyof typeof PostQuotingProspectsProspectIdQuotesIdGenerateAffordabilityStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesIdGenerateAffordabilityStrategy = {
  floor_mec: 'floor_mec',
  individual_mec: 'individual_mec',
} as const;

/**
 * Generate a quote
 */
export interface PostQuotingProspectsProspectIdQuotesIdGenerate {
  /** Metal tiers to run quotes with (required for dynamic allowances) */
  metal_tiers?: PostQuotingProspectsProspectIdQuotesIdGenerateMetalTiersItem[];
  /** Coverage percentiles to run quotes with (required for dynamic allowances) */
  coverage_percentiles?: number[];
  /** Coverage start date to be used to calculate employee ages */
  coverage_start_date: string;
  /** Year to be used to get plan years */
  year?: number;
  /** Affordability strategy */
  affordability_strategy?: PostQuotingProspectsProspectIdQuotesIdGenerateAffordabilityStrategy;
}

/**
 * Benchmark
 */
export type PatchQuotingProspectsProspectIdQuotesIdBenchmark = typeof PatchQuotingProspectsProspectIdQuotesIdBenchmark[keyof typeof PatchQuotingProspectsProspectIdQuotesIdBenchmark];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchQuotingProspectsProspectIdQuotesIdBenchmark = {
  all_plans_silver_plus: 'all_plans_silver_plus',
  on_thatch_bronze: 'on_thatch_bronze',
  on_thatch_silver: 'on_thatch_silver',
  on_thatch_gold: 'on_thatch_gold',
  on_thatch_platinum: 'on_thatch_platinum',
  score_tier_0: 'score_tier_0',
  score_tier_1: 'score_tier_1',
  score_tier_2: 'score_tier_2',
  score_tier_3: 'score_tier_3',
} as const;

/**
 * Quote type
 */
export type PatchQuotingProspectsProspectIdQuotesIdQuoteType = typeof PatchQuotingProspectsProspectIdQuotesIdQuoteType[keyof typeof PatchQuotingProspectsProspectIdQuotesIdQuoteType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchQuotingProspectsProspectIdQuotesIdQuoteType = {
  public_tool: 'public_tool',
  internal_tool: 'internal_tool',
  quoting_v2: 'quoting_v2',
  self_serve_tool: 'self_serve_tool',
  renewal: 'renewal',
} as const;

/**
 * Affordability strategy
 */
export type PatchQuotingProspectsProspectIdQuotesIdAffordabilityStrategy = typeof PatchQuotingProspectsProspectIdQuotesIdAffordabilityStrategy[keyof typeof PatchQuotingProspectsProspectIdQuotesIdAffordabilityStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchQuotingProspectsProspectIdQuotesIdAffordabilityStrategy = {
  floor_mec: 'floor_mec',
  individual_mec: 'individual_mec',
} as const;

/**
 * Partially update a quote
 */
export interface PatchQuotingProspectsProspectIdQuotesId {
  /** Benchmark */
  benchmark?: PatchQuotingProspectsProspectIdQuotesIdBenchmark;
  /**
   * Coverage percentile
   * @minimum 0
   * @maximum 100
   */
  coverage_percentile?: number;
  /** Employee multiplier */
  employee_multiplier?: number;
  /** First dependent multiplier */
  first_dependent_multiplier?: number;
  /** Additional dependent multiplier */
  additional_dependent_multiplier?: number;
  /** Prospect employee census ID used for the quote */
  quoting_prospect_employee_census_id?: string;
  /** Quote type */
  quote_type?: PatchQuotingProspectsProspectIdQuotesIdQuoteType;
  /** Quote name */
  name?: string;
  /** Coverage start date */
  coverage_start_date?: string;
  /** Affordability strategy */
  affordability_strategy?: PatchQuotingProspectsProspectIdQuotesIdAffordabilityStrategy;
}

/**
 * Generate Benchmarks
 */
export interface PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks {
  /** Deductible for benchmark */
  target_individual_deductible: number;
  /** Out of pocket max for benchmark */
  target_individual_oop_max: number;
  /** Network type for benchmark */
  target_network_type?: string;
  /** Metal level for benchmark */
  target_metal_tier?: string;
  /** Coverage start date (to be used to calculate employee age) for the benchmark */
  coverage_start_date: string;
  /** Year (to be used to get the plans) for the benchmark */
  year?: string;
}

/**
 * Location type
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassLocationType = typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassLocationType[keyof typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassLocationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassLocationType = {
  rating_area: 'rating_area',
  state: 'state',
} as const;

/**
 * Employment type
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassEmploymentType = typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassEmploymentType[keyof typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassEmploymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassEmploymentType = {
  part_time: 'part_time',
  full_time: 'full_time',
} as const;

/**
 * Pay type
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassPayType = typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassPayType[keyof typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassPayType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassPayType = {
  hourly: 'hourly',
  salary: 'salary',
} as const;

/**
 * Allowance class
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClass = {
  /** Location type */
  location_type?: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassLocationType;
  /** Location ID */
  location_id?: string;
  /** Employment type */
  employment_type?: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassEmploymentType;
  /** Pay type */
  pay_type?: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClassPayType;
  /** Max age */
  max_age?: number;
  /** Min age */
  min_age?: number;
};

/**
 * Benchmark
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemDynamicConfigBenchmark = typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemDynamicConfigBenchmark[keyof typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemDynamicConfigBenchmark];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemDynamicConfigBenchmark = {
  all_plans_silver_plus: 'all_plans_silver_plus',
  on_thatch_bronze: 'on_thatch_bronze',
  on_thatch_silver: 'on_thatch_silver',
  on_thatch_gold: 'on_thatch_gold',
  on_thatch_platinum: 'on_thatch_platinum',
  score_tier_0: 'score_tier_0',
  score_tier_1: 'score_tier_1',
  score_tier_2: 'score_tier_2',
  score_tier_3: 'score_tier_3',
} as const;

/**
 * Dynamic allowance config
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemDynamicConfig = {
  /**
   * Coverage percentile
   * @minimum 0
   * @maximum 100
   */
  coverage_percentile: number;
  /** Benchmark */
  benchmark: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemDynamicConfigBenchmark;
  /**
   * Employee contribution percentage
   * @minimum 0
   * @maximum 100
   */
  employee_contribution_percentage: number;
  /**
   * Spouse contribution percentage
   * @minimum 0
   * @maximum 100
   */
  spouse_contribution_percentage: number;
  /**
   * Dependent contribution percentage
   * @minimum 0
   * @maximum 200
   */
  dependent_contribution_percentage: number;
};

/**
 * Flat allowance config
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemFlatConfig = {
  /** Employee amount */
  employee_amount: number;
  /** Spouse amount */
  spouse_amount: number;
  /** Dependent amount */
  dependent_amount: number;
  /** Max dependent count */
  max_dependent_count: number;
};

/**
 * QME treatment
 */
export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemQmeTreatment = typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemQmeTreatment[keyof typeof PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemQmeTreatment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemQmeTreatment = {
  all_allowed: 'all_allowed',
  disabled: 'disabled',
  copay_only: 'copay_only',
} as const;

export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItem = {
  /** Allowance class */
  class?: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemClass;
  /** Dynamic allowance config */
  dynamic_config?: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemDynamicConfig;
  /** Flat allowance config */
  flat_config?: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemFlatConfig;
  /** QME treatment */
  qme_treatment?: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItemQmeTreatment;
};

/**
 * Create Allowances
 */
export interface PostQuotingProspectsProspectIdQuotesQuoteIdAllowances {
  /** List of allowances */
  allowances: PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesAllowancesItem[];
  /** Remove existing allowances for the quote */
  remove_existing?: boolean;
}

/**
 * quoting.PaginatedEmployeeCensusList model
 */
export interface QuotingPaginatedEmployeeCensusList {
  data?: QuotingEmployeeCensus[];
  pagination?: Pagination;
}

/**
 * Parser format
 */
export type QuotingEmployeeCensusFormat = typeof QuotingEmployeeCensusFormat[keyof typeof QuotingEmployeeCensusFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingEmployeeCensusFormat = {
  rippling: 'rippling',
  generic: 'generic',
  manual_entry: 'manual_entry',
} as const;

/**
 * quoting.EmployeeCensus model
 */
export interface QuotingEmployeeCensus {
  /** Employee Census ID */
  id: string;
  /** File name */
  file_name: string;
  /** Parser format */
  format: QuotingEmployeeCensusFormat;
  /** Parsing errors */
  parsing_errors?: string[];
  /** Parsing status */
  status: string;
  /** Created at */
  created_at: string;
  /** Updated at */
  updated_at: string;
  /** Prospect ID associated with this census */
  quoting_prospect_id: string;
  /** File size in bytes, if the census came from an uploaded CSV file. */
  file_size?: number;
  /** URL to download the file */
  file_url?: string;
}

/**
 * quoting.PaginatedEmployeeList model
 */
export interface QuotingPaginatedEmployeeList {
  data?: QuotingEmployee[];
  pagination?: Pagination;
}

/**
 * quoting.Employee model
 */
export interface QuotingEmployee {
  /** Prospect Employee ID */
  id: string;
  /** Employee name */
  name?: string;
  /** Employee first name */
  first_name?: string;
  /** Employee last name */
  last_name?: string;
  /** Employee date of birth */
  date_of_birth: string;
  /** Employee ZIP code */
  zip: string;
  /** Employee rating area code */
  rating_area_code: string;
  /** Dependents */
  dependents: QuotingDependent[];
  /** Employee medical contribution */
  employee_medical_contribution?: number;
  /** Employer medical contribution */
  employer_medical_contribution?: number;
  /** Individual deductible amount */
  individual_deductible?: number;
  /** Pay rate in case the employee is paid hourly */
  pay_rate?: number;
  /** Employee's pay type: hourly or salary */
  pay_type?: string;
  /** Salary of the employee in case they are paid with a salary */
  yearly_pay?: number;
  /** Employee email */
  email?: string;
  /** Whether the employee is eligible for benefits */
  eligible: boolean;
}

/**
 * Dependent relationship type
 */
export type QuotingDependentRelationship = typeof QuotingDependentRelationship[keyof typeof QuotingDependentRelationship];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingDependentRelationship = {
  spouse: 'spouse',
  child: 'child',
  self: 'self',
} as const;

export interface QuotingDependent {
  /** Dependent relationship type */
  relationship: QuotingDependentRelationship;
  /** Dependent date of birth */
  date_of_birth: string;
}

export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesDependentsItem = {
  /** Dependent relationship */
  relationship: string;
  /** Dependent date of birth */
  date_of_birth: string;
};

/**
 * Employee status
 */
export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesStatus = typeof PostQuotingProspectsProspectIdCensusCensusIdEmployeesStatus[keyof typeof PostQuotingProspectsProspectIdCensusCensusIdEmployeesStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdCensusCensusIdEmployeesStatus = {
  draft: 'draft',
  finalized: 'finalized',
} as const;

/**
 * Create an employee
 */
export interface PostQuotingProspectsProspectIdCensusCensusIdEmployees {
  /** Employee name */
  name?: string;
  /** Employee first name */
  first_name?: string;
  /** Employee last name */
  last_name?: string;
  /** Employee work email */
  work_email?: string;
  /** Employee personal email */
  personal_email?: string;
  /** Employee date of birth */
  date_of_birth?: string;
  /** Employee zip code */
  zip?: string;
  dependents?: PostQuotingProspectsProspectIdCensusCensusIdEmployeesDependentsItem[];
  /** Employee medical contribution */
  employee_medical_contribution?: number;
  /** Employer medical contribution */
  employer_medical_contribution?: number;
  /** Individual deductible amount */
  individual_deductible?: number;
  /** Pay rate in case the employee is paid hourly */
  pay_rate?: number;
  /** Employee's pay type: hourly or salary */
  pay_type?: string;
  /** Salary of the employee in case they are paid with a salary */
  yearly_pay?: number;
  /** Whether the employee is eligible for benefits */
  eligible?: boolean;
  /** Employee status */
  status?: PostQuotingProspectsProspectIdCensusCensusIdEmployeesStatus;
}

export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItemDependentsItem = {
  /** Dependent relationship */
  relationship: string;
  /** Dependent date of birth */
  date_of_birth: string;
};

/**
 * Employee status
 */
export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItemStatus = typeof PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItemStatus[keyof typeof PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItemStatus = {
  draft: 'draft',
  finalized: 'finalized',
} as const;

export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItem = {
  /** Employee name */
  name?: string;
  /** Employee first name */
  first_name?: string;
  /** Employee last name */
  last_name?: string;
  /** Employee work email */
  work_email?: string;
  /** Employee personal email */
  personal_email?: string;
  /** Employee date of birth */
  date_of_birth?: string;
  /** Employee zip code */
  zip?: string;
  dependents?: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItemDependentsItem[];
  /** Employee medical contribution */
  employee_medical_contribution?: number;
  /** Employer medical contribution */
  employer_medical_contribution?: number;
  /** Individual deductible amount */
  individual_deductible?: number;
  /** Pay rate in case the employee is paid hourly */
  pay_rate?: number;
  /** Employee's pay type: hourly or salary */
  pay_type?: string;
  /** Salary of the employee in case they are paid with a salary */
  yearly_pay?: number;
  /** Whether the employee is eligible for benefits */
  eligible?: boolean;
  /** Employee status */
  status?: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItemStatus;
};

/**
 * Bulk create employees
 */
export interface PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate {
  employees: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateEmployeesItem[];
  /** Overwrite existing employees */
  overwrite_existing?: boolean;
}

export type PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdDependentsItem = {
  /** Dependent relationship */
  relationship: string;
  /** Dependent date of birth */
  date_of_birth: string;
};

/**
 * Employee status
 */
export type PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdStatus = typeof PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdStatus[keyof typeof PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdStatus = {
  draft: 'draft',
  finalized: 'finalized',
} as const;

/**
 * Update an employee
 */
export interface PutQuotingProspectsProspectIdCensusCensusIdEmployeesId {
  /** Employee name */
  name?: string;
  /** Employee first name */
  first_name?: string;
  /** Employee last name */
  last_name?: string;
  /** Employee work email */
  work_email?: string;
  /** Employee personal email */
  personal_email?: string;
  /** Employee date of birth */
  date_of_birth?: string;
  /** Employee zip code */
  zip?: string;
  dependents?: PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdDependentsItem[];
  /** Employee medical contribution */
  employee_medical_contribution?: number;
  /** Employer medical contribution */
  employer_medical_contribution?: number;
  /** Individual deductible amount */
  individual_deductible?: number;
  /** Pay rate in case the employee is paid hourly */
  pay_rate?: number;
  /** Employee's pay type: hourly or salary */
  pay_type?: string;
  /** Salary of the employee in case they are paid with a salary */
  yearly_pay?: number;
  /** Whether the employee is eligible for benefits */
  eligible?: boolean;
  /** Employee status */
  status?: PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdStatus;
}

/**
 * Map of prospect_employee_id => array of dependents (relationship, date_of_birth)
 */
export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsUpdatesByEmployeeId = { [key: string]: unknown };

/**
 * Bulk replace dependents for prospect employees
 */
export interface PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents {
  /** Map of prospect_employee_id => array of dependents (relationship, date_of_birth) */
  updates_by_employee_id: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsUpdatesByEmployeeId;
}

/**
 * The pay type of the Quoting::ProspectEmployee
 */
export type QuotingQuoteResultPayType = typeof QuotingQuoteResultPayType[keyof typeof QuotingQuoteResultPayType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuotingQuoteResultPayType = {
  hourly: 'hourly',
  salary: 'salary',
} as const;

/**
 * quoting.QuoteResult model
 */
export interface QuotingQuoteResult {
  /** The ID of the Quoting::ProspectEmployee */
  id: string;
  /** The name of the Quoting::ProspectEmployee */
  name: string;
  /** The date of birth of the Quoting::ProspectEmployee */
  date_of_birth: string;
  /** The array of dependents for the Quoting::ProspectEmployee */
  dependents: QuotingDependent[];
  /** The rating area code of the Quoting::ProspectEmployee */
  rating_area_code: string;
  /** The zip code of the Quoting::ProspectEmployee */
  zip: string;
  /** The employee's current monthly medical contribution */
  employee_medical_contribution: number;
  /** The employer's monthly medical contribution */
  employer_medical_contribution: number;
  /** The pay type of the Quoting::ProspectEmployee */
  pay_type: QuotingQuoteResultPayType;
  /** The estimated employee's monthly allowance for the generated quote */
  employee_allowance: number;
  /** The minimum employer contribution required to make the plan affordable for employee */
  min_employer_contribution: number;
  /** Individual deductible amount */
  individual_deductible?: number;
  medical_plan?: QuotingMedicalPlan;
  /** Whether the employee is eligible for benefits */
  eligible: boolean;
}

export interface QuotingMedicalPlan {
  /** The ID of the MedicalPlan */
  id: string;
  /** The name of the carrier */
  carrier_name: string;
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** The name of the plan */
  plan_name: string;
  /** The monthly premium of the plan */
  monthly_premium: number;
}

/**
 * Share the Quote with an individual
 */
export interface PostQuotingQuoteResultsQuoteIdInvite { [key: string]: unknown }

/**
 * resource_access_tokens.InvitationResult model
 */
export interface ResourceAccessTokensInvitationResult {
  access_token: ResourceAccessTokensResourceAccessToken;
  recipient: ResourceAccessTokensResourceAccessTokenRecipient;
  /** The email used by Thatch for the email invite */
  from_email: string;
}

/**
 * Status
 */
export type ResourceAccessTokensResourceAccessTokenStatus = typeof ResourceAccessTokensResourceAccessTokenStatus[keyof typeof ResourceAccessTokensResourceAccessTokenStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResourceAccessTokensResourceAccessTokenStatus = {
  revoked: 'revoked',
  redeemed: 'redeemed',
  expired: 'expired',
  unredeemed: 'unredeemed',
} as const;

export type ResourceAccessTokensResourceAccessTokenAbilitiesItem = typeof ResourceAccessTokensResourceAccessTokenAbilitiesItem[keyof typeof ResourceAccessTokensResourceAccessTokenAbilitiesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResourceAccessTokensResourceAccessTokenAbilitiesItem = {
  view: 'view',
  edit: 'edit',
  onboard: 'onboard',
} as const;

/**
 * resource_access_tokens.ResourceAccessToken model
 */
export interface ResourceAccessTokensResourceAccessToken {
  /** ID of the token */
  id: string;
  /** ID of the resource that the token is for */
  resource_id: string;
  /** Type of the resource that the token is for */
  resource_type: string;
  /** Status */
  status: ResourceAccessTokensResourceAccessTokenStatus;
  /** Abilities available to the token */
  abilities: ResourceAccessTokensResourceAccessTokenAbilitiesItem[];
  /** Email of the person who created the token */
  created_by_email: string;
  /** Timestamp of when the token expires */
  expires_at: string;
  /** Timestamp of when the token was redeemed */
  redeemed_at?: string;
  /** IP address of the person who redeemed the token */
  redeemed_by_ip?: string;
  /** User agent of the person who redeemed the token */
  redeemed_by_user_agent?: string;
  /** Geo location of the person who redeemed the token */
  redeemed_by_geo_location?: string;
  /** Timestamp of when the token was created */
  created_at: string;
}

/**
 * resource_access_tokens.ResourceAccessTokenRecipient model
 */
export interface ResourceAccessTokensResourceAccessTokenRecipient {
  /** ID */
  id: string;
  /** Email */
  email: string;
  /** Name */
  name?: string;
  /** The tokens that have been created for this recipient (scoped to the requested resource if provided) */
  tokens: ResourceAccessTokensResourceAccessToken[];
}

/**
 * quoting.RecommendedQuoteResults model
 */
export interface QuotingRecommendedQuoteResults {
  lowest_cost?: QuotingQuoteResultWithBenchmark;
  best_fit?: QuotingQuoteResultWithBenchmark;
  better_benefits?: QuotingQuoteResultWithBenchmark;
}

export interface QuotingQuoteResultWithBenchmark {
  benchmark?: QuotingSuggestedBenchmark;
  /** Quote results for this coverage level */
  quote_results: QuotingQuoteResult[];
}

export interface QuotingSuggestedBenchmark {
  /** Metal tier of the benchmark */
  metal_tier: string;
  /** Coverage percentile of the benchmark */
  coverage_percentile: string;
}

/**
 * Mapping of carrier names to their icon URLs
 */
export type QuotingPlanAvailabilityCarrierIcons = { [key: string]: unknown };

/**
 * quoting.PlanAvailability model
 */
export interface QuotingPlanAvailability {
  /** The rating area code */
  rating_area_code: string;
  /** List of carriers available in this rating area */
  carriers: string[];
  /** Mapping of carrier names to their icon URLs */
  carrier_icons: QuotingPlanAvailabilityCarrierIcons;
  plan_counts: QuotingPlanCounts;
}

export interface QuotingPlanCounts {
  /** Number of EPO plans */
  epo: number;
  /** Number of HMO plans */
  hmo: number;
  /** Number of POS plans */
  pos: number;
  /** Number of PPO plans */
  ppo: number;
}

/**
 * quoting.MedicalPlanDisplayItem model
 */
export interface QuotingMedicalPlanDisplayItem {
  /** Array of medical plan display items */
  plan_items: MemberOnboardingMedicalPlanDisplayItem[];
  /** Whether projected premiums are being used for these plans */
  use_projected_premiums: boolean;
}

/**
 * In network providers verification task status
 */
export type MemberOnboardingMedicalPlanDisplayItemInNetworkVerificationProgressStatus = typeof MemberOnboardingMedicalPlanDisplayItemInNetworkVerificationProgressStatus[keyof typeof MemberOnboardingMedicalPlanDisplayItemInNetworkVerificationProgressStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMedicalPlanDisplayItemInNetworkVerificationProgressStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  done: 'done',
} as const;

export interface MemberOnboardingMedicalPlanDisplayItem {
  plan: MemberOnboardingMedicalPlan;
  total_premium: Money;
  original_premium?: Money;
  monthly_premium?: Money;
  tiered_allowance_remaining_budget?: Money;
  tiered_allowance_employer_pays?: Money;
  tiered_allowance_employee_pays?: Money;
  tiered_allowance_employee_only_premium?: Money;
  /** Provider in network map */
  provider_in_network_map?: MemberOnboardingProviderInNetworkMap[];
  /** In network providers count */
  in_network_providers_count?: number;
  /** In network providers verification task status */
  in_network_verification_progress_status: MemberOnboardingMedicalPlanDisplayItemInNetworkVerificationProgressStatus;
}

/**
 * Metal tier of the plan. Valid values: catastrophic, bronze, expanded_bronze, silver, gold, platinum
 */
export type MemberOnboardingMedicalPlanMetalTier = typeof MemberOnboardingMedicalPlanMetalTier[keyof typeof MemberOnboardingMedicalPlanMetalTier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMedicalPlanMetalTier = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
} as const;

/**
 * Type of plan. Valid values: hmo, ppo, epo, pos
 */
export type MemberOnboardingMedicalPlanPlanType = typeof MemberOnboardingMedicalPlanPlanType[keyof typeof MemberOnboardingMedicalPlanPlanType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMedicalPlanPlanType = {
  hmo: 'hmo',
  ppo: 'ppo',
  epo: 'epo',
  pos: 'pos',
} as const;

export interface MemberOnboardingMedicalPlan {
  /** Unique identifier for the plan */
  id: string;
  /** Actuarial value of the plan as a percentage (0.00-100.00) */
  actuarial_value?: number;
  /** Name of the insurance carrier */
  carrier_name: string;
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** The URL of the carrier icon */
  carrier_icon_url?: string;
  /** Actuarial value of the plan as a percentage (0.00-100.00), or estimate if not available */
  computed_actuarial_value: number;
  /** Display name of the plan */
  display_name: string;
  /** User-friendly name of the plan */
  friendly_name: string;
  /** Metal tier of the plan. Valid values: catastrophic, bronze, expanded_bronze, silver, gold, platinum */
  metal_tier: MemberOnboardingMedicalPlanMetalTier;
  /** Type of plan. Valid values: hmo, ppo, epo, pos */
  plan_type: MemberOnboardingMedicalPlanPlanType;
  /** Name of the network */
  network_name?: string;
  /** Whether the plan is HSA eligible */
  hsa_eligible: boolean;
  /** Link to the summary of benefits and coverage for this plan */
  sbc_url?: string;
  /** Link to the provider support page for this plan */
  provider_support_link?: string;
  /** Individual medical deductible */
  individual_medical_deductible: string;
  /** Individual drug deductible */
  individual_drug_deductible?: string;
  /** Family medical deductible */
  family_medical_deductible: string;
  /** Family drug deductible */
  family_drug_deductible?: string;
  /** Individual medical out-of-pocket maximum */
  individual_medical_moop: string;
  /** Individual drug out-of-pocket maximum */
  individual_drug_moop?: string;
  /** Family medical out-of-pocket maximum */
  family_medical_moop: string;
  /** Family drug out-of-pocket maximum */
  family_drug_moop?: string;
  /** Preventive care benefit */
  preventative_care_benefit?: string;
  /** Primary care physician benefit */
  primary_care_physician_benefit?: string;
  /** Specialist benefit */
  specialist_benefit?: string;
  /** Generic drugs benefit */
  generic_drugs_benefit?: string;
  /** Preferred brand drugs benefit */
  preferred_brand_drugs_benefit?: string;
  /** Non-preferred brand drugs benefit */
  non_preferred_brand_drugs_benefit?: string;
  /** Specialty drugs benefit */
  specialty_drugs_benefit?: string;
  /** Urgent care benefit */
  urgent_care_benefit?: string;
  /** Emergency room benefit */
  emergency_room_benefit?: string;
  /** Ambulance benefit */
  ambulance_benefit?: string;
  /** Outpatient ambulatory care center benefit */
  outpatient_ambulatory_care_center_benefit?: string;
  /** Outpatient facility benefit */
  outpatient_facility_benefit?: string;
  /** Outpatient physician benefit */
  outpatient_physician_benefit?: string;
  /** Inpatient facility benefit */
  inpatient_facility_benefit?: string;
  /** Inpatient physician benefit */
  inpatient_physician_benefit?: string;
  /** Skilled nursing benefit */
  skilled_nursing_benefit?: string;
  /** Home health care benefit */
  home_health_care_benefit?: string;
  /** Hospice service benefit */
  hospice_service_benefit?: string;
  /** Child dental benefit */
  child_dental_benefit?: string;
  /** Child eye exam benefit */
  child_eye_exam_benefit?: string;
  /** Child eyewear benefit */
  child_eyewear_benefit?: string;
  /** Diagnostic test benefit */
  diagnostic_test_benefit?: string;
  /** Lab test benefit */
  lab_test_benefit?: string;
  /** Imaging benefit */
  imaging_benefit?: string;
  /** Imaging physician benefit */
  imaging_physician_benefit?: string;
  /** Durable medical equipment benefit */
  durable_medical_equipment_benefit?: string;
  /** Outpatient mental health benefit */
  outpatient_mental_health_benefit?: string;
  /** Inpatient mental health benefit */
  inpatient_mental_health_benefit?: string;
  /** Outpatient substance care benefit */
  outpatient_substance_benefit?: string;
  /** Inpatient substance care benefit */
  inpatient_substance_benefit?: string;
  /** Inpatient birth benefit */
  inpatient_birth_benefit?: string;
  /** Inpatient birth physician benefit */
  inpatient_birth_physician_benefit?: string;
  /** Prenatal care benefit */
  prenatal_care_benefit?: string;
  /** Postnatal care benefit */
  postnatal_care_benefit?: string;
  /** Rehabilitation services benefit */
  rehabilitation_services_benefit?: string;
  /** Habilitation services benefit */
  habilitation_services_benefit?: string;
}

/**
 * If the provider is in network
 */
export type MemberOnboardingProviderInNetworkMapInNetwork = typeof MemberOnboardingProviderInNetworkMapInNetwork[keyof typeof MemberOnboardingProviderInNetworkMapInNetwork];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingProviderInNetworkMapInNetwork = {
  IN_NETWORK: 'IN_NETWORK',
  OUT_OF_NETWORK: 'OUT_OF_NETWORK',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface MemberOnboardingProviderInNetworkMap {
  /** Provider npi */
  npi: number;
  /** Provider name */
  name: string;
  /** If the provider is in network */
  in_network: MemberOnboardingProviderInNetworkMapInNetwork;
}

/**
 * quoting.QuotePricing model
 */
export interface QuotingQuotePricing {
  /** Base compliance price per month */
  base_compliance_price?: number;
  /** Platform price per employee per month */
  platform_price?: number;
  /** Advising price per employee per month */
  advising_price?: number;
  /** Core compliance price per employee per month (for ALE) */
  core_compliance_price?: number;
  /** ACA compliance price per employee per month (for ALE) */
  aca_compliance_price?: number;
  /** Custom price per employee per month */
  custom_price?: number;
}

/**
 * Update quote pricing
 */
export interface PutQuotingPricesQuoteId {
  /** Base compliance price per month */
  base_compliance_price?: number;
  /** Platform price per employee per month */
  platform_price?: number;
  /** Advising price per employee per month */
  advising_price?: number;
  /** Core compliance price per employee per month (for ALE) */
  core_compliance_price?: number;
  /** ACA compliance price per employee per month (for ALE) */
  aca_compliance_price?: number;
  /** Custom price per employee per month */
  custom_price?: number;
}

/**
 * member_onboarding.AdditionalParticipantsList model
 */
export interface MemberOnboardingAdditionalParticipantsList {
  data?: MemberOnboardingAdditionalParticipant[];
}

/**
 * The participant's gender
 */
export type MemberOnboardingAdditionalParticipantGender = typeof MemberOnboardingAdditionalParticipantGender[keyof typeof MemberOnboardingAdditionalParticipantGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingAdditionalParticipantGender = {
  female: 'female',
  male: 'male',
  non_binary: 'non_binary',
} as const;

/**
 * The participant's relationship to the member
 */
export type MemberOnboardingAdditionalParticipantRelationship = typeof MemberOnboardingAdditionalParticipantRelationship[keyof typeof MemberOnboardingAdditionalParticipantRelationship];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingAdditionalParticipantRelationship = {
  spouse: 'spouse',
  child: 'child',
} as const;

/**
 * If the participant is a net-new participant, or was included in the previous enrollment but will be removed, or was included in the previous enrollment but will be added again
 */
export type MemberOnboardingAdditionalParticipantSelectedPlanStatus = typeof MemberOnboardingAdditionalParticipantSelectedPlanStatus[keyof typeof MemberOnboardingAdditionalParticipantSelectedPlanStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingAdditionalParticipantSelectedPlanStatus = {
  will_be_added: 'will_be_added',
  will_be_removed: 'will_be_removed',
  ported_over: 'ported_over',
  not_eligible: 'not_eligible',
} as const;

/**
 * member_onboarding.AdditionalParticipant model
 */
export interface MemberOnboardingAdditionalParticipant {
  /** The ID of the covered participant */
  id: string;
  /** The participant's family name */
  family_name: string;
  /** The participant's given name */
  given_name: string;
  /** The participant's date of birth */
  dob: string;
  /** The participant's gender */
  gender?: MemberOnboardingAdditionalParticipantGender;
  /** The participant's relationship to the member */
  relationship: MemberOnboardingAdditionalParticipantRelationship;
  /** If the participant has disability or not (used for relationship child) */
  has_disability?: boolean;
  /** The participant's Social Security Number (only exposed for renewal events) */
  ssn?: string;
  /** If the participant is a net-new participant, or was included in the previous enrollment but will be removed, or was included in the previous enrollment but will be added again */
  selected_plan_status?: MemberOnboardingAdditionalParticipantSelectedPlanStatus;
  /** The reason that why the participant is marked as not_eligible, if applicable (if using plan selection metadata) */
  selected_plan_status_ineligible_reason?: string;
  /** If the participant is a tobacco user or not */
  tobacco: boolean;
}

/**
 * The participant's relationship to the member
 */
export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsRelationship = typeof PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsRelationship[keyof typeof PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsRelationship];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsRelationship = {
  spouse: 'spouse',
  child: 'child',
} as const;

/**
 * The participant's gender
 */
export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsGender = typeof PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsGender[keyof typeof PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsGender = {
  female: 'female',
  male: 'male',
  non_binary: 'non_binary',
} as const;

/**
 * Create an additional participant
 */
export interface PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants {
  /** The participant's family name */
  family_name: string;
  /** The participant's given name */
  given_name: string;
  /** The participant's date of birth in YYYY-MM-DD format */
  dob: string;
  /** The participant's relationship to the member */
  relationship: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsRelationship;
  /** The participant's gender */
  gender?: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsGender;
  /** The participant's social security number */
  ssn?: string;
  /** If the participant uses tobacco or not */
  tobacco?: boolean;
  /** If the participant has disability or not (used for relationship child) */
  has_disability?: boolean;
}

/**
 * Bulk update additional participants
 */
export interface PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate { [key: string]: unknown }

/**
 * The participant's relationship to the member
 */
export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdRelationship = typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdRelationship[keyof typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdRelationship];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdRelationship = {
  spouse: 'spouse',
  child: 'child',
} as const;

/**
 * The participant's gender
 */
export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdGender = typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdGender[keyof typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdGender = {
  female: 'female',
  male: 'male',
  non_binary: 'non_binary',
} as const;

/**
 * Update an additional participant
 */
export interface PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId {
  /** The participant's family name */
  family_name?: string;
  /** The participant's given name */
  given_name?: string;
  /** The participant's date of birth in YYYY-MM-DD format */
  dob?: string;
  /** The participant's relationship to the member */
  relationship?: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdRelationship;
  /** The participant's gender */
  gender?: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdGender;
  /** The participant's social security number */
  ssn?: string;
  /** If the participant uses tobacco or not */
  tobacco?: boolean;
  /** If the participant has disability or not (used for relationship child) */
  has_disability?: boolean;
}

/**
 * The current progress of the onboarding process
 */
export type MemberOnboardingOnboardingProgress = typeof MemberOnboardingOnboardingProgress[keyof typeof MemberOnboardingOnboardingProgress];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingOnboardingProgress = {
  incomplete: 'incomplete',
  completed: 'completed',
  opted_out: 'opted_out',
} as const;

/**
 * The reason for declining coverage
 */
export type MemberOnboardingOnboardingDeclineReason = typeof MemberOnboardingOnboardingDeclineReason[keyof typeof MemberOnboardingOnboardingDeclineReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingOnboardingDeclineReason = {
  covered_by_family: 'covered_by_family',
  subsidy: 'subsidy',
  dislike_plans: 'dislike_plans',
  budget_not_affordable: 'budget_not_affordable',
  insurance_not_needed: 'insurance_not_needed',
  other: 'other',
} as const;

/**
 * member_onboarding.Onboarding model
 */
export interface MemberOnboardingOnboarding {
  /** The current progress of the onboarding process */
  progress: MemberOnboardingOnboardingProgress;
  /** The reason for declining coverage */
  decline_reason?: MemberOnboardingOnboardingDeclineReason;
  /** The state abbreviation if the member requires a state-specific form, null otherwise */
  state_config?: string;
  enrollment_event: MemberOnboardingEnrollmentEvent;
  plan_selection_metadata?: MemberOnboardingPlanSelectionMetadata;
  allowance?: MemberOnboardingAllowance;
  missing_fields: MemberOnboardingMissingFields;
  employee?: MemberOnboardingEmployee;
  employer?: MemberOnboardingEmployer;
  member?: MemberOnboardingMember;
  /** The list of providers from member's plan selection ichra config */
  provider_preferences?: MemberOnboardingProvider[];
  medical_plan_selection_preferences?: MemberOnboardingPlanSelectionPreference;
  /** The recommended medical plans for the member */
  recommended_medical_plans?: MemberOnboardingRecommendedPlan[];
  enrollments?: MemberOnboardingMemberEnrollment;
  additional_participants?: MemberOnboardingAdditionalParticipant;
  restrictions: MemberOnboardingRestrictions;
  user?: MemberOnboardingUser;
}

/**
 * The enrollment event type
 */
export type MemberOnboardingEnrollmentEventType = typeof MemberOnboardingEnrollmentEventType[keyof typeof MemberOnboardingEnrollmentEventType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingEnrollmentEventType = {
  ichra_invite: 'ichra_invite',
  open_enrollment: 'open_enrollment',
  special_enrollment: 'special_enrollment',
} as const;

/**
 * The enrollment event's status
 */
export type MemberOnboardingEnrollmentEventStatus = typeof MemberOnboardingEnrollmentEventStatus[keyof typeof MemberOnboardingEnrollmentEventStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingEnrollmentEventStatus = {
  active: 'active',
  in_progress: 'in_progress',
  completed: 'completed',
  inactive: 'inactive',
} as const;

export interface MemberOnboardingEnrollmentEvent {
  /** The enrollment event ID */
  id: string;
  /** The enrollment event type */
  type: MemberOnboardingEnrollmentEventType;
  /** The enrollment event subtype */
  subtype?: string;
  /** The enrollment event's plan year */
  plan_year: number;
  /** Start date of the enrollment period, inclusive */
  start_date: string;
  /** End date of the enrollment period, inclusive */
  end_date: string;
  /** The enrollment event's status */
  status: MemberOnboardingEnrollmentEventStatus;
}

export interface MemberOnboardingPlanSelectionMetadata {
  /** Plan Selection Metadata ID */
  id: string;
  /** Participants from the previous enrollment event who won't be added to this enrollment event */
  ineligible_participants?: MemberOnboardingIneligibleParticipant[];
  /** Whether the member is opted in to Thatch */
  opt_in?: boolean;
}

export interface MemberOnboardingIneligibleParticipant {
  /** The ID of the covered participant */
  id: string;
  /** The participant's name */
  name?: string;
  /** The reason for validation failure */
  validation_failure_reason?: string;
}

/**
 * The type of QME treatment for this member
 */
export type MemberOnboardingAllowanceQmeTreatment = typeof MemberOnboardingAllowanceQmeTreatment[keyof typeof MemberOnboardingAllowanceQmeTreatment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingAllowanceQmeTreatment = {
  all_allowed: 'all_allowed',
  disabled: 'disabled',
  copay_only: 'copay_only',
} as const;

export interface MemberOnboardingAllowance {
  allowance_amount: Money;
  /** The type of QME treatment for this member */
  qme_treatment: MemberOnboardingAllowanceQmeTreatment;
}

export interface MemberOnboardingMissingFields {
  /** List of missing fields for generating allowance */
  allowance?: string[];
  /** List of missing fields for starting plan selection process */
  plans_selection?: string[];
  /** List of missing fields for enrollment */
  enrollment?: string[];
}

export interface MemberOnboardingEmployee {
  /** pre-configured first name from the employee model */
  first_name?: string;
  /** pre-configured last name from the employee model */
  last_name?: string;
}

export interface MemberOnboardingEmployer {
  /** The official name of the employer (or DBA) */
  formatted_name: string;
  /** Whether the employer is ICHRA Shop */
  is_ichra_shop_employer: boolean;
}

/**
 * Member's occupation
 */
export type MemberOnboardingMemberOccupation = typeof MemberOnboardingMemberOccupation[keyof typeof MemberOnboardingMemberOccupation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMemberOccupation = {
  architect_or_engineer: 'architect_or_engineer',
  business_analyst_accountant_or_financial_advisor: 'business_analyst_accountant_or_financial_advisor',
  community_and_social_services_worker: 'community_and_social_services_worker',
  construction_mechanic_or_maintenance_worker: 'construction_mechanic_or_maintenance_worker',
  doctor: 'doctor',
  educator: 'educator',
  entertainment_sports_arts_or_media: 'entertainment_sports_arts_or_media',
  executive_or_manager: 'executive_or_manager',
  farmer_fisherman_forester: 'farmer_fisherman_forester',
  food_service_worker: 'food_service_worker',
  gig_worker: 'gig_worker',
  hospitality_office_or_administrative_support_worker: 'hospitality_office_or_administrative_support_worker',
  household_manager: 'household_manager',
  janitor_housekeeper_landscaper: 'janitor_housekeeper_landscaper',
  lawyer: 'lawyer',
  manufacturing_or_production_worker: 'manufacturing_or_production_worker',
  military_or_public_safety: 'military_or_public_safety',
  nurse_healthcare_technician_or_healthcare_support: 'nurse_healthcare_technician_or_healthcare_support',
  personal_care_or_service_worker: 'personal_care_or_service_worker',
  pilot_driver_operator: 'pilot_driver_operator',
  sales_representative_broker_agent: 'sales_representative_broker_agent',
  scientist_or_technologist: 'scientist_or_technologist',
  student: 'student',
} as const;

/**
 * The member's gender
 */
export type MemberOnboardingMemberGender = typeof MemberOnboardingMemberGender[keyof typeof MemberOnboardingMemberGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMemberGender = {
  female: 'female',
  male: 'male',
  non_binary: 'non_binary',
} as const;

export interface MemberOnboardingMember {
  /** The ID of the member */
  id?: string;
  /** The ID of the member covered participant */
  participant_id?: string;
  /** The name of the member covered participant */
  participant_name?: string;
  /** The member's family name */
  family_name?: string;
  /** The member's given name */
  given_name?: string;
  /** Member's address - line 1 */
  address_line1?: string;
  /** Member's address - line 2 */
  address_line2?: string;
  /** Member's address - city */
  city?: string;
  /** Member's address - state */
  state?: string;
  /** Member's address - zip code */
  zip?: string;
  household_income?: Money;
  /** Member's occupation */
  occupation?: MemberOnboardingMemberOccupation;
  /** The member's date of birth */
  date_of_birth?: string;
  /** The member's gender */
  gender?: MemberOnboardingMemberGender;
  /** Whether the member smokes tobacco */
  tobacco?: boolean;
  /** The phone number of the member */
  phone_number?: string;
  /** Whether the member has opted in to SMS AI */
  sms_ai_opt_in?: boolean;
  /** Whether the member has opted in to SMS account notifications */
  sms_account_notification_opt_in?: boolean;
  /** Whether the member is a US citizen */
  is_us_citizen?: boolean;
  /** Whether the member is a resident of their current state */
  is_state_resident?: boolean;
  /** The URL for the state marketplace if that is the preferred enrollment path */
  enroll_url?: string;
  /** The soonest date the member can start coverage */
  soonest_coverage_start_date?: string;
  plan_selection_call_scheduling_links?: MembersPlanSelectionSupportCallSchedulingInfo;
  /** The member's Social Security Number (only exposed for renewal events) */
  ssn?: string;
}

export interface MembersPlanSelectionSupportCallSchedulingInfo {
  /**
   * URL for scheduling a call conducted in English
   * @nullable
   */
  en?: string | null;
  /**
   * URL for scheduling a call conducted in Spanish
   * @nullable
   */
  es?: string | null;
}

export interface MemberOnboardingProvider {
  /** The NPI of the provider */
  npi: number;
  /** The first name of the provider */
  first_name?: string;
  /** The last name of the provider */
  last_name?: string;
}

/**
 * How much the member is planning to spend on their medical expenses
 */
export type MemberOnboardingPlanSelectionPreferenceExpectedPlanUtilization = typeof MemberOnboardingPlanSelectionPreferenceExpectedPlanUtilization[keyof typeof MemberOnboardingPlanSelectionPreferenceExpectedPlanUtilization];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingPlanSelectionPreferenceExpectedPlanUtilization = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

/**
 * member_onboarding.PlanSelectionPreference model
 */
export interface MemberOnboardingPlanSelectionPreference {
  /** Plan Selection Preference ID */
  id: string;
  /** How much the member is planning to spend on their medical expenses */
  expected_plan_utilization?: MemberOnboardingPlanSelectionPreferenceExpectedPlanUtilization;
  /** Out of pocket budget that the member is willing to spend on top of the allowance */
  oop_budget?: number;
  /** Plan year used for the preference */
  year: number;
}

/**
 * Category of the recommended plan
 */
export type MemberOnboardingRecommendedPlanCategory = typeof MemberOnboardingRecommendedPlanCategory[keyof typeof MemberOnboardingRecommendedPlanCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingRecommendedPlanCategory = {
  lowest_cost: 'lowest_cost',
  most_comprehensive: 'most_comprehensive',
} as const;

export interface MemberOnboardingRecommendedPlan {
  /** Recommended Plan ID */
  id: string;
  /** Category of the recommended plan */
  category: MemberOnboardingRecommendedPlanCategory;
  /** Plan year of the recommended plan */
  year: number;
  /** Rank of the recommended plan within the category */
  rank: number;
  /** Medical Plan ID */
  plan_id: string;
  /** Plan Selection Preference ID */
  plan_selection_preference_id?: string;
}

/**
 * Metal tier of the medical plan. Valid values: catastrophic, bronze, expanded_bronze, silver, gold, platinum
 */
export type MemberOnboardingMemberEnrollmentMedicalMetalTier = typeof MemberOnboardingMemberEnrollmentMedicalMetalTier[keyof typeof MemberOnboardingMemberEnrollmentMedicalMetalTier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMemberEnrollmentMedicalMetalTier = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
} as const;

/**
 * Type of medical plan. Valid values: hmo, ppo, epo, pos
 */
export type MemberOnboardingMemberEnrollmentMedicalPlanType = typeof MemberOnboardingMemberEnrollmentMedicalPlanType[keyof typeof MemberOnboardingMemberEnrollmentMedicalPlanType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMemberEnrollmentMedicalPlanType = {
  hmo: 'hmo',
  ppo: 'ppo',
  epo: 'epo',
  pos: 'pos',
} as const;

/**
 * Category of the enrollment (e.g., general_medical, off_thatch_medical, medicare, etc.)
 */
export type MemberOnboardingMemberEnrollmentCategory = typeof MemberOnboardingMemberEnrollmentCategory[keyof typeof MemberOnboardingMemberEnrollmentCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingMemberEnrollmentCategory = {
  general_medical: 'general_medical',
  guardian_dental: 'guardian_dental',
  renaissance_dental: 'renaissance_dental',
  bsca_dental: 'bsca_dental',
  vsp: 'vsp',
  bsca_vision: 'bsca_vision',
  medicare: 'medicare',
  medicare_part_a: 'medicare_part_a',
  medicare_part_b: 'medicare_part_b',
  medicare_part_c: 'medicare_part_c',
  medicare_part_d: 'medicare_part_d',
  medicare_supplement: 'medicare_supplement',
  off_thatch_medical: 'off_thatch_medical',
  subsidy: 'subsidy',
  off_thatch_dental: 'off_thatch_dental',
  off_thatch_vision: 'off_thatch_vision',
  cobra: 'cobra',
  renewal: 'renewal',
} as const;

/**
 * member_onboarding.MemberEnrollment model
 */
export interface MemberOnboardingMemberEnrollment {
  /** Enrollment ID */
  id: string;
  /** Whether the enrollment covers dental */
  covers_dental: boolean;
  /** Whether the enrollment covers medical */
  covers_medical: boolean;
  /** Whether the enrollment covers vision */
  covers_vision: boolean;
  /** The carrier providing the coverage */
  carrier_name: string;
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** The plan code for the enrollment, ID for medical plans, code for non-medical plans */
  plan_code: string;
  /** The display name for the enrollment, friendly name for medical plans, code for non-medical plans */
  display_name: string;
  /** Whether the enrollment was purchased off-exchange */
  off_exchange?: boolean;
  /** Metal tier of the medical plan. Valid values: catastrophic, bronze, expanded_bronze, silver, gold, platinum */
  medical_metal_tier?: MemberOnboardingMemberEnrollmentMedicalMetalTier;
  /** Type of medical plan. Valid values: hmo, ppo, epo, pos */
  medical_plan_type?: MemberOnboardingMemberEnrollmentMedicalPlanType;
  /** Category of the enrollment (e.g., general_medical, off_thatch_medical, medicare, etc.) */
  category: MemberOnboardingMemberEnrollmentCategory;
  /** Where in the process of onboarding the enrollment is */
  state: string;
  quoted_premium?: Money;
  /** How the member will be paying for the enrollment -- defaults to paid_by_thatch for on thatch plans */
  payment_method?: string;
  /** Whether this medical enrollment is eligible for HSA */
  medical_plan_hsa_eligible?: boolean;
  max_premium_reimbursement_amount?: Money;
}

/**
 * Field to indicate the reason why the dental plan is not available
 */
export type MemberOnboardingRestrictionsDentalNotAvailable = typeof MemberOnboardingRestrictionsDentalNotAvailable[keyof typeof MemberOnboardingRestrictionsDentalNotAvailable];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingRestrictionsDentalNotAvailable = {
  not_provided_by_employer: 'not_provided_by_employer',
  not_provided_by_state: 'not_provided_by_state',
  coverage_ends_mid_year: 'coverage_ends_mid_year',
} as const;

/**
 * Field to indicate the reason why the vision plan is not available
 */
export type MemberOnboardingRestrictionsVisionNotAvailable = typeof MemberOnboardingRestrictionsVisionNotAvailable[keyof typeof MemberOnboardingRestrictionsVisionNotAvailable];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingRestrictionsVisionNotAvailable = {
  not_provided_by_employer: 'not_provided_by_employer',
  coverage_ends_mid_year: 'coverage_ends_mid_year',
} as const;

export interface MemberOnboardingRestrictions {
  /** List of fields that are causing the member to be eligible for medicare */
  medicare_eligible?: string[];
  /** Field that causes the member to be in a geographic state that Thatch does not support */
  ineligible_state?: string;
  /** List of fields that must have a binary gender */
  binary_gender_required?: string[];
  /** Field that causes the member to have additional instructions based on their geographic state */
  additional_instructions_state?: string;
  /** Field that causes the member to verify their phone number from the UI */
  phone_number_verification?: string;
  /** Flag to be used when the allowance generation has been failed from the backend */
  allowance_generation_failed?: boolean;
  /** Flag to be used when the member is eligible for a subsidy */
  subsidy_eligible?: string;
  /** Flag to be used when we weren't able to determine the member's county from their address */
  member_missing_county?: boolean;
  /** Field to indicate the reason why the dental plan is not available */
  dental_not_available?: MemberOnboardingRestrictionsDentalNotAvailable;
  /** Field to indicate the reason why the vision plan is not available */
  vision_not_available?: MemberOnboardingRestrictionsVisionNotAvailable;
}

export interface MemberOnboardingUser {
  /** The user's email address */
  email?: string;
}

/**
 * State
 */
export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMemberState = typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMemberState[keyof typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMemberState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMemberState = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * Member details
 */
export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMember = {
  /** First name */
  given_name?: string;
  /** Last name */
  family_name?: string;
  /** Date of birth in YYYY-MM-DD format */
  date_of_birth?: string;
  /** Address line 1 */
  address_line1?: string;
  /** Address line 2 */
  address_line2?: string;
  /** City */
  city?: string;
  /** State */
  state?: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMemberState;
  /** Zip code */
  zip?: string;
  /** Phone number */
  phone_number?: string;
  /** Tobacco usage */
  tobacco?: boolean;
  /** Household income */
  household_income?: number;
  /** Gender */
  gender?: string;
  /** Social security number or ITIN */
  ssn?: string;
  /** Occupation */
  occupation?: string;
  /** Is the member a US citizen? */
  is_us_citizen?: boolean;
  /** Is the member a resident of the state they selected? */
  is_state_resident?: boolean;
  /** SMS AI opt-in */
  sms_ai_opt_in?: boolean;
  /** SMS account notification opt-in */
  sms_account_notification_opt_in?: boolean;
};

/**
 * Reason for declining coverage offer
 */
export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingDeclineReason = typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingDeclineReason[keyof typeof PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingDeclineReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingDeclineReason = {
  covered_by_family: 'covered_by_family',
  subsidy: 'subsidy',
  dislike_plans: 'dislike_plans',
  budget_not_affordable: 'budget_not_affordable',
  insurance_not_needed: 'insurance_not_needed',
  other: 'other',
} as const;

/**
 * Signatory details
 */
export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingSignatory = {
  /** Contract agreement signature */
  contract_agreement?: string;
  /** Arbitration agreement signature */
  arbitration_agreement?: string;
  /** User platform agreement signature */
  user_platform_agreement?: boolean;
};

/**
 * Update the onboarding context for an enrollment event
 */
export interface PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding {
  /** Member details */
  member?: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMember;
  /** Reason for declining coverage offer */
  decline_reason?: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingDeclineReason;
  /** Signatory details */
  signatory?: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingSignatory;
}

/**
 * Create an enrollment
 */
export interface PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll {
  /** Whether the enrollment covers medical */
  covers_medical: boolean;
  /** Whether the enrollment covers vision */
  covers_vision: boolean;
  /** Whether the enrollment covers dental */
  covers_dental: boolean;
  /** The amount of money for the enrollment */
  quoted_premium: number;
  /** The plan code of the enrollment (corresponds to the ID of the MedicalPlan for medical enrollment) */
  plan_code: string;
  /** The name of the carrier for the plan */
  carrier_name: string;
  /** The employee-only premium for the plan, only for tiered allowance & medical enrollment */
  employee_only_premium?: number;
  /** whether the enrollment is in the process of being onboarded, used only for vision/dental */
  state?: string;
}

/**
 * Finalizes all enrollments for the user
 */
export interface PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments { [key: string]: unknown }

/**
 * member_onboarding.MedicalPlanDisplayItemList model
 */
export interface MemberOnboardingMedicalPlanDisplayItemList {
  data?: MemberOnboardingMedicalPlanDisplayItem[];
  recommended_plans?: MemberOnboardingRecommendedPlansDisplayItems;
  /** Total number of plans without any filters */
  total_count_without_filters: number;
  filters?: MemberOnboardingMedicalPlanFilters;
  pagination: Pagination;
  /** List of plan display items from plans_for_comparison that are still available */
  plans_for_comparison?: MemberOnboardingMedicalPlanDisplayItem[];
}

export interface MemberOnboardingRecommendedPlansDisplayItems {
  lowest_cost_plan_display_item?: MemberOnboardingMedicalPlanDisplayItem;
  most_comprehensive_plan_display_item?: MemberOnboardingMedicalPlanDisplayItem;
}

export interface MemberOnboardingMedicalPlanFilters {
  /** List of unique carrier names available for filtering */
  carriers?: string[];
  /** List of unique metal tiers available for filtering */
  metal_tiers?: string[];
  /** List of unique plan types available for filtering */
  plan_types?: string[];
}

/**
 * member_onboarding.MedicalPlanDisplayItemDetailsList model
 */
export interface MemberOnboardingMedicalPlanDisplayItemDetailsList {
  data?: MemberOnboardingMedicalPlanDisplayItem[];
}

/**
 * member_onboarding.DentalPlanList model
 */
export interface MemberOnboardingDentalPlanList {
  data?: MemberOnboardingDentalPlan[];
}

/**
 * The dental plan carrier
 */
export type MemberOnboardingDentalPlanCarrier = typeof MemberOnboardingDentalPlanCarrier[keyof typeof MemberOnboardingDentalPlanCarrier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingDentalPlanCarrier = {
  guardian: 'guardian',
  renaissance: 'renaissance',
} as const;

/**
 * The dental plan carrier
 */
export type MemberOnboardingDentalPlanPlanCode = typeof MemberOnboardingDentalPlanPlanCode[keyof typeof MemberOnboardingDentalPlanPlanCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingDentalPlanPlanCode = {
  Shine: 'Shine',
  Bright: 'Bright',
} as const;

export type MemberOnboardingDentalPlanFeaturesItem = { [key: string]: unknown };

export interface MemberOnboardingDentalPlan {
  /** The dental plan carrier */
  carrier?: MemberOnboardingDentalPlanCarrier;
  /** The dental plan carrier */
  plan_code?: MemberOnboardingDentalPlanPlanCode;
  /** The name of the dental plan */
  name?: string;
  premium?: Money;
  /** Array of plan features */
  features?: MemberOnboardingDentalPlanFeaturesItem[];
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** The URL of the carrier icon */
  carrier_icon_url?: string;
  /** Whether or not the plan has a waiting period */
  waiting_period?: boolean;
}

/**
 * member_onboarding.VisionPlanList model
 */
export interface MemberOnboardingVisionPlanList {
  data?: MemberOnboardingVisionPlan[];
}

/**
 * The vision dental plan carrier
 */
export type MemberOnboardingVisionPlanCarrier = typeof MemberOnboardingVisionPlanCarrier[keyof typeof MemberOnboardingVisionPlanCarrier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingVisionPlanCarrier = {
  vsp: 'vsp',
} as const;

export type MemberOnboardingVisionPlanFeaturesItem = { [key: string]: unknown };

export interface MemberOnboardingVisionPlan {
  /** The vision dental plan carrier */
  carrier?: MemberOnboardingVisionPlanCarrier;
  /** The plan code for the vision plan */
  plan_code?: string;
  /** The name of the vision plan */
  name?: string;
  premium?: Money;
  /** The description of the plan */
  description?: string;
  /** Array of plan features */
  features?: MemberOnboardingVisionPlanFeaturesItem[];
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** The URL of the carrier icon */
  carrier_icon_url?: string;
}

/**
 * Create an off-Thatch enrollment
 */
export interface PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll {
  /** The amount of money for the enrollment */
  quoted_premium: number;
  /** The plan code of the enrollment (corresponds to the ID of the MedicalPlan for medical enrollment) */
  plan_code: string;
  /** The name of the carrier for the plan */
  carrier_name: string;
  /** Whether the enrollment was purchased off-exchange */
  off_exchange: boolean;
  /** How the member intends to pay for the plan */
  payment_source: string;
  /** Whether the member has attested to the coverage */
  attestation: boolean;
}

/**
 * member_onboarding.CarrierAgreement model
 */
export interface MemberOnboardingCarrierAgreement {
  /** The content of the carrier agreement */
  content?: string;
}

/**
 * member_onboarding.MemberPlanChangesProps model
 */
export interface MemberOnboardingMemberPlanChangesProps {
  current_plan_year: MemberOnboardingPlanYearSummary;
  next_plan_year: MemberOnboardingPlanYearSummary;
  year_over_year_change: MemberOnboardingYearOverYearChange;
}

export type MemberOnboardingPlanYearSummaryCoveredParticipantsItem = { [key: string]: unknown };

/**
 * Medical plan renewal type, based on the result of plan descendant resolver.This will always be nil for the current plan year.
 */
export type MemberOnboardingPlanYearSummaryMedicalPlanRenewalType = typeof MemberOnboardingPlanYearSummaryMedicalPlanRenewalType[keyof typeof MemberOnboardingPlanYearSummaryMedicalPlanRenewalType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingPlanYearSummaryMedicalPlanRenewalType = {
  plan_selection_required: 'plan_selection_required',
  same_plan: 'same_plan',
  same_carrier_new_plan: 'same_carrier_new_plan',
  new_carrier_new_plan: 'new_carrier_new_plan',
} as const;

export interface MemberOnboardingPlanYearSummary {
  /** Whether this is a renewal year */
  is_renewal_year: boolean;
  /** Plan year */
  plan_year: number;
  /** Array of covered participants */
  covered_participants: MemberOnboardingPlanYearSummaryCoveredParticipantsItem[];
  allowance_amount: Money;
  premium_total: Money;
  remaining_balance: Money;
  /** Medical plan renewal type, based on the result of plan descendant resolver.This will always be nil for the current plan year. */
  medical_plan_renewal_type?: MemberOnboardingPlanYearSummaryMedicalPlanRenewalType;
  medical_plan?: MemberOnboardingRenewalMedicalPlan;
  dental_plan?: MemberOnboardingRenewalDentalPlan;
  vision_plan?: MemberOnboardingRenewalVisionPlan;
}

export interface MemberOnboardingRenewalMedicalPlan {
  /** Enrollment ID */
  enrollment_id: number;
  /** Name of the insurance carrier */
  carrier_name: string;
  /** Name of the plan */
  plan_name: string;
  /** Plan category */
  category: string;
  premium_amount: Money;
  /** Whether plan is off-exchange */
  off_exchange: boolean;
  /** Parameterized carrier name for image lookup */
  carrier_image_name: string;
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** Whether plan has medicare eligible participants */
  has_medicare_eligible_participant: boolean;
  /** HIOS ID */
  hios_id: string;
  /** Metal tier of the plan */
  metal_tier: string;
  /** Medical plan ID in case the type of the plan is general_medical, otherwise plan name for off thatch medical plans */
  plan_code: string;
  /** Type of plan */
  plan_type: string;
  /** In-network deductible amount */
  deductible: string;
  /** In-network family deductible amount */
  family_deductible: string;
  /** In-network out-of-pocket maximum */
  out_of_pocket_max: string;
  /** In-network family out-of-pocket maximum */
  family_out_of_pocket_max: string;
  /** Summary of Benefits and Coverage URL */
  sbc_url: string;
  max_premium_reimbursement_amount?: Money;
  employer_reimbursement_amount?: Money;
  /** Whether plan is an ancestor plan (next year only - if plan changed) */
  is_ancestor_plan?: boolean;
  /** Indicator that whether the member's current county is being supported by the current plan.If false, we would need to let the members know to choose a new plan. */
  can_support_member_county?: boolean;
}

export type MemberOnboardingRenewalDentalPlanFeaturesItem = { [key: string]: unknown };

export interface MemberOnboardingRenewalDentalPlan {
  /** Enrollment ID */
  enrollment_id: number;
  premium_amount: Money;
  /** Dental plan deductible value in string format */
  deductible: string;
  /** Dental plan annual max coverage value in string format */
  annual_max_coverage: string;
  /** Plan category (renaissance_dental or guardian_dental) */
  category: string;
  /** Plan code */
  plan_code: string;
  /** Name of the insurance carrier */
  carrier_name: string;
  /** Carrier image name */
  carrier_image_name: string;
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** Array of covered participant IDs */
  covered_participant_ids: string[];
  /** Coverage start date */
  coverage_start_date: string;
  /** SBC URL */
  sbc_url: string;
  /** Coverage end date */
  coverage_end_date: string;
  /** Array of plan features */
  features?: MemberOnboardingRenewalDentalPlanFeaturesItem[];
}

export type MemberOnboardingRenewalVisionPlanFeaturesItem = { [key: string]: unknown };

export interface MemberOnboardingRenewalVisionPlan {
  /** Enrollment ID */
  enrollment_id: number;
  premium_amount: Money;
  /** Plan code */
  plan_code: string;
  /** Plan category */
  category: string;
  /** Name of the insurance carrier */
  carrier_name: string;
  /** Eye exam copay */
  eye_exam_copay?: string;
  /** Frames or contacts allowance */
  frames_or_contacts_allowance?: string;
  /** Carrier image name */
  carrier_image_name?: string;
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** Array of covered participant IDs */
  covered_participant_ids: string[];
  /** Coverage start date */
  coverage_start_date: string;
  /** Coverage end date */
  coverage_end_date: string;
  /** SBC URL */
  sbc_url: string;
  /** Array of plan features */
  features?: MemberOnboardingRenewalVisionPlanFeaturesItem[];
}

export interface MemberOnboardingYearOverYearChange {
  allowance_amount: Money;
  medical_amount: Money;
  dental_amount: Money;
  vision_amount: Money;
  premium_total: Money;
  remaining_balance: Money;
  medical_feature_change: MemberOnboardingMedicalFeatureYoyChange;
  dental_feature_change: MemberOnboardingDentalFeatureYoyChange;
  vision_feature_change: MemberOnboardingVisionFeatureYoyChange;
}

export interface MemberOnboardingMedicalFeatureYoyChange {
  deductible: Money;
  out_of_pocket_max: Money;
  family_deductible: Money;
  family_out_of_pocket_max: Money;
}

export interface MemberOnboardingDentalFeatureYoyChange {
  deductible: Money;
  annual_max_coverage: Money;
}

export interface MemberOnboardingVisionFeatureYoyChange {
  eye_exam_copay: Money;
  frames_or_contacts_allowance: Money;
}

/**
 * member_onboarding.SelectedPlansList model
 */
export interface MemberOnboardingSelectedPlansList {
  data?: MemberOnboardingSelectedPlan[];
}

/**
 * Category of the plan
 */
export type MemberOnboardingSelectedPlanCategory = typeof MemberOnboardingSelectedPlanCategory[keyof typeof MemberOnboardingSelectedPlanCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingSelectedPlanCategory = {
  general_medical: 'general_medical',
  guardian_dental: 'guardian_dental',
  renaissance_dental: 'renaissance_dental',
  bsca_dental: 'bsca_dental',
  vsp: 'vsp',
  bsca_vision: 'bsca_vision',
  medicare: 'medicare',
  medicare_part_a: 'medicare_part_a',
  medicare_part_b: 'medicare_part_b',
  medicare_part_c: 'medicare_part_c',
  medicare_part_d: 'medicare_part_d',
  medicare_supplement: 'medicare_supplement',
  off_thatch_medical: 'off_thatch_medical',
  subsidy: 'subsidy',
  off_thatch_dental: 'off_thatch_dental',
  off_thatch_vision: 'off_thatch_vision',
  cobra: 'cobra',
  renewal: 'renewal',
} as const;

/**
 * member_onboarding.SelectedPlan model
 */
export interface MemberOnboardingSelectedPlan {
  /** Selected Plan ID */
  id: string;
  /** Name of the insurance carrier associated with the plan */
  carrier_name: string;
  /** Category of the plan */
  category: MemberOnboardingSelectedPlanCategory;
  max_premium_reimbursement_amount?: Money;
  /** Whether the plan is off-exchange */
  off_exchange: boolean;
  /** Plan code */
  plan_code: string;
  quoted_premium: Money;
  /** Plan selection metadata ID associated with the plan */
  plan_selection_metadata_id: string;
}

/**
 * Map of recommendation strategies to medical plan IDs
 */
export type MemberOnboardingSmartBudgetRecommendationsSmartBudgetRecommendations = { [key: string]: unknown };

/**
 * member_onboarding.SmartBudgetRecommendations model
 */
export interface MemberOnboardingSmartBudgetRecommendations {
  /** Map of recommendation strategies to medical plan IDs */
  smart_budget_recommendations: MemberOnboardingSmartBudgetRecommendationsSmartBudgetRecommendations;
}

/**
 * The recommendation strategy (flexible, balanced, or traditional)
 */
export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetCreateOrUpdateRecommendationStrategy = typeof PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetCreateOrUpdateRecommendationStrategy[keyof typeof PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetCreateOrUpdateRecommendationStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetCreateOrUpdateRecommendationStrategy = {
  flexible: 'flexible',
  balanced: 'balanced',
  traditional: 'traditional',
} as const;

/**
 * Create or update a smart budget recommendation for the enrollment event
 */
export interface PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetCreateOrUpdateRecommendation {
  /** The recommendation strategy (flexible, balanced, or traditional) */
  strategy: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetCreateOrUpdateRecommendationStrategy;
  /** Medical plan ID for this strategy (e.g., 'mdpln_2024-ca-12345') */
  medical_plan_id?: string;
}

/**
 * How much the member is planning to spend on their medical expenses
 */
export type PostMemberOnboardingPlanSelectionPreferencesExpectedPlanUtilization = typeof PostMemberOnboardingPlanSelectionPreferencesExpectedPlanUtilization[keyof typeof PostMemberOnboardingPlanSelectionPreferencesExpectedPlanUtilization];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMemberOnboardingPlanSelectionPreferencesExpectedPlanUtilization = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

/**
 * Create a plan selection preference
 */
export interface PostMemberOnboardingPlanSelectionPreferences {
  /** How much the member is planning to spend on their medical expenses */
  expected_plan_utilization?: PostMemberOnboardingPlanSelectionPreferencesExpectedPlanUtilization;
  /** Out of pocket budget that the member is willing to spend on top of the allowance */
  oop_budget?: number;
  /** Plan year used for the preference */
  year: number;
}

/**
 * How much the member is planning to spend on their medical expenses
 */
export type PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateExpectedPlanUtilization = typeof PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateExpectedPlanUtilization[keyof typeof PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateExpectedPlanUtilization];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateExpectedPlanUtilization = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

/**
 * Either create or update the plan selection preference for a given year
 */
export interface PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate {
  /** How much the member is planning to spend on their medical expenses */
  expected_plan_utilization?: PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateExpectedPlanUtilization;
  /** Out of pocket budget that the member is willing to spend on top of the allowance */
  oop_budget?: number;
  /** Plan year used for the preference */
  year: number;
}

/**
 * How much the member is planning to spend on their medical expenses
 */
export type PatchMemberOnboardingPlanSelectionPreferencesIdExpectedPlanUtilization = typeof PatchMemberOnboardingPlanSelectionPreferencesIdExpectedPlanUtilization[keyof typeof PatchMemberOnboardingPlanSelectionPreferencesIdExpectedPlanUtilization];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchMemberOnboardingPlanSelectionPreferencesIdExpectedPlanUtilization = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

/**
 * Partially update the plan selection preference
 */
export interface PatchMemberOnboardingPlanSelectionPreferencesId {
  /** How much the member is planning to spend on their medical expenses */
  expected_plan_utilization?: PatchMemberOnboardingPlanSelectionPreferencesIdExpectedPlanUtilization;
  /** Out of pocket budget that the member is willing to spend on top of the allowance */
  oop_budget?: number;
  /** Plan year used for the preference */
  year?: number;
}

/**
 * member_onboarding.RecommendedPlanListByCategory model
 */
export interface MemberOnboardingRecommendedPlanListByCategory {
  lowest_cost_plan?: MemberOnboardingRecommendedPlan[];
  most_comprehensive_plan?: MemberOnboardingRecommendedPlan[];
}

/**
 * Enroll in a recommended medical plan
 */
export interface PostMemberOnboardingRecommendedPlansSelect {
  /** The ID of the plan to enroll in */
  plan_id: string;
  /** The premium for the plan */
  premium: string;
  /** The employee-only premium for the plan */
  employee_only_premium?: string;
  /** The ID of the in_progress enrollment event */
  enrollment_event_id?: string;
}

/**
 * Opt out of coverage for a specific year
 */
export interface PutMemberOnboardingMemberIchraConfigOptOut {
  /** The plan year of the Member ICHRA config target */
  plan_year: number;
}

/**
 * Verify phone number with the provided code
 */
export interface PostMemberOnboardingPhoneVerificationVerify {
  /** The verification code sent to the phone number */
  phone_verification_code: string;
}

/**
 * In network providers verification task status
 */
export type MemberOnboardingInNetworkVerificationTaskInNetworkVerificationProgressStatus = typeof MemberOnboardingInNetworkVerificationTaskInNetworkVerificationProgressStatus[keyof typeof MemberOnboardingInNetworkVerificationTaskInNetworkVerificationProgressStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingInNetworkVerificationTaskInNetworkVerificationProgressStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  done: 'done',
} as const;

/**
 * member_onboarding.InNetworkVerificationTask model
 */
export interface MemberOnboardingInNetworkVerificationTask {
  /** In network providers verification task status */
  in_network_verification_progress_status: MemberOnboardingInNetworkVerificationTaskInNetworkVerificationProgressStatus;
  /** Creation date of the newest verification task */
  newest_verify_task_created_at?: string;
  /** Unique identifier for the plan */
  plan_ids: string[];
  /** The NPI of the provider */
  provider_npis: number[];
  data?: MemberOnboardingInNetworkVerificationRecord[];
}

/**
 * In network providers verification task status
 */
export type MemberOnboardingInNetworkVerificationRecordInNetworkVerificationProgressStatus = typeof MemberOnboardingInNetworkVerificationRecordInNetworkVerificationProgressStatus[keyof typeof MemberOnboardingInNetworkVerificationRecordInNetworkVerificationProgressStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingInNetworkVerificationRecordInNetworkVerificationProgressStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  done: 'done',
} as const;

/**
 * In network status
 */
export type MemberOnboardingInNetworkVerificationRecordInNetworkStatus = typeof MemberOnboardingInNetworkVerificationRecordInNetworkStatus[keyof typeof MemberOnboardingInNetworkVerificationRecordInNetworkStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingInNetworkVerificationRecordInNetworkStatus = {
  IN_NETWORK: 'IN_NETWORK',
  OUT_OF_NETWORK: 'OUT_OF_NETWORK',
  UNKNOWN: 'UNKNOWN',
} as const;

/**
 * Unknown in network status reason
 */
export type MemberOnboardingInNetworkVerificationRecordUnknownNetworkStatusReason = typeof MemberOnboardingInNetworkVerificationRecordUnknownNetworkStatusReason[keyof typeof MemberOnboardingInNetworkVerificationRecordUnknownNetworkStatusReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberOnboardingInNetworkVerificationRecordUnknownNetworkStatusReason = {
  PROVIDER_NOT_AT_ADDRESS: 'PROVIDER_NOT_AT_ADDRESS',
  CONFLICTING_RESULTS: 'CONFLICTING_RESULTS',
  UNABLE_TO_CONTACT_PRACTICE: 'UNABLE_TO_CONTACT_PRACTICE',
} as const;

export interface MemberOnboardingInNetworkVerificationRecord {
  /** In network providers verification task status */
  in_network_verification_progress_status: MemberOnboardingInNetworkVerificationRecordInNetworkVerificationProgressStatus;
  /** In network status */
  in_network_status: MemberOnboardingInNetworkVerificationRecordInNetworkStatus;
  /** Unknown in network status reason */
  unknown_network_status_reason?: MemberOnboardingInNetworkVerificationRecordUnknownNetworkStatusReason;
  /** Unique identifier for the plan */
  plan_id: string;
  /** The NPI of the provider */
  npi: number;
}

/**
 * Create a verification task for in network status
 */
export interface PostMemberOnboardingInNetworkVerification { [key: string]: unknown }

/**
 * member_onboarding.ProofOfCoverage model
 */
export interface MemberOnboardingProofOfCoverage {
  /** The file name of the proof of coverage */
  file_name: string;
  /** The blob id of the proof of coverage */
  file_id: string;
}

/**
 * payroll.AdpConfig model
 */
export interface PayrollAdpConfig {
  /** ADP Marketplace URL for subscribing to the Thatch app */
  marketplace_url: string;
}

/**
 * Get ADP authorization URI
 */
export interface PostPayrollAdpConnectAuthorizeUri {
  /** The URL to redirect to after successful connection */
  on_success: string;
  /** The URL to redirect to after failed connection */
  on_failure?: string;
}

/**
 * payroll.PayPeriodConsistentDeductionsList model
 */
export interface PayrollPayPeriodConsistentDeductionsList {
  data?: PayrollPayPeriodConsistentDeductions[];
}

/**
 * Payroll metadata
 */
export type PayrollPayPeriodConsistentDeductionsPayrollMetadata = { [key: string]: unknown };

export interface PayrollPayPeriodConsistentDeductions {
  /** Member ID */
  member_id: string;
  /** Employee ID */
  employee_id: string;
  /** Given name */
  given_name: string;
  /** Family name */
  family_name: string;
  /** Employee source ID or member SSN */
  source_id?: string;
  /** Date when medical coverage started */
  coverage_start_date?: string;
  /** Date when medical coverage ended */
  coverage_end_date?: string;
  /** Payroll metadata */
  payroll_metadata?: PayrollPayPeriodConsistentDeductionsPayrollMetadata;
  s125_deduction: PayrollConsistentDeduction;
  posttax_deduction: PayrollConsistentDeduction;
}

/**
 * Consistent deduction status
 */
export type PayrollConsistentDeductionStatus = typeof PayrollConsistentDeductionStatus[keyof typeof PayrollConsistentDeductionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollConsistentDeductionStatus = {
  unchanged: 'unchanged',
  created: 'created',
  updated: 'updated',
  corrected: 'corrected',
} as const;

export interface PayrollConsistentDeduction {
  /** Consistent deduction ID */
  id: string;
  /** Allowance amount */
  allowance_amount: number;
  /** Deduction amount */
  amount: number;
  /** Base amount */
  base_amount: number;
  /** Employer contribution amount */
  employer_contribution?: number;
  /** Expected year-to-date amount */
  expected_ytd_amount: number;
  /** Whether the deduction is pretax */
  pretax: boolean;
  /** Total premiums amount */
  total_premiums: number;
  payroll_correction?: PayrollPayrollCorrection;
  payroll_deduction?: PayrollPayrollDeduction;
  /** Consistent deduction status */
  status: PayrollConsistentDeductionStatus;
}

/**
 * Payroll correction strategy
 */
export type PayrollPayrollCorrectionStrategy = typeof PayrollPayrollCorrectionStrategy[keyof typeof PayrollPayrollCorrectionStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollPayrollCorrectionStrategy = {
  one_time: 'one_time',
  amortized: 'amortized',
} as const;

export interface PayrollPayrollCorrection {
  /** Payroll correction ID */
  id?: string;
  /** Payroll correction amount */
  amount: number;
  /** Payroll correction period start date */
  period_start_date: string;
  /** Payroll correction period end date */
  period_end_date: string;
  /** Payroll correction strategy */
  strategy: PayrollPayrollCorrectionStrategy;
}

export interface PayrollPayrollDeduction {
  /** Payroll deduction ID */
  id?: string;
  /** YTD amount */
  ytd_amount: number;
  /** Calculation method */
  calculation_method: string;
  /** Period start date */
  period_start_date: string;
  /** Period end date */
  period_end_date: string;
}

/**
 * Create a connect session for the Payroll::ProviderConfig
 */
export interface PostPayrollFinchCreateConnectSession {
  payroll_provider_config_id: string;
}

/**
 * Exchange an authorization code for an access token and store it on the employer's payroll config
 */
export interface PostPayrollFinchExchangeAuthorizationCode {
  code: string;
}

/**
 * Create a Kombo Connect link
 */
export interface PostPayrollKomboCreateConnectLink {
  /** ID of payroll provider config to create a session for */
  payroll_provider_config_id: string;
}

/**
 * Activate a Kombo integration
 */
export interface PostPayrollKomboActivate {
  /** Activation token to exchange for integration details */
  token: string;
}

/**
 * payroll.PayrollConfig model
 */
export interface PayrollPayrollConfig {
  /** Payroll config ID */
  id: string;
  /** Whether the employer is connected to payroll */
  connected_to_payroll: boolean;
  /** Deduction method */
  deduction_method: string;
  /**
   * The last time the employer synced their employees with payroll
   * @nullable
   */
  last_employee_sync: string | null;
  /**
   * The display name of the payroll provider
   * @nullable
   */
  provider_display_name: string | null;
  /**
   * The icon URL of the payroll provider
   * @nullable
   */
  provider_icon_url: string | null;
  /** Whether the payroll provider supports pay schedule sync */
  supports_pay_schedule_sync: boolean;
  /** Whether the payroll provider supports automatic payroll deductions */
  supports_automatic_payroll_deductions: boolean;
  /** Whether the employer has automatic payroll deductions */
  has_automatic_payroll_deductions: boolean;
  /** Whether to show automated deductions notice */
  show_automated_deductions_notice: boolean;
  /**
   * The next time the employer will sync their employees with payroll
   * @nullable
   */
  next_employee_sync: string | null;
  /** Whether this is a shared payroll connection */
  shared_connection: boolean;
  /** Whether this is payroll is managed by a partner */
  partner_managed: boolean;
}

/**
 * Update automated deductions settings
 */
export interface PostPayrollManageAutomatedDeductions {
  enabled: boolean;
}

/**
 * Create a link token for the Payroll::ProviderConfig
 */
export interface PostPayrollMergeCreateLinkToken {
  payroll_provider_config_id: string;
}

/**
 * Exchange an public token for an account token and store it on the employer's payroll config
 */
export interface PostPayrollMergeExchangePublicToken {
  public_token: string;
}

/**
 * Attach employer to a shared Merge connection
 */
export interface PostPayrollMergeSharedConnection {
  api_connection_remote_id: string;
  shared_connection_name: string;
}

/**
 * payroll.PayPeriodList model
 */
export interface PayrollPayPeriodList {
  data?: PayrollPayPeriod[];
}

export interface PayrollPayPeriod {
  /** Pay period ID */
  id: string;
  /** Pay period end date */
  end_date: string;
  /** Pay period pay date */
  pay_date: string;
  /** Pay period status */
  status: string;
  /** Deductions available on date */
  deductions_available_on: string;
  latest_report?: ReportingReport;
}

/**
 * Type of report
 */
export type ReportingReportReportType = typeof ReportingReportReportType[keyof typeof ReportingReportReportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportingReportReportType = {
  employee_status: 'employee_status',
  payroll_pay_period_deduction: 'payroll_pay_period_deduction',
  employer_billing_invoice: 'employer_billing_invoice',
} as const;

/**
 * Current processing status of the report
 */
export type ReportingReportStatus = typeof ReportingReportStatus[keyof typeof ReportingReportStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportingReportStatus = {
  unprocessed: 'unprocessed',
  processing: 'processing',
  processed: 'processed',
  failed: 'failed',
} as const;

/**
 * reporting.Report model
 */
export interface ReportingReport {
  /** Report unique identifier */
  id: string;
  /** Type of report */
  report_type: ReportingReportReportType;
  /** Current processing status of the report */
  status: ReportingReportStatus;
  /** When report processing started */
  processing_started_at?: string;
  /** When report processing completed */
  processing_completed_at?: string;
  /** When the report was created */
  created_at: string;
  /** When the report was last updated */
  updated_at: string;
  /** URL to download the generated report file */
  download_url?: string;
  /** Type of entity that owns this report */
  owner_type: string;
  /** ID of the entity that owns this report */
  owner_id: string;
  /** ID of the user who requested the report */
  requested_by_user_id: string;
}

/**
 * payroll.PayScheduleList model
 */
export interface PayrollPayScheduleList {
  data?: PayrollPaySchedule[];
}

/**
 * Pay schedule frequency
 */
export type PayrollPayScheduleFrequency = typeof PayrollPayScheduleFrequency[keyof typeof PayrollPayScheduleFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollPayScheduleFrequency = {
  monthly: 'monthly',
  semi_monthly: 'semi_monthly',
  bi_weekly: 'bi_weekly',
  weekly: 'weekly',
} as const;

/**
 * Bank closure payment strategy (before/after/closest)
 */
export type PayrollPayScheduleBankClosureStrategy = typeof PayrollPayScheduleBankClosureStrategy[keyof typeof PayrollPayScheduleBankClosureStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollPayScheduleBankClosureStrategy = {
  before: 'before',
  after: 'after',
  closest: 'closest',
  ignore: 'ignore',
} as const;

/**
 * Schedule source
 */
export type PayrollPayScheduleSource = typeof PayrollPayScheduleSource[keyof typeof PayrollPayScheduleSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollPayScheduleSource = {
  finch: 'finch',
  merge_dev: 'merge_dev',
  kombo: 'kombo',
  manual: 'manual',
  default: 'default',
  adp: 'adp',
  partner: 'partner',
} as const;

/**
 * payroll.PaySchedule model
 */
export interface PayrollPaySchedule {
  /** Pay schedule ID */
  id: string;
  /** Pay schedule name */
  name: string;
  /**
   * Pay schedule reference date
   * @nullable
   */
  reference_pay_date?: string | null;
  /** Pay schedule start date */
  start_date?: string;
  /**
   * Pay schedule end date
   * @nullable
   */
  end_date?: string | null;
  /** Pay schedule frequency */
  frequency: PayrollPayScheduleFrequency;
  /** First pay day of the month (1-31, required for monthly/semi-monthly) */
  first_day?: number;
  /**
   * Second pay day of the month (1-31, required for semi-monthly)
   * @nullable
   */
  second_day?: number | null;
  /** Bank closure payment strategy (before/after/closest) */
  bank_closure_strategy: PayrollPayScheduleBankClosureStrategy;
  /** Schedule source */
  source: PayrollPayScheduleSource;
  /** Whether the pay schedule has been verified */
  is_verified: boolean;
  /** Whether the pay schedule has been archived */
  archived: boolean;
  /** Created at */
  created_at: string;
}

/**
 * payroll.SamplePayPeriodList model
 */
export interface PayrollSamplePayPeriodList {
  /** List of sample pay periods */
  data?: PayrollSamplePayPeriod[];
}

export interface PayrollSamplePayPeriod {
  /** The date payment will be made */
  pay_date: string;
  /** The end date of the pay period */
  period_end_date: string;
}

export type PostPayrollPaySchedulesFrequency = typeof PostPayrollPaySchedulesFrequency[keyof typeof PostPayrollPaySchedulesFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostPayrollPaySchedulesFrequency = {
  monthly: 'monthly',
  semi_monthly: 'semi_monthly',
  bi_weekly: 'bi_weekly',
  weekly: 'weekly',
} as const;

export type PostPayrollPaySchedulesBankClosureStrategy = typeof PostPayrollPaySchedulesBankClosureStrategy[keyof typeof PostPayrollPaySchedulesBankClosureStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostPayrollPaySchedulesBankClosureStrategy = {
  before: 'before',
  after: 'after',
  closest: 'closest',
  ignore: 'ignore',
} as const;

/**
 * Create a pay schedule
 */
export interface PostPayrollPaySchedules {
  frequency: PostPayrollPaySchedulesFrequency;
  bank_closure_strategy: PostPayrollPaySchedulesBankClosureStrategy;
  reference_pay_date?: string;
  /**
   * @minimum 1
   * @maximum 31
   */
  first_day?: number;
  /**
   * @minimum 1
   * @maximum 31
   */
  second_day?: number;
  start_date?: string;
  end_date?: string;
  is_verified?: boolean;
  name: string;
}

export type PutPayrollPaySchedulesIdFrequency = typeof PutPayrollPaySchedulesIdFrequency[keyof typeof PutPayrollPaySchedulesIdFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutPayrollPaySchedulesIdFrequency = {
  monthly: 'monthly',
  semi_monthly: 'semi_monthly',
  bi_weekly: 'bi_weekly',
  weekly: 'weekly',
} as const;

export type PutPayrollPaySchedulesIdBankClosureStrategy = typeof PutPayrollPaySchedulesIdBankClosureStrategy[keyof typeof PutPayrollPaySchedulesIdBankClosureStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutPayrollPaySchedulesIdBankClosureStrategy = {
  before: 'before',
  after: 'after',
  closest: 'closest',
  ignore: 'ignore',
} as const;

/**
 * Edit a pay schedule
 */
export interface PutPayrollPaySchedulesId {
  frequency: PutPayrollPaySchedulesIdFrequency;
  bank_closure_strategy: PutPayrollPaySchedulesIdBankClosureStrategy;
  reference_pay_date?: string;
  /**
   * @minimum 1
   * @maximum 31
   */
  first_day?: number;
  /**
   * @minimum 1
   * @maximum 31
   */
  second_day?: number;
  start_date?: string;
  end_date?: string;
  is_verified?: boolean;
  name: string;
}

/**
 * reimbursements.ReimbursementCreated model
 */
export interface ReimbursementsReimbursementCreated {
  /** ID of the created reimbursement */
  reimbursement_id: string;
  /** State of the created reimbursement */
  reimbursement_state: string;
  /** URL to redirect to after reimbursement creation */
  redirect_to: string;
  /** Status message */
  status_message?: string;
}

/**
 * marketplace.ProductList model
 */
export interface MarketplaceProductList {
  data?: MarketplaceProduct[];
}

export interface MarketplaceProduct {
  /** Product ID */
  id: string;
  /** Product name */
  name: string;
  /** Product description */
  description: string;
  /** Product brand */
  product_brand: string;
  /** Product categories */
  categories: string[];
  /** Product slug */
  slug: string;
  /** Merchant ID */
  marketplace_merchant_id: string;
  /** Merchant name */
  marketplace_merchant_name: string;
  base_price: Money;
  discounted_price?: Money;
  /** Price cadence of the product variant with the lowest effective price (e.g., one_time, monthly, etc) */
  price_cadence: string;
  /**
   * Full URL to the product image
   * @nullable
   */
  image_url: string | null;
  /** Whether the price shown should be qualified with ie. 'starting at'. True if the product has multiple variants, or if it has one variant which itself has a price qualifier. */
  has_price_qualifier: boolean;
  /** Rank of the product in the marketplace */
  rank: number;
  /** Whether the product has a future launch date */
  coming_soon: boolean;
  /** ISO 8601 timestamp of when the most recently created variant was added */
  most_recent_variant_created_at: string;
}

/**
 * Submit a new product request
 */
export interface PostMarketplaceProductRequest {
  /** Name of the product to request. */
  name: string;
}

/**
 * marketplace.ProductRequest model
 */
export interface MarketplaceProductRequest {
  /** Product Request ID */
  id: string;
  /** Requested product name */
  name: string;
  /** User ID of the submitter */
  submitted_by: string;
  /** Timestamp of creation */
  created_at: string;
  /** Timestamp of last update */
  updated_at: string;
}

/**
 * marketplace.HappiestBabyAddEmployeeResult model
 */
export interface MarketplaceHappiestBabyAddEmployeeResult {
  /** Whether the employee was successfully added */
  success: boolean;
}

export type PostMarketplacePurchasesShippingAddress = {
  name?: string;
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  country?: string;
};

/**
 * Create a hosted checkout purchase
 */
export interface PostMarketplacePurchases {
  /** ID of the product variant being purchased */
  marketplace_product_variant_id: string;
  shipping_address?: PostMarketplacePurchasesShippingAddress;
  /** First name of the person this purchase is for */
  purchased_for_first_name?: string;
  /** Last name of the person this purchase is for */
  purchased_for_last_name?: string;
  /** Date of birth of the person this purchase is for (ISO8601) */
  purchased_for_dob?: string;
  /** Email of the person this purchase is for */
  purchased_for_email?: string;
}

/**
 * marketplace.Purchase model
 */
export interface MarketplacePurchase {
  /** Purchase ID */
  id?: string;
  payment_amount?: Money;
  /** Purchase status */
  status?: string;
  /** ID of the product variant associated with the purchase */
  marketplace_product_variant_id?: string;
  /** ISO8601 timestamp of when the purchase was created */
  created_at?: string;
  variant: MarketplacePurchaseVariant;
  product: MarketplacePurchaseProduct;
  merchant: MarketplacePurchaseMerchant;
}

export interface MarketplacePurchaseVariant {
  /** Variant ID */
  id: string;
  /** Variant name */
  name: string;
  base_price: Money;
  discounted_price?: Money;
  /** Image URLs */
  image_urls: string[];
  /** Thumbnail image URLs */
  thumbnail_image_urls: string[];
  /** Purchase confirmation text */
  purchase_confirmation_text?: string;
}

export interface MarketplacePurchaseProduct {
  /** Product ID */
  id: string;
  /** Product name */
  name: string;
  /** Product brand */
  product_brand: string;
  /** Product slug */
  slug: string;
}

export interface MarketplacePurchaseMerchant {
  /** Merchant ID */
  id: string;
  /** Merchant name */
  name: string;
}

/**
 * employers.banking.PlaidAccount model
 */
export interface EmployersBankingPlaidAccount {
  /**
   * The logo of the institution the account is with
   * @nullable
   */
  institution_logo: string | null;
  /**
   * The name of the institution the account is with
   * @nullable
   */
  institution_name: string | null;
  /**
   * The date and time the account was last connected
   * @nullable
   */
  last_connected_at: string | null;
  /** The masked account number */
  mask: string;
  /** The name of the account */
  name: string;
  /** Whether the account requires reauthentication */
  requires_reauthentication: boolean;
  /** The verification status of the account */
  verification_status: string;
}

/**
 * employers.banking.PlaidLinkToken model
 */
export interface EmployersBankingPlaidLinkToken {
  /** A token used to initialize Plaid Link */
  link_token: string;
}

/**
 * Additional event metadata
 * @nullable
 */
export type PostEmployersBankingPlaidLogEventMetadata = { [key: string]: unknown } | null;

/**
 * Create a PlaidEvent
 */
export interface PostEmployersBankingPlaidLogEvent {
  /** The webhook type from Plaid Link */
  webhook_type: string;
  /** The webhook code from Plaid Link */
  webhook_code: string;
  /** The Plaid item ID */
  item_id?: string;
  /** The Plaid account ID */
  account_id?: string;
  /**
   * Additional event metadata
   * @nullable
   */
  metadata?: PostEmployersBankingPlaidLogEventMetadata;
  /**
   * Whether to mark the event as processed by default
   * @nullable
   */
  mark_as_processed?: boolean | null;
}

export type PostEmployersBankingPlaidProcessLinkAccountsItem = {
  /** The account ID */
  id: string;
  /** The account name */
  name: string;
  /** The account mask */
  mask: string;
  /** The account type */
  type: string;
  /** The account subtype */
  subtype: string;
  /**
   * The account verification status
   * @nullable
   */
  verification_status: string | null;
};

/**
 * The institution returned by Plaid Link
 * @nullable
 */
export type PostEmployersBankingPlaidProcessLinkInstitution = {
  /** The name of the institution */
  name: string;
  /** The institution ID */
  institution_id: string;
} | null;

/**
 * Process the Plaid link callback
 */
export interface PostEmployersBankingPlaidProcessLink {
  /** The accounts returned by Plaid Link */
  accounts: PostEmployersBankingPlaidProcessLinkAccountsItem[];
  /**
   * The institution returned by Plaid Link
   * @nullable
   */
  institution?: PostEmployersBankingPlaidProcessLinkInstitution;
  /** The link session ID returned by Plaid Link */
  link_session_id: string;
  /** The public token returned by Plaid Link */
  public_token: string;
}

/**
 * employers.EmployeesList model
 */
export interface EmployersEmployeesList {
  data?: EmployersEmployee[];
  pagination?: Pagination;
}

/**
 * employers.Employee model
 */
export interface EmployersEmployee {
  /** Employee ID */
  id: string;
  /** Employee First Name */
  first_name: string;
  /** Employee Last Name */
  last_name: string;
  /** Member ID if the employee has enrolled */
  member_id?: string;
  /** Employee work email */
  work_email?: string;
  /** Employee personal email */
  personal_email?: string;
  /** Employee pay schedule assignments */
  assigned_pay_schedules?: EmployersEmployeePaySchedule[];
  /** The date and time the employee was last invited to Thatch */
  last_invited_at?: string;
}

export interface EmployersEmployeePaySchedule {
  /** Employee Pay Schedule ID */
  id: string;
  /** Start date of the pay schedule assignment */
  start_date: string;
  /** End date of the pay schedule assignment */
  end_date?: string;
  /** ID of the assigned pay schedule */
  payroll_pay_schedule_id: string;
  pay_schedule?: PayrollPaySchedule;
}

/**
 * Assign employees to pay schedule
 */
export interface PostEmployersEmployeesPaySchedulesPayScheduleId {
  /** Employee IDs */
  employee_ids: string[];
}

/**
 * Deduplicate employees
 */
export interface PostEmployersEmployeesDuplicates {
  /** ID of the employee to from payroll */
  payroll_employee_id: string;
  /** ID of the manually added employee */
  manual_employee_id: string;
}

/**
 * Create employer ichra allowance amounts from a quote
 */
export interface PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote {
  /** Quote ID */
  quote_id: string;
  /** Overwrite existing allowance amounts */
  overwrite_existing?: boolean;
}

/**
 * The employer's business type
 */
export type EmployersEmployerBusinessType = typeof EmployersEmployerBusinessType[keyof typeof EmployersEmployerBusinessType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployersEmployerBusinessType = {
  c_corp: 'c_corp',
  s_corp: 's_corp',
  llc: 'llc',
  llp: 'llp',
  partnership: 'partnership',
  sole_proprietorship: 'sole_proprietorship',
  non_profit: 'non_profit',
} as const;

/**
 * The employer's state
 */
export type EmployersEmployerState = typeof EmployersEmployerState[keyof typeof EmployersEmployerState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployersEmployerState = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * The employer's industry
 * @nullable
 */
export type EmployersEmployerIndustry = typeof EmployersEmployerIndustry[keyof typeof EmployersEmployerIndustry] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployersEmployerIndustry = {
  accommodation_and_food_services: 'accommodation_and_food_services',
  administrative_and_support_and_waste_management_services: 'administrative_and_support_and_waste_management_services',
  agriculture_forestry_fishing_and_hunting: 'agriculture_forestry_fishing_and_hunting',
  arts_entertainment_and_recreation: 'arts_entertainment_and_recreation',
  construction: 'construction',
  educational_services: 'educational_services',
  finance_and_insurance: 'finance_and_insurance',
  health_care_and_social_assistance: 'health_care_and_social_assistance',
  information_and_technology: 'information_and_technology',
  management_of_companies_and_enterprises: 'management_of_companies_and_enterprises',
  manufacturing: 'manufacturing',
  mining_quarrying_and_oil_and_gas_extraction: 'mining_quarrying_and_oil_and_gas_extraction',
  other_services_except_public_administration: 'other_services_except_public_administration',
  professional_scientific_and_technical_services: 'professional_scientific_and_technical_services',
  public_administration: 'public_administration',
  real_estate_and_rental_and_leasing: 'real_estate_and_rental_and_leasing',
  retail_trade: 'retail_trade',
  transportation_and_warehousing: 'transportation_and_warehousing',
  utilities: 'utilities',
  wholesale_trade: 'wholesale_trade',
  other: 'other',
} as const;

/**
 * employers.Employer model
 */
export interface EmployersEmployer {
  /** The employer's unique identifier */
  id: string;
  /** Creation datetime in ISO 8601 format with UTC timezone, returned as a string */
  created_at: string;
  /** The employer's legal business name */
  name: string;
  /** The employer's business type */
  business_type: EmployersEmployerBusinessType;
  /** The employer's EIN (employer identification number) */
  ein: string;
  /**
   * The employer's DBA (doing business as) name, if different from the employer's legal business name
   * @nullable
   */
  dba?: string | null;
  /** The employer's address (line 1) */
  address_line1: string;
  /**
   * The employer's address (line 2)
   * @nullable
   */
  address_line2?: string | null;
  /** The employer's city */
  city: string;
  /** The employer's state */
  state: EmployersEmployerState;
  /** The employer's ZIP code, with optional +4 */
  zip: string;
  /**
   * The employer's phone number
   * @nullable
   */
  phone_number?: string | null;
  /** The number of employees */
  number_of_employees: number;
  /**
   * The employer's industry
   * @nullable
   */
  industry?: EmployersEmployerIndustry;
  /**
   * Whether the employer is considered an applicable large employer
   * @nullable
   */
  considered_applicable_large_employer?: boolean | null;
  /**
   * The employer's prospect ID
   * @nullable
   */
  quoting_prospect_id?: string | null;
  /** Whether the employer has a connected bank account through Plaid */
  has_plaid_account: boolean;
  /** Whether the employer has a payroll connection */
  has_payroll_connection: boolean;
  /** Whether the employer has a pay schedule */
  has_pay_schedule: boolean;
  /** Whether the employer profile is complete */
  employer_profile_complete: boolean;
  /** Whether the employer has an ICHRA config */
  has_current_ichra_config: boolean;
  /**
   * The employer's coverage start date
   * @nullable
   */
  coverage_start_date?: string | null;
  current_admin?: EmployersEmployerAdmin;
  /** Returns true if the employer is the current employer, false otherwise */
  is_current_employer?: boolean;
  /** The status of the owner invitation form */
  owner_invitation_form_status: string;
}

/**
 * How the employer heard about Thatch
 */
export type PostEmployersEmployersAttribution = typeof PostEmployersEmployersAttribution[keyof typeof PostEmployersEmployersAttribution];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEmployersEmployersAttribution = {
  search_engine: 'search_engine',
  social_media: 'social_media',
  billboard: 'billboard',
  radio: 'radio',
  mail: 'mail',
  video: 'video',
  webinar: 'webinar',
  email: 'email',
  word_of_mouth: 'word_of_mouth',
  other: 'other',
  partners_api: 'partners_api',
} as const;

/**
 * The onboarding experience the employer is using
 */
export type PostEmployersEmployersOnboardingExperience = typeof PostEmployersEmployersOnboardingExperience[keyof typeof PostEmployersEmployersOnboardingExperience];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEmployersEmployersOnboardingExperience = {
  v1: 'v1',
  v2: 'v2',
} as const;

export type PostEmployersEmployersAdmin = {
  /** Name of the employer's administrator */
  first_name?: string;
  /** Last name of the employer's administrator */
  last_name?: string;
  /** Job title of the employer's administrator */
  job_title?: string;
};

/**
 * Create an employer.
 */
export interface PostEmployersEmployers {
  /** Employer's legal business name */
  name: string;
  /** Employer's DBA (Doing Business As) name, if different from the employer's legal business name */
  dba?: string;
  /** How the employer heard about Thatch */
  attribution?: PostEmployersEmployersAttribution;
  /** Whether to create a prospect for the employer to support self-serve quoting. */
  create_prospect?: boolean;
  /** The onboarding experience the employer is using */
  onboarding_experience?: PostEmployersEmployersOnboardingExperience;
  /** Employer's phone number */
  phone_number?: string;
  admin?: PostEmployersEmployersAdmin;
}

/**
 * employers.ComplianceOwner model
 */
export interface EmployersComplianceOwner {
  /** Compliance owner ID */
  id: string;
  /** Email address of the compliance owner */
  email: string;
  /** First name of the compliance owner */
  first_name: string;
  /** Last name of the compliance owner */
  last_name: string;
  /** Indicates whether Owner is a controlling officer */
  is_controlling_officer: boolean;
  /** Indicates whether Owner is a beneficial owner */
  is_beneficial_owner: boolean;
  /** Title of the compliance owner */
  title: string;
  /** Timestamp when the compliance owner was created */
  created_at?: string;
}

/**
 * The new status for Owner invitation form
 */
export type PutEmployersEmployersIdUpdateOwnerInvitationFormStatusStatus = typeof PutEmployersEmployersIdUpdateOwnerInvitationFormStatusStatus[keyof typeof PutEmployersEmployersIdUpdateOwnerInvitationFormStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutEmployersEmployersIdUpdateOwnerInvitationFormStatusStatus = {
  not_started: 'not_started',
  started: 'started',
  submitted: 'submitted',
} as const;

/**
 * Update the owner invitation form status
 */
export interface PutEmployersEmployersIdUpdateOwnerInvitationFormStatus {
  /** The new status for Owner invitation form */
  status: PutEmployersEmployersIdUpdateOwnerInvitationFormStatusStatus;
}

/**
 * How the employer heard about Thatch
 */
export type PutEmployersEmployersIdProfileAttribution = typeof PutEmployersEmployersIdProfileAttribution[keyof typeof PutEmployersEmployersIdProfileAttribution];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutEmployersEmployersIdProfileAttribution = {
  search_engine: 'search_engine',
  social_media: 'social_media',
  billboard: 'billboard',
  radio: 'radio',
  mail: 'mail',
  video: 'video',
  webinar: 'webinar',
  email: 'email',
  word_of_mouth: 'word_of_mouth',
  other: 'other',
  partners_api: 'partners_api',
} as const;

/**
 * Employer's business type
 */
export type PutEmployersEmployersIdProfileBusinessType = typeof PutEmployersEmployersIdProfileBusinessType[keyof typeof PutEmployersEmployersIdProfileBusinessType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutEmployersEmployersIdProfileBusinessType = {
  c_corp: 'c_corp',
  s_corp: 's_corp',
  llc: 'llc',
  llp: 'llp',
  partnership: 'partnership',
  sole_proprietorship: 'sole_proprietorship',
  non_profit: 'non_profit',
} as const;

/**
 * Employer's state
 */
export type PutEmployersEmployersIdProfileState = typeof PutEmployersEmployersIdProfileState[keyof typeof PutEmployersEmployersIdProfileState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutEmployersEmployersIdProfileState = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * Employer's industry
 */
export type PutEmployersEmployersIdProfileIndustry = typeof PutEmployersEmployersIdProfileIndustry[keyof typeof PutEmployersEmployersIdProfileIndustry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutEmployersEmployersIdProfileIndustry = {
  accommodation_and_food_services: 'accommodation_and_food_services',
  administrative_and_support_and_waste_management_services: 'administrative_and_support_and_waste_management_services',
  agriculture_forestry_fishing_and_hunting: 'agriculture_forestry_fishing_and_hunting',
  arts_entertainment_and_recreation: 'arts_entertainment_and_recreation',
  construction: 'construction',
  educational_services: 'educational_services',
  finance_and_insurance: 'finance_and_insurance',
  health_care_and_social_assistance: 'health_care_and_social_assistance',
  information_and_technology: 'information_and_technology',
  management_of_companies_and_enterprises: 'management_of_companies_and_enterprises',
  manufacturing: 'manufacturing',
  mining_quarrying_and_oil_and_gas_extraction: 'mining_quarrying_and_oil_and_gas_extraction',
  other_services_except_public_administration: 'other_services_except_public_administration',
  professional_scientific_and_technical_services: 'professional_scientific_and_technical_services',
  public_administration: 'public_administration',
  real_estate_and_rental_and_leasing: 'real_estate_and_rental_and_leasing',
  retail_trade: 'retail_trade',
  transportation_and_warehousing: 'transportation_and_warehousing',
  utilities: 'utilities',
  wholesale_trade: 'wholesale_trade',
  other: 'other',
} as const;

/**
 * Update the employer's profile
 */
export interface PutEmployersEmployersIdProfile {
  /** Employer's address (line 1) */
  address_line1?: string;
  /** Employer's address (line 2) */
  address_line2?: string;
  /** How the employer heard about Thatch */
  attribution?: PutEmployersEmployersIdProfileAttribution;
  /** Employer's business type */
  business_type?: PutEmployersEmployersIdProfileBusinessType;
  /** Employer's city */
  city?: string;
  /** Employer's DBA (Doing Business As) name, if different from the employer's legal business name */
  dba?: string;
  /** Employer's EIN (Employer Identification Number) */
  ein?: string;
  /** Employer's legal business name */
  name?: string;
  /** The number of employees */
  number_of_employees?: number;
  /** The employer's phone number */
  phone_number?: string;
  /** Employer's state */
  state?: PutEmployersEmployersIdProfileState;
  /** Employer's ZIP code, with optional +4 */
  zip?: string;
  /** Employer's industry */
  industry?: PutEmployersEmployersIdProfileIndustry;
  /** Whether the employer is considered an applicable large employer */
  considered_applicable_large_employer?: boolean;
}

/**
 * employers.BillingV2OptInResponse model
 */
export interface EmployersBillingV2OptInResponse {
  /** Whether the user has opted in to billing v2 */
  opted_in: boolean;
}

/**
 * Register a user
 */
export interface PostEmployersRegistration {
  /** Email address for the employer's administrator */
  email: string;
  /** Password for the employer's administrator */
  password: string;
  /** Confirmation of the password */
  password_confirmation: string;
  /** Whether the user agrees to the Thatch agreements. */
  agree_to_terms: boolean;
}

/**
 * employers.CreatedUser model
 */
export interface EmployersCreatedUser {
  /** User ID */
  id: string;
}

export type PostEmployersReportingEmployeeStatusEnrollmentStatusesItem = typeof PostEmployersReportingEmployeeStatusEnrollmentStatusesItem[keyof typeof PostEmployersReportingEmployeeStatusEnrollmentStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEmployersReportingEmployeeStatusEnrollmentStatusesItem = {
  cobra: 'cobra',
  terminated: 'terminated',
  termination_scheduled: 'termination_scheduled',
  payroll_deactivated: 'payroll_deactivated',
  enrolled: 'enrolled',
  declined: 'declined',
  expired: 'expired',
  invited: 'invited',
  invite_pending: 'invite_pending',
  not_invited: 'not_invited',
  in_progress: 'in_progress',
  pending_automated_invite: 'pending_automated_invite',
  unknown: 'unknown',
} as const;

export type PostEmployersReportingEmployeeStatusEmploymentSubtypesItem = typeof PostEmployersReportingEmployeeStatusEmploymentSubtypesItem[keyof typeof PostEmployersReportingEmployeeStatusEmploymentSubtypesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEmployersReportingEmployeeStatusEmploymentSubtypesItem = {
  part_time: 'part_time',
  full_time: 'full_time',
} as const;

/**
 * Create a new employee status report
 */
export interface PostEmployersReportingEmployeeStatus {
  /** Plan year for the report */
  plan_year: number;
  /** Specific employee IDs to include */
  employee_ids?: string[];
  /** Filter by enrollment status */
  enrollment_statuses?: PostEmployersReportingEmployeeStatusEnrollmentStatusesItem[];
  /** Filter by employment subtype */
  employment_subtypes?: PostEmployersReportingEmployeeStatusEmploymentSubtypesItem[];
}

/**
 * Create a new employer billing invoice report
 */
export interface PostEmployersReportingEmployerBillingInvoice {
  /** Employer Invoice ID for report */
  employer_invoice_id: string;
}

/**
 * employers.CompleteOnboardingOptions model
 */
export interface EmployersCompleteOnboardingOptions {
  /** Whether the employer can invite employees */
  can_invite_employees: boolean;
  /** The dashboard URL to redirect to after onboarding is complete */
  dashboard_url: string;
}

/**
 * Update a renewal config
 */
export interface PatchEmployersRenewalsRenewalConfigsIdUpdate {
  /** Confirmed eligibility at */
  confirmed_eligibility_at: string;
}

/**
 * employers.renewals.PaginatedEmployeeList model
 */
export interface EmployersRenewalsPaginatedEmployeeList {
  data?: EmployersRenewalsEmployee[];
  pagination?: Pagination;
}

/**
 * Employee enrollment status for the given plan year
 */
export type EmployersRenewalsEmployeeEnrollmentStatus = typeof EmployersRenewalsEmployeeEnrollmentStatus[keyof typeof EmployersRenewalsEmployeeEnrollmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployersRenewalsEmployeeEnrollmentStatus = {
  enrolled: 'enrolled',
  declined: 'declined',
  not_invited: 'not_invited',
  offboarded: 'offboarded',
  not_accepted: 'not_accepted',
} as const;

/**
 * Employment type
 */
export type EmployersRenewalsEmployeeEmploymentType = typeof EmployersRenewalsEmployeeEmploymentType[keyof typeof EmployersRenewalsEmployeeEmploymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployersRenewalsEmployeeEmploymentType = {
  part_time: 'part_time',
  full_time: 'full_time',
} as const;

export interface EmployersRenewalsEmployee {
  /** Prospect Employee ID */
  id: string;
  /** Employee name */
  name: string;
  /** Employee date of birth */
  date_of_birth: string;
  /** Employee state */
  state?: string;
  /** Employee zip code */
  zip?: string;
  yearly_pay?: Money;
  /** Whether the employee is eligible for benefits */
  eligible: boolean;
  /** Employee enrollment status for the given plan year */
  enrollment_status: EmployersRenewalsEmployeeEnrollmentStatus;
  /** Employment type */
  employment_type?: EmployersRenewalsEmployeeEmploymentType;
}

/**
 * employers.renewals.EmployeeListMetadata model
 */
export interface EmployersRenewalsEmployeeListMetadata {
  /** List of eligible employee IDs */
  eligible_employee_ids: string[];
  /** List of enrolled employee IDs */
  enrolled_employee_ids: string[];
  /** Number of employees with missing required information */
  num_employees_with_missing_required_info: number;
  /** The Prospect Employee IDs who were invited last year and are missing required information */
  employee_ids_invited_last_year_with_missing_info: string[];
  /** Total number of offboarded employees */
  num_offboarded_employees: number;
}

/**
 * employers.renewals.RenewalQuoteResults model
 */
export interface EmployersRenewalsRenewalQuoteResults {
  current: QuotingQuoteResultWithBenchmark;
  reduced?: QuotingQuoteResultWithBenchmark;
  matched: QuotingQuoteResultWithBenchmark;
  upgraded?: QuotingQuoteResultWithBenchmark;
  custom?: QuotingQuoteResultWithBenchmark;
}

/**
 * employers.renewals.RateSummaryList model
 */
export interface EmployersRenewalsRateSummaryList {
  data?: EmployersRenewalsRateSummary[];
}

export interface EmployersRenewalsRateSummary {
  /** State abbreviation */
  state_abbreviation: string;
  /** Minimum change in rates for this state */
  min_change: number;
  /** Maximum change in rates for this state */
  max_change: number;
  /** Average change in rates for this state */
  average_change: number;
  /** Whether this state has finalized rates */
  has_finalized_rates: boolean;
}

/**
 * Create a new compliance owner
 */
export interface PostEmployersOwners {
  /** First name of Owner */
  first_name: string;
  /** Last name of the Owner */
  last_name: string;
  /** Email address of the Owner */
  email: string;
  /** Whether Owner has significant control over business */
  is_controlling_officer: boolean;
  /** Title of the Owner */
  title: string;
  /** Whether Owner is a beneficial owner */
  is_beneficial_owner: boolean;
}

/**
 * Update an existing compliance owner
 */
export interface PutEmployersOwnersId {
  /** First name of Owner */
  first_name: string;
  /** Last name of the Owner */
  last_name: string;
  /** Email address of the Owner */
  email: string;
  /** Whether Owner has significant control over business */
  is_controlling_officer: boolean;
  /** Title of the Owner */
  title: string;
  /** Whether Owner is a beneficial owner */
  is_beneficial_owner: boolean;
}

/**
 * Import ADP prospect from a JWT
 */
export interface PostPartnersAdpEmbeddedImportProspect {
  /** ADP JWT token */
  token: string;
}

/**
 * WebAPI_Entities_AdpProspectImportResponse model
 */
export interface WebAPIEntitiesAdpProspectImportResponse {
  /** Whether the request was successful */
  success?: boolean;
  job?: WebAPIEntitiesAdpJob;
}

/**
 * Enum representing error classification for ADP job
 */
export type WebAPIEntitiesAdpJobErrorType = typeof WebAPIEntitiesAdpJobErrorType[keyof typeof WebAPIEntitiesAdpJobErrorType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebAPIEntitiesAdpJobErrorType = {
  unknown: 'unknown',
  existing_thatch_user_requires_direct_login: 'existing_thatch_user_requires_direct_login',
} as const;

/**
 * WebAPI_Entities_AdpJob model
 */
export interface WebAPIEntitiesAdpJob {
  id?: string;
  state?: string;
  /** Enum representing error classification for ADP job */
  error_type?: WebAPIEntitiesAdpJobErrorType;
}

/**
 * Exchange a completed ADP job and JWT for an employer onboarding redirect URL
 */
export interface PostPartnersAdpEmbeddedJobIdOnboardingSession {
  /** ADP JWT token */
  token: string;
}

/**
 * partners.AdpOnboardingSessionRedirect model
 */
export interface PartnersAdpOnboardingSessionRedirect {
  /** URL to redirect the employer to claim their onboarding session */
  redirect_url: string;
}

/**
 * ValidationError model
 */
export interface ValidationError {
  /** Error message */
  message?: string;
  /** Validation errors */
  errors?: string[];
}

/**
 * Reset ADP employer data for testing (non-production only)
 */
export interface PostPartnersAdpEmbeddedResetEmployerData {
  /** ADP JWT token */
  token: string;
}

/**
 * partners.AdpResetResponse model
 */
export interface PartnersAdpResetResponse {
  /** Whether the reset operation was successful */
  success: boolean;
  /** Success or error message */
  message: string;
}

/**
 * partners.EmbeddedSessionStatus model
 */
export interface PartnersEmbeddedSessionStatus {
  /** The user ID for the embedded onboarding session */
  user_id?: string;
  /** The validated email address for the user in the embedded onboarding session */
  email: string;
  /** The email address of an existing employer_admin for the session employer. Used for error messages */
  session_employer_existing_admin_email?: string;
  /** Passwordless magic link URL that signs the user in and redirects to Next Steps */
  magic_link?: string;
  /** Allowed postMessage targetOrigins for the embedding partner (empty if unknown) */
  target_origins?: string[];
  /** Whether the user is an admin for another employer. Used for error messages */
  is_admin_for_another_employer?: boolean;
  /** Whether the user is an admin for the session employer and has set their password. Used to determine how far the user in the embedded session has progressed previously */
  has_session_signed_up?: boolean;
  /** Whether the embedding partner supports SSO. Used to hide password creation in the embedded flow */
  supports_sso?: boolean;
  /** ISO 8601 timestamp when the session's async data import was finalized. Null if still importing. */
  finalized_at?: string;
}

/**
 * partners.EmbeddedMagicLink model
 */
export interface PartnersEmbeddedMagicLink {
  /** Passwordless magic link URL that signs the user in and redirects to Next Steps */
  magic_link: string;
}

/**
 * partners.Partner model
 */
export interface PartnersPartner {
  /** The ID of the partner */
  id: string;
  /** The display name of the partner */
  display_name: string;
  /** The support email of the partner */
  support_email?: string;
  /** The support phone number of the partner */
  support_phone_number?: string;
  /** A user-friendly name for the partner */
  friendly_name?: string;
}

/**
 * Set password and associate onboarding user as employer admin
 */
export interface PostPartnersEmbeddedOnboardingSetPassword {
  password?: string;
  password_confirmation?: string;
  agree_to_terms: boolean;
}

/**
 * partners.PaginatedEmployers model
 */
export interface PartnersPaginatedEmployers {
  data?: PartnersEmployer[];
  pagination?: Pagination;
}

/**
 * Employer onboarding status
 */
export type PartnersEmployerStatus = typeof PartnersEmployerStatus[keyof typeof PartnersEmployerStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PartnersEmployerStatus = {
  open: 'open',
  launched: 'launched',
  quoted: 'quoted',
  quote_accepted: 'quote_accepted',
  payroll_connected: 'payroll_connected',
  bank_account_created: 'bank_account_created',
  completed: 'completed',
} as const;

/**
 * partners.Employer model
 */
export interface PartnersEmployer {
  /** Employer ID */
  id: string;
  /** Name */
  name: string;
  /** Location */
  location: string;
  /** Employer onboarding status */
  status: PartnersEmployerStatus;
  /** Whether the employee is in onboarding progress */
  in_progress: boolean;
  /** Amount of billable employees */
  billable_employees?: number;
  /** Total monthly earnings from all employees */
  earnings?: string;
  /** Signup date of the employer */
  created_at?: string;
  assignee?: PartnersPartnerAdmin;
  /**
   * The ID of the employer's corresponding prospect
   * @nullable
   */
  prospect_id?: string | null;
  last_active_admin_user: PartnersUser;
  /** The employer's phone number */
  phone_number?: string;
  /** Magic link to the employer's quote */
  quote_link?: string;
}

/**
 * partners.PartnerAdmin model
 */
export interface PartnersPartnerAdmin {
  /** Partner Admin ID */
  id: string;
  /** The full name of the partner admin */
  name: string;
  /** The first name of the partner admin */
  first_name: string;
  /** The last name of the partner admin */
  last_name: string;
  /** The email of the partner admin */
  email: string;
  /** The roles of the partner admin */
  roles: string[];
  /** When the partner admin was last invited */
  last_invited_at: string;
  /** The status of the partner admin */
  status: string;
}

export interface PartnersUser {
  /** The id of the user */
  id: string;
  /** The full name of the user */
  name?: string;
  /** The first name of the user */
  first_name?: string;
  /** The email address of the user */
  email: string;
  /** The date this user last signed in */
  last_signed_in?: string;
}

/**
 * Update employer assignee
 */
export interface PatchPartnersEmployersIdAssignee {
  /** User ID to assign the employer to */
  assignee_id?: string;
}

/**
 * partners.PaginatedPartnerAdminList model
 */
export interface PartnersPaginatedPartnerAdminList {
  data?: PartnersPartnerAdmin[];
  pagination?: Pagination;
}

/**
 * Create a partner admin
 */
export interface PostPartnersPartnerIdPartnerAdmins {
  /** The partner admin's first name */
  first_name: string;
  /** The partner admin's last name */
  last_name: string;
  /** The partner admin's work email */
  email: string;
}

/**
 * Update a partner admin
 */
export interface PutPartnersPartnerIdPartnerAdminsPartnerAdminId {
  /** The partner admin's first name */
  first_name?: string;
  /** The partner admin's last name */
  last_name?: string;
  /** The partner admin's work email */
  email?: string;
}

/**
 * The reason the token was not redeemed
 */
export type ResourceAccessTokensRedemptionResultCannotRedeemReason = typeof ResourceAccessTokensRedemptionResultCannotRedeemReason[keyof typeof ResourceAccessTokensRedemptionResultCannotRedeemReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResourceAccessTokensRedemptionResultCannotRedeemReason = {
  revoked: 'revoked',
  redeemed: 'redeemed',
  expired: 'expired',
  unredeemed: 'unredeemed',
  not_found: 'not_found',
} as const;

/**
 * resource_access_tokens.RedemptionResult model
 */
export interface ResourceAccessTokensRedemptionResult {
  /** Whether the token was redeemed */
  redeemed: boolean;
  /** The reason the token was not redeemed */
  cannot_redeem_reason?: ResourceAccessTokensRedemptionResultCannotRedeemReason;
}

/**
 * members.PaginatedBalanceTransactionList model
 */
export interface MembersPaginatedBalanceTransactionList {
  data?: BalanceTransaction[];
  pagination?: Pagination;
}

/**
 * The category of the balance transaction
 */
export type BalanceTransactionCategory = typeof BalanceTransactionCategory[keyof typeof BalanceTransactionCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BalanceTransactionCategory = {
  employer_allowance: 'employer_allowance',
  insurance_premium: 'insurance_premium',
  healthcare_expense: 'healthcare_expense',
  other: 'other',
} as const;

export interface BalanceTransaction {
  /** The ID of the balance transaction */
  id: string;
  /** The date of the balance transaction */
  date: string;
  amount: Money;
  /** The description of the balance transaction */
  description: string;
  /** The category of the balance transaction */
  category: BalanceTransactionCategory;
  /** The ID of the source of the balance transaction */
  source_id?: string;
}

/**
 * members.Balance model
 */
export interface MembersBalance {
  /** The effective date for this balance breakdown */
  effective_date: string;
  /** The plan year for this balance */
  plan_year: string;
  balance_amount?: Money;
  deduction_amount?: Money;
  /** Whether QME is enabled for this member */
  qme_enabled: boolean;
  monthly_allowance: Money;
  total_monthly_premiums: Money;
  off_thatch_premiums: Money;
  on_thatch_premiums: Money;
  /** The last time the balance was updated (in ISO 8601 format) */
  last_updated_at: string;
  /** The number of plans that this member has for this plan year */
  number_of_plans: number;
  /** When the warning about the balance deadline starts */
  deadline_warning_start_date: string;
  /** Until when can the user spend this balance */
  deadline_to_use_balance: string;
}

/**
 * DepositAccountDetail model
 */
export interface DepositAccountDetail {
  /** The account number of the deposit account,returns null if the member does not have a deposit account */
  account_number?: string;
  /** The routing number of the deposit account,returns null if the member does not have a deposit account */
  routing_number?: string;
  /** Whether the member sets up autopay,returns null if the member does not have a deposit account */
  member_sets_up_autopay?: boolean;
}

/**
 * members.CategorizedEnrollments model
 */
export interface MembersCategorizedEnrollments {
  /** Medical enrollments */
  medical_enrollments: MembersEnrollment[];
  /** Dental enrollments */
  dental_enrollments: MembersEnrollment[];
  /** Vision enrollments */
  vision_enrollments: MembersEnrollment[];
}

/**
 * Coverage Type
 */
export type MembersEnrollmentCoverageType = typeof MembersEnrollmentCoverageType[keyof typeof MembersEnrollmentCoverageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersEnrollmentCoverageType = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
} as const;

export interface MembersEnrollment {
  /** Enrollment ID */
  id: string;
  /** Carrier name */
  carrier_name?: string;
  /** The URL of the carrier image */
  carrier_image_url?: string;
  /** Carrier Member ID */
  carrier_member_id?: string;
  coverage_dates?: MembersCoverageDates;
  /** Coverage Type */
  coverage_type: MembersEnrollmentCoverageType;
  /** Array of covered participants ordered by relationship (self first, then spouse, then children) */
  covered_participants: MembersCoveredParticipant[];
  /** The date the member confirmed their enrollment */
  member_confirmed_at?: string;
  monthly_premium?: Money;
  overview?: MembersEnrollmentOverview;
  /** Plan name */
  plan_name?: string;
  /** URL to the coverage details for the enrollment - public plan page for medical, and SBC PDF for dental and vision */
  coverage_details_url?: string;
  /** Whether the member can self-serve change dependents */
  self_serve_change_dependents_enabled: boolean;
  /** Whether Thatch pays for this enrollment */
  thatch_pays?: boolean;
  max_reimbursement_amount?: Money;
}

export interface MembersCoverageDates {
  /** The expected start date of coverage for this enrollment */
  coverage_start_date?: string;
  /** The expected end date of coverage for this enrollment */
  coverage_end_date?: string;
}

export type MembersCoveredParticipantGender = typeof MembersCoveredParticipantGender[keyof typeof MembersCoveredParticipantGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersCoveredParticipantGender = {
  female: 'female',
  male: 'male',
  non_binary: 'non_binary',
} as const;

export type MembersCoveredParticipantRelationship = typeof MembersCoveredParticipantRelationship[keyof typeof MembersCoveredParticipantRelationship];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersCoveredParticipantRelationship = {
  self: 'self',
  spouse: 'spouse',
  child: 'child',
} as const;

export type MembersCoveredParticipantQualifyingLifeEventStatus = typeof MembersCoveredParticipantQualifyingLifeEventStatus[keyof typeof MembersCoveredParticipantQualifyingLifeEventStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersCoveredParticipantQualifyingLifeEventStatus = {
  awaiting_confirmation: 'awaiting_confirmation',
  complete: 'complete',
} as const;

export interface MembersCoveredParticipant {
  /** Covered Participant ID */
  id: string;
  dob: string;
  family_name: string;
  gender: MembersCoveredParticipantGender;
  given_name: string;
  relationship: MembersCoveredParticipantRelationship;
  ssn?: string;
  qualifying_life_event_status?: MembersCoveredParticipantQualifyingLifeEventStatus;
  /** The date when coverage starts for this participant */
  coverage_start_date?: string;
  /** The date when coverage ends for this participant */
  coverage_end_date?: string;
  /** The originally requested start date for coverage */
  requested_start_date?: string;
}

/**
 * Financial Status
 */
export type MembersEnrollmentOverviewFinancialStatus = typeof MembersEnrollmentOverviewFinancialStatus[keyof typeof MembersEnrollmentOverviewFinancialStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersEnrollmentOverviewFinancialStatus = {
  active: 'active',
  pending_payment: 'pending_payment',
  behind_on_payments: 'behind_on_payments',
  canceled: 'canceled',
  inactive: 'inactive',
  unknown: 'unknown',
} as const;

/**
 * Progress State
 */
export type MembersEnrollmentOverviewProgressState = typeof MembersEnrollmentOverviewProgressState[keyof typeof MembersEnrollmentOverviewProgressState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersEnrollmentOverviewProgressState = {
  failed: 'failed',
  on_track: 'on_track',
  needs_attention: 'needs_attention',
  enrolled: 'enrolled',
} as const;

export interface MembersEnrollmentOverview {
  /** Financial Status */
  financial_status?: MembersEnrollmentOverviewFinancialStatus;
  /** Array of enrollment progress events */
  progress_events?: MembersEnrollmentProgressEvent[];
  /** Progress State */
  progress_state?: MembersEnrollmentOverviewProgressState;
}

/**
 * Progress event state
 */
export type MembersEnrollmentProgressEventState = typeof MembersEnrollmentProgressEventState[keyof typeof MembersEnrollmentProgressEventState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersEnrollmentProgressEventState = {
  completed: 'completed',
  pending: 'pending',
  processing: 'processing',
} as const;

/**
 * Progress event label
 */
export type MembersEnrollmentProgressEventLabel = typeof MembersEnrollmentProgressEventLabel[keyof typeof MembersEnrollmentProgressEventLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersEnrollmentProgressEventLabel = {
  Received: 'Received',
  Submitted: 'Submitted',
  Enrolled: 'Enrolled',
} as const;

export interface MembersEnrollmentProgressEvent {
  /** Progress event state */
  state: MembersEnrollmentProgressEventState;
  /** Progress event label */
  label: MembersEnrollmentProgressEventLabel;
  /** Completion timestamp */
  completion_date?: string;
}

/**
 * Metadata about the instructions
 */
export type MembersInstructionListMetadata = { [key: string]: unknown };

/**
 * members.InstructionList model
 */
export interface MembersInstructionList {
  /** Array of instructions */
  data: MembersInstruction[];
  /** Metadata about the instructions */
  metadata: MembersInstructionListMetadata;
}

/**
 * The party responsible for following the instruction
 */
export type MembersInstructionResponsibility = typeof MembersInstructionResponsibility[keyof typeof MembersInstructionResponsibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersInstructionResponsibility = {
  member: 'member',
  thatch: 'thatch',
} as const;

/**
 * The completion status of the instruction
 */
export type MembersInstructionStatus = typeof MembersInstructionStatus[keyof typeof MembersInstructionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersInstructionStatus = {
  pending: 'pending',
  completed: 'completed',
  canceled: 'canceled',
} as const;

/**
 * members.Instruction model
 */
export interface MembersInstruction {
  /** The ID of the instruction */
  id: string;
  /** The party responsible for following the instruction */
  responsibility: MembersInstructionResponsibility;
  /** Headline of the instruction to be shown to the member */
  title: string;
  /** Detail text of the instruction to be shown to the member. Can contain HTML */
  details: string;
  /** The deadline for following the instruction, if applicable */
  deadline?: string;
  /** The completion status of the instruction */
  status: MembersInstructionStatus;
  /** The enrollment plan year for which the instruction applies to */
  plan_year?: number;
}

/**
 * The new status for the instruction
 */
export type PatchMembersInstructionsInstructionIdStatus = typeof PatchMembersInstructionsInstructionIdStatus[keyof typeof PatchMembersInstructionsInstructionIdStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchMembersInstructionsInstructionIdStatus = {
  pending: 'pending',
  completed: 'completed',
  canceled: 'canceled',
} as const;

/**
 * Update an instruction (currently only the status)
 */
export interface PatchMembersInstructionsInstructionId {
  /** The new status for the instruction */
  status: PatchMembersInstructionsInstructionIdStatus;
}

/**
 * members.PaginatedReimbursements model
 */
export interface MembersPaginatedReimbursements {
  data?: MemberReimbursement[];
  pagination?: Pagination;
}

/**
 * Reimbursement Purpose
 */
export type MemberReimbursementPurpose = typeof MemberReimbursementPurpose[keyof typeof MemberReimbursementPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberReimbursementPurpose = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
  qme: 'qme',
  premium: 'premium',
} as const;

/**
 * State of the reimbursement
 */
export type MemberReimbursementState = typeof MemberReimbursementState[keyof typeof MemberReimbursementState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberReimbursementState = {
  draft: 'draft',
  waiting_for_review: 'waiting_for_review',
  confirmed: 'confirmed',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  canceled: 'canceled',
  rejected: 'rejected',
  returned: 'returned',
} as const;

export interface MemberReimbursement {
  /** Reimbursement ID */
  id: string;
  /** Reimbursement Purpose */
  purpose: MemberReimbursementPurpose;
  /** State of the reimbursement */
  state: MemberReimbursementState;
  amount?: Money;
  reviewed_by_id?: string;
  reviewed_by_name?: string;
  has_receipts?: boolean;
  member_description?: string;
  created_at?: string;
  updated_at?: string;
}

/**
 * WebAPI_Feedback_Entities_Prompt model
 */
export interface WebAPIFeedbackEntitiesPrompt {
  id?: string;
  prompt_key?: string;
  status?: string;
  first_seen_at?: string;
  dismissed_at?: string;
  responded_at?: string;
  created_at?: string;
  updated_at?: string;
  version?: string;
  context?: string;
}

/**
 * Create a pending prompt for the current user (idempotent per key)
 */
export interface PostFeedbackPrompts {
  /** Prompt key */
  prompt_key: string;
}

/**
 * Rating
 */
export type PostFeedbackSubmissionsRating = typeof PostFeedbackSubmissionsRating[keyof typeof PostFeedbackSubmissionsRating];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostFeedbackSubmissionsRating = {
  great: 'great',
  okay: 'okay',
  not_good: 'not_good',
} as const;

/**
 * Create a feedback submission
 */
export interface PostFeedbackSubmissions {
  /** Rating */
  rating: PostFeedbackSubmissionsRating;
  /** Freeform feedback */
  comment?: string;
  /** Associated prompt instance id */
  feedback_prompt_id?: string;
}

/**
 * WebAPI_Feedback_Entities_Submission model
 */
export interface WebAPIFeedbackEntitiesSubmission {
  id?: string;
  prompt_key?: string;
  rating?: string;
  comment?: string;
  created_at?: string;
  updated_at?: string;
}

/**
 * users.UserOrganizations model
 */
export interface UsersUserOrganizations {
  /** List of member relationships with their employers */
  members: UsersMemberWithOrganization[];
  /** List of employer admin relationships with their employers */
  employer_admins: UsersEmployerAdminWithOrganization[];
  /** List of partner admin relationships with their partners */
  partner_admins: UsersPartnerAdminWithOrganization[];
}

export interface UsersMemberWithOrganization {
  /** The member's unique identifier */
  id: string;
  employer: UsersEmployer;
}

export interface UsersEmployer {
  /** The employer's unique identifier */
  id: string;
  /** The employer's name */
  name: string;
  /** The employer's display name */
  display_name: string;
}

export interface UsersEmployerAdminWithOrganization {
  /** The employer admin's unique identifier */
  id: string;
  employer: UsersEmployer;
  /** The partner name for the employer */
  partner_name?: string;
}

export interface UsersPartnerAdminWithOrganization {
  /** The partner admin's unique identifier */
  id: string;
  /** The roles of the partner admin */
  roles: string[];
  partner: PartnersPartner;
}

/**
 * Type of organization (member, employer, partner)
 */
export type PostUsersOrganizationsSetCurrentOrganizationType = typeof PostUsersOrganizationsSetCurrentOrganizationType[keyof typeof PostUsersOrganizationsSetCurrentOrganizationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostUsersOrganizationsSetCurrentOrganizationType = {
  member: 'member',
  employer: 'employer',
  partner: 'partner',
} as const;

/**
 * Set the current organization
 */
export interface PostUsersOrganizationsSetCurrent {
  /** Type of organization (member, employer, partner) */
  organization_type: PostUsersOrganizationsSetCurrentOrganizationType;
  /** The ID of the actual organization (member ID, employer ID, or partner ID) to set */
  organization_id: string;
}

export type GetAccessRequestsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter by resource requested
 */
'filter[requested_resources][]'?: string[];
/**
 * Filter by ID of user who made the access request
 */
'filter[requested_by_ids][]'?: string[];
/**
 * Filter by state of the access request
 */
'filter[request_states][]'?: string[];
/**
 * Only include items that grant access at the present moment
 */
'filter[only_allowing_immediate_access]'?: boolean;
};

export type GetAdminCompliancePoliciesParams = {
/**
 * Compliance provider (e.g., Footprint)
 */
provider: string;
/**
 * Type of entity (Employer or Compliance::Owner)
 */
entity_type: string;
};

export type GetAdminFinchEmployerParams = {
/**
 * The ID of the employer
 */
employer_id: string;
};

export type GetAdminFinchEmployerEmployeesParams = {
/**
 * The ID of the employer
 */
employer_id: string;
};

export type GetAdminFinchApiIntrospectParams = {
/**
 * The ID of the employer
 */
employer_id: string;
};

export type GetAdminFinchApiDirectoryParams = {
/**
 * The ID of the employer
 */
employer_id: string;
};

export type GetAdminFinchApiIndividualParams = {
/**
 * The ID of the employer
 */
employer_id: string;
/**
 * The Finch individual IDs to query
 */
'finch_ids[]': string[];
};

export type GetAdminFinchApiEmploymentParams = {
/**
 * The ID of the employer
 */
employer_id: string;
/**
 * The Finch individual IDs to query
 */
'finch_ids[]': string[];
};

export type GetAdminFinchApiPaymentParams = {
/**
 * The ID of the employer
 */
employer_id: string;
/**
 * The start date for the payment
 */
start_date: string;
/**
 * The end date for the payment
 */
end_date: string;
};

export type GetAdminFinchApiPayStatementParams = {
/**
 * The ID of the employer
 */
employer_id: string;
/**
 * The Finch payment IDs to query
 */
'payment_ids[]': string[];
};

export type GetAdminFinchApiBenefitsParams = {
/**
 * The ID of the employer
 */
employer_id: string;
};

export type GetAdminFinchApiPayGroupsParams = {
/**
 * The ID of the employer
 */
employer_id: string;
};

export type GetAdminFinchApiPayGroupParams = {
/**
 * The ID of the employer
 */
employer_id: string;
/**
 * The Finch Pay Group ID to query
 */
pay_group_id: string;
};

export type GetAdminMergeEmployerIsolvedClientsParams = {
/**
 * The ID of the employer
 */
employer_id: string;
};

export type GetAdminEmployerOpenEnrollmentParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * The open enrollment year to fetch
 */
open_enrollment_year: number;
'sort[employer_name]'?: GetAdminEmployerOpenEnrollmentSortEmployerName;
'sort[cohort]'?: GetAdminEmployerOpenEnrollmentSortCohort;
'sort[status]'?: GetAdminEmployerOpenEnrollmentSortStatus;
'sort[eligible_employee_count]'?: GetAdminEmployerOpenEnrollmentSortEligibleEmployeeCount;
'sort[percentage_of_employees_with_final_rates]'?: GetAdminEmployerOpenEnrollmentSortPercentageOfEmployeesWithFinalRates;
'sort[current_year_monthly_employer_contribution]'?: GetAdminEmployerOpenEnrollmentSortCurrentYearMonthlyEmployerContribution;
'sort[open_enrollment_year_monthly_employer_contribution]'?: GetAdminEmployerOpenEnrollmentSortOpenEnrollmentYearMonthlyEmployerContribution;
'sort[monthly_employer_contribution_delta]'?: GetAdminEmployerOpenEnrollmentSortMonthlyEmployerContributionDelta;
/**
 * Filter by status
 */
'filter[status][]'?: string[];
/**
 * Filter by cohort
 */
'filter[cohort][]'?: string[];
/**
 * Filter by employer IDs
 */
'filter[employer_ids][]'?: string[];
/**
 * Minimum employee count
 */
'filter[min_employee_count]'?: string;
/**
 * Maximum employee count
 */
'filter[max_employee_count]'?: string;
/**
 * Minimum final rates percentage
 */
'filter[min_final_rates]'?: string;
/**
 * Maximum final rates percentage
 */
'filter[max_final_rates]'?: string;
};

export type GetAdminEmployerOpenEnrollmentSortEmployerName = typeof GetAdminEmployerOpenEnrollmentSortEmployerName[keyof typeof GetAdminEmployerOpenEnrollmentSortEmployerName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortEmployerName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEmployerOpenEnrollmentSortCohort = typeof GetAdminEmployerOpenEnrollmentSortCohort[keyof typeof GetAdminEmployerOpenEnrollmentSortCohort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortCohort = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEmployerOpenEnrollmentSortStatus = typeof GetAdminEmployerOpenEnrollmentSortStatus[keyof typeof GetAdminEmployerOpenEnrollmentSortStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortStatus = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEmployerOpenEnrollmentSortEligibleEmployeeCount = typeof GetAdminEmployerOpenEnrollmentSortEligibleEmployeeCount[keyof typeof GetAdminEmployerOpenEnrollmentSortEligibleEmployeeCount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortEligibleEmployeeCount = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEmployerOpenEnrollmentSortPercentageOfEmployeesWithFinalRates = typeof GetAdminEmployerOpenEnrollmentSortPercentageOfEmployeesWithFinalRates[keyof typeof GetAdminEmployerOpenEnrollmentSortPercentageOfEmployeesWithFinalRates];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortPercentageOfEmployeesWithFinalRates = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEmployerOpenEnrollmentSortCurrentYearMonthlyEmployerContribution = typeof GetAdminEmployerOpenEnrollmentSortCurrentYearMonthlyEmployerContribution[keyof typeof GetAdminEmployerOpenEnrollmentSortCurrentYearMonthlyEmployerContribution];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortCurrentYearMonthlyEmployerContribution = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEmployerOpenEnrollmentSortOpenEnrollmentYearMonthlyEmployerContribution = typeof GetAdminEmployerOpenEnrollmentSortOpenEnrollmentYearMonthlyEmployerContribution[keyof typeof GetAdminEmployerOpenEnrollmentSortOpenEnrollmentYearMonthlyEmployerContribution];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortOpenEnrollmentYearMonthlyEmployerContribution = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEmployerOpenEnrollmentSortMonthlyEmployerContributionDelta = typeof GetAdminEmployerOpenEnrollmentSortMonthlyEmployerContributionDelta[keyof typeof GetAdminEmployerOpenEnrollmentSortMonthlyEmployerContributionDelta];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployerOpenEnrollmentSortMonthlyEmployerContributionDelta = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminEnrollmentEventParams = {
/**
 * The ID of the employee
 */
employee_id: string;
};

export type GetAdminEmployersParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter employers by name (case insensitive) or ID
 */
'filter[name]'?: string;
/**
 * Filter employers by review status
 */
'filter[review_statuses][]'?: GetAdminEmployersFilterReviewStatusesItem[];
/**
 * Filter employers by IDs
 */
'filter[employer_ids][]'?: string[];
/**
 * Filter employers by bank partner
 */
'filter[bank_partners][]'?: GetAdminEmployersFilterBankPartnersItem[];
/**
 * Filter employers by bank onboarding status
 */
'filter[bank_onboarding_status]'?: GetAdminEmployersFilterBankOnboardingStatus;
/**
 * Filter employers by plaid account verification status
 */
'filter[plaid_account_verification_status][]'?: GetAdminEmployersFilterPlaidAccountVerificationStatusItem[];
/**
 * Filter employers by onboarding status
 */
'filter[onboarding_status][]'?: GetAdminEmployersFilterOnboardingStatusItem[];
/**
 * Filter employers by whether they have invited employees
 */
'filter[invited_employees]'?: boolean;
/**
 * Filter employers by whether they have confirmed enrollments
 */
'filter[has_confirmed_enrollments]'?: boolean;
/**
 * Filter employers by assigned broker IDs
 */
'filter[broker_ids][]'?: string[];
/**
 * Sort order
 */
sort?: string;
};

export type GetAdminEmployersFilterReviewStatusesItem = typeof GetAdminEmployersFilterReviewStatusesItem[keyof typeof GetAdminEmployersFilterReviewStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployersFilterReviewStatusesItem = {
  pending: 'pending',
  approved: 'approved',
  denied: 'denied',
  inactive_duplicate: 'inactive_duplicate',
  inactive_withdrawn: 'inactive_withdrawn',
  inactive_ineligible: 'inactive_ineligible',
  inactive_churned: 'inactive_churned',
} as const;

export type GetAdminEmployersFilterBankPartnersItem = typeof GetAdminEmployersFilterBankPartnersItem[keyof typeof GetAdminEmployersFilterBankPartnersItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployersFilterBankPartnersItem = {
  Bangor: 'Bangor',
  Unit: 'Unit',
} as const;

export type GetAdminEmployersFilterBankOnboardingStatus = typeof GetAdminEmployersFilterBankOnboardingStatus[keyof typeof GetAdminEmployersFilterBankOnboardingStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployersFilterBankOnboardingStatus = {
  none: 'none',
  passing: 'passing',
  pending: 'pending',
  failing: 'failing',
} as const;

export type GetAdminEmployersFilterPlaidAccountVerificationStatusItem = typeof GetAdminEmployersFilterPlaidAccountVerificationStatusItem[keyof typeof GetAdminEmployersFilterPlaidAccountVerificationStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployersFilterPlaidAccountVerificationStatusItem = {
  none: 'none',
  pending: 'pending',
  verified: 'verified',
  failed: 'failed',
} as const;

export type GetAdminEmployersFilterOnboardingStatusItem = typeof GetAdminEmployersFilterOnboardingStatusItem[keyof typeof GetAdminEmployersFilterOnboardingStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminEmployersFilterOnboardingStatusItem = {
  open: 'open',
  launched: 'launched',
  quoted: 'quoted',
  quote_accepted: 'quote_accepted',
  payroll_connected: 'payroll_connected',
  bank_account_created: 'bank_account_created',
  completed: 'completed',
  'launched|quoted|quote_accepted': 'launched|quoted|quote_accepted',
} as const;

export type GetAdminSearchParams = {
/**
 * The query to search for. This can be an ID or a name/email.
 * @maxLength 1024
 */
query: string;
/**
 * Is User search enabled
 */
user?: boolean;
/**
 * Is Employer search enabled
 */
employer?: boolean;
/**
 * Is Employee search enabled
 */
employee?: boolean;
/**
 * Is Member search enabled
 */
member?: boolean;
/**
 * Is EmployerAdmin search enabled
 */
employerAdmin?: boolean;
/**
 * Is Partner search enabled
 */
partner?: boolean;
/**
 * Is PartnerAdmin search enabled
 */
partnerAdmin?: boolean;
/**
 * Is Prospect search enabled
 */
prospect?: boolean;
};

export type GetAdminPartnersParams = {
/**
 * Employer to include partner relationship for, falling back to the default relationship
 */
employer_id?: string;
};

export type GetAdminLedgerAccountsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Sort order
 */
sort?: string;
/**
 * The ID of a base ledger account
 */
id?: string;
/**
 * A query to filter ledger accounts by path
 */
query?: string;
/**
 * A cutoff date to filter rollup amounts
 */
cutoff?: string;
/**
 * The field to sort by (deprecated, use sort)
 */
sort_by?: string;
/**
 * The direction to sort by (deprecated, use sort)
 */
sort_order?: string;
};

export type GetAdminLedgerAccountsIdParams = {
/**
 * A cutoff date to filter rollup amounts
 */
cutoff?: string;
};

export type GetAdminLedgerEntriesParams = {
/**
 * The ID of a base ledger account
 */
ledger_account_id?: string;
/**
 * A query to filter ledger accounts by path
 */
ledger_account_query?: string;
/**
 * A cutoff date to filter ledger entries by created_at
 */
cutoff?: string;
/**
 * The field to sort by (deprecated, use sort)
 */
sort_by?: string;
/**
 * The direction to sort by (deprecated, use sort)
 */
sort_order?: string;
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Sort order
 */
sort?: string;
};

export type GetAdminMedicalPlanDataParams = {
/**
 * Plan year
 */
year?: number;
};

export type GetAdminMedicalPlanIngestionsParams = {
/**
 * Plan year (omit for all years)
 */
year?: number;
/**
 * Ingestion status filter (pending, processing, success, failed, cancelled)
 */
status?: string;
/**
 * State code filter
 */
state_code?: string;
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetAdminMemberConsistentDeductionsParams = {
/**
 * Member ID
 */
member_id: string;
};

export type GetAdminSubstantiationsParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
'sort[review_status]'?: GetAdminSubstantiationsSortReviewStatus;
'sort[created_at]'?: GetAdminSubstantiationsSortCreatedAt;
'sort[reviewed_at]'?: GetAdminSubstantiationsSortReviewedAt;
'filter[review_statuses][]'?: string[];
'filter[medical_care][]'?: string[];
'filter[ongoing_coverage][]'?: string[];
'filter[member_ids][]'?: string[];
'filter[employer_ids][]'?: string[];
'filter[broker_ids][]'?: string[];
'filter[after_date]'?: string;
'filter[before_date]'?: string;
'filter[vip_employer]'?: string;
'filter[has_receipts]'?: string;
'filter[payment_method_unit_card]'?: string;
};

export type GetAdminSubstantiationsSortReviewStatus = typeof GetAdminSubstantiationsSortReviewStatus[keyof typeof GetAdminSubstantiationsSortReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminSubstantiationsSortReviewStatus = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminSubstantiationsSortCreatedAt = typeof GetAdminSubstantiationsSortCreatedAt[keyof typeof GetAdminSubstantiationsSortCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminSubstantiationsSortCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminSubstantiationsSortReviewedAt = typeof GetAdminSubstantiationsSortReviewedAt[keyof typeof GetAdminSubstantiationsSortReviewedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminSubstantiationsSortReviewedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
};

export type GetAdminReimbursementsParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
'sort[state]'?: GetAdminReimbursementsSortState;
'sort[created_at]'?: GetAdminReimbursementsSortCreatedAt;
'filter[states][]'?: string[];
'filter[purposes][]'?: string[];
'filter[enrollment_categories][]'?: string[];
'filter[member_ids][]'?: string[];
'filter[employer_ids][]'?: string[];
'filter[broker_ids][]'?: string[];
'filter[has_receipts]'?: string;
'filter[after_date]'?: string;
'filter[before_date]'?: string;
'filter[vip_employer]'?: string;
'filter[off_thatch_or_medicare]'?: string;
};

export type GetAdminReimbursementsSortState = typeof GetAdminReimbursementsSortState[keyof typeof GetAdminReimbursementsSortState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminReimbursementsSortState = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminReimbursementsSortCreatedAt = typeof GetAdminReimbursementsSortCreatedAt[keyof typeof GetAdminReimbursementsSortCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminReimbursementsSortCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAdminMedicalPlanProjectionsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Year to filter by (matches projected_from_year)
 */
year: number;
/**
 * Carrier name to filter by
 */
carrier_name?: string;
/**
 * State abbreviation to filter by
 */
state?: string;
};

export type GetAdminMedicalPlanProjectionsDownloadProjectionsParams = {
/**
 * Year to download projections for
 */
year: number;
};

export type GetAdminIneligibleSpendReportsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Search employers by name
 */
search?: string;
};

export type GetAdminUnmappedPlansParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter by states
 */
'filters[states][]'?: string[];
/**
 * Filter by carrier names
 */
'filters[carrier_names][]'?: string[];
/**
 * Filter on employer renewal status
 */
'filters[renewed_employers_only]'?: boolean;
};

export type GetAdminMappedPlansParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter by states
 */
'filters[states][]'?: string[];
/**
 * Filter by carrier names
 */
'filters[carrier_names][]'?: string[];
/**
 * Filter by source (Ideon or Thatch)
 */
'filters[source]'?: string;
/**
 * Include deactivated plan mappings
 */
'filters[show_deactivated]'?: boolean;
/**
 * Filter on employer renewal status
 */
'filters[renewed_employers_only]'?: boolean;
/**
 * Filter to only show plans with different carrier names
 */
'filters[different_carriers_only]'?: boolean;
};

export type GetAdminPlanMappingsDownloadTemplateParams = {
/**
 * Template type to download
 */
template_type: GetAdminPlanMappingsDownloadTemplateTemplateType;
};

export type GetAdminPlanMappingsDownloadTemplateTemplateType = typeof GetAdminPlanMappingsDownloadTemplateTemplateType[keyof typeof GetAdminPlanMappingsDownloadTemplateTemplateType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminPlanMappingsDownloadTemplateTemplateType = {
  empty: 'empty',
  populated: 'populated',
} as const;

export type GetAdminSidebarPromoCardsParams = {
/**
 * Filter by target audience
 */
target_audience?: GetAdminSidebarPromoCardsTargetAudience;
};

export type GetAdminSidebarPromoCardsTargetAudience = typeof GetAdminSidebarPromoCardsTargetAudience[keyof typeof GetAdminSidebarPromoCardsTargetAudience];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminSidebarPromoCardsTargetAudience = {
  employer: 'employer',
  member: 'member',
  partner: 'partner',
} as const;

export type GetBrokersAuditsParams = {
/**
 * The model type of the auditable record
 */
auditable_type: string;
/**
 * The ID of the auditable record
 */
auditable_id: string;
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetBrokersEmployersParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter employers by name (case insensitive) or ID
 */
'filter[name]'?: string;
/**
 * Filter by employer review statuses (pending, approved, denied, etc.). Defaults to ['approved'] if not specified.
 */
'filter[review_statuses][]'?: string[];
/**
 * Sort order
 */
sort?: string;
};

export type GetBrokersEmployersEmployerIdEmployeesParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter employees by enrollment status
 */
'filter[enrollment_status]'?: GetBrokersEmployersEmployerIdEmployeesFilterEnrollmentStatus;
};

export type GetBrokersEmployersEmployerIdEmployeesFilterEnrollmentStatus = typeof GetBrokersEmployersEmployerIdEmployeesFilterEnrollmentStatus[keyof typeof GetBrokersEmployersEmployerIdEmployeesFilterEnrollmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersEmployersEmployerIdEmployeesFilterEnrollmentStatus = {
  cobra: 'cobra',
  terminated: 'terminated',
  termination_scheduled: 'termination_scheduled',
  payroll_deactivated: 'payroll_deactivated',
  not_invited: 'not_invited',
  invited: 'invited',
  in_progress: 'in_progress',
  enrolled: 'enrolled',
  unknown: 'unknown',
} as const;

export type GetBrokersMembersParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter by date of birth (YYYY-MM-DD)
 */
'filter[date_of_birth]'?: string;
/**
 * Filter by email address
 */
'filter[email]'?: string;
/**
 * Filter by employer name
 */
'filter[employer_name]'?: string;
/**
 * Filter by last name
 */
'filter[family_name]'?: string;
/**
 * Filter by first name
 */
'filter[given_name]'?: string;
/**
 * Filter by ID
 */
'filter[id]'?: string;
/**
 * Filter by name (searches both first and last name or ID if provided)
 */
'filter[name]'?: string;
/**
 * Filter by state
 */
'filter[state]'?: string;
'sort[date_of_birth]'?: GetBrokersMembersSortDateOfBirth;
'sort[email]'?: GetBrokersMembersSortEmail;
'sort[employer_name]'?: GetBrokersMembersSortEmployerName;
'sort[family_name]'?: GetBrokersMembersSortFamilyName;
'sort[given_name]'?: GetBrokersMembersSortGivenName;
'sort[id]'?: GetBrokersMembersSortId;
'sort[state]'?: GetBrokersMembersSortState;
};

export type GetBrokersMembersSortDateOfBirth = typeof GetBrokersMembersSortDateOfBirth[keyof typeof GetBrokersMembersSortDateOfBirth];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersMembersSortDateOfBirth = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersMembersSortEmail = typeof GetBrokersMembersSortEmail[keyof typeof GetBrokersMembersSortEmail];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersMembersSortEmail = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersMembersSortEmployerName = typeof GetBrokersMembersSortEmployerName[keyof typeof GetBrokersMembersSortEmployerName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersMembersSortEmployerName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersMembersSortFamilyName = typeof GetBrokersMembersSortFamilyName[keyof typeof GetBrokersMembersSortFamilyName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersMembersSortFamilyName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersMembersSortGivenName = typeof GetBrokersMembersSortGivenName[keyof typeof GetBrokersMembersSortGivenName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersMembersSortGivenName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersMembersSortId = typeof GetBrokersMembersSortId[keyof typeof GetBrokersMembersSortId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersMembersSortId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersMembersSortState = typeof GetBrokersMembersSortState[keyof typeof GetBrokersMembersSortState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersMembersSortState = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersMembersMemberIdIchraDataParams = {
/**
 * Plan year for ICHRA data (defaults to current year)
 */
plan_year?: number;
};

export type DeleteBrokersMembersMemberIdFileUploadsBlobIdParams = {
/**
 * Type of file upload to delete
 */
upload_type: DeleteBrokersMembersMemberIdFileUploadsBlobIdUploadType;
};

export type DeleteBrokersMembersMemberIdFileUploadsBlobIdUploadType = typeof DeleteBrokersMembersMemberIdFileUploadsBlobIdUploadType[keyof typeof DeleteBrokersMembersMemberIdFileUploadsBlobIdUploadType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteBrokersMembersMemberIdFileUploadsBlobIdUploadType = {
  member_upload: 'member_upload',
  broker_upload: 'broker_upload',
  broker_private_upload: 'broker_private_upload',
} as const;

export type GetBrokersMembersMemberIdTransactionsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter transactions by enrollment id. When the string 'none' is passed, it will return transactions that we don't believe are paying for a premium. When the string 'missing' is passed, it will return transactions that we think are paying for a premium, but we don't know which enrollment. When not passed, it will return all transactions.
 */
'filter[enrollment_id]'?: string;
};

export type GetBrokersMembersMemberIdEnrollmentsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Plan year
 */
plan_year?: number;
/**
 * Include cost of coverage through this month
 */
include_cost_of_coverage_through?: number;
/**
 * Include canceled enrollments
 */
include_canceled?: boolean;
};

export type GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams = {
/**
 * Plan year for cost calculations
 */
plan_year: number;
/**
 * Starting month (1-12)
 */
start_month: number;
/**
 * Ending month (1-12)
 */
end_month: number;
/**
 * Specific enrollment ID to calculate costs for
 */
enrollment_id?: string;
/**
 * Whether to account for losses in cost calculations
 */
account_for_losses?: boolean;
};

export type DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams = {
/**
 * Reason for this coverage change
 */
coverage_audit_reason?: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason;
/**
 * Coverage ID
 */
coverage_id: string;
};

export type DeleteBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason = typeof DeleteBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason[keyof typeof DeleteBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteBrokersMembersMemberIdEnrollmentsIdCoverageCoverageAuditReason = {
  unknown: 'unknown',
  qualifying_life_event: 'qualifying_life_event',
  initial_ichra_invite: 'initial_ichra_invite',
  open_enrollment: 'open_enrollment',
  administrative_correction: 'administrative_correction',
  termination: 'termination',
  member_initiated_change: 'member_initiated_change',
} as const;

export type GetBrokersMembersMemberIdCoveredParticipantsParams = {
/**
 * Plan Year (returns all participants if not provided)
 */
plan_year?: number;
/**
 * Include pending participants
 */
include_pending?: boolean;
};

export type GetBrokersMembersMemberIdQualifyingLifeEventsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Plan Year
 */
plan_year?: number;
/**
 * Include in progress qualifying life events
 */
include_in_progress?: boolean;
};

export type GetBrokersMembersMemberIdStripeIssuingCardsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetBrokersNotesParams = {
member_id?: string;
employer_id?: string;
subject_type?: string;
subject_id?: string;
};

export type GetBrokersUnprocessedEnrollmentsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter enrollments by name (case insensitive)
 */
'filter[formatted_member_name]'?: string;
/**
 * Sort order
 */
sort?: string;
};

export type GetBrokersBrokersParams = {
/**
 * Sort order
 */
sort?: string;
};

export type GetBrokersTagsParams = {
/**
 * Whether to return archived tags or active ones
 */
archived?: boolean;
};

export type GetBrokersBrokerAttentionNeededItemsStatisticsParams = {
'filter[statuses][]'?: string[];
'filter[exclude_statuses][]'?: string[];
'filter[reasons][]'?: string[];
'filter[exclude_reasons][]'?: string[];
'filter[enrollment_types][]'?: string[];
'filter[exclude_enrollment_types][]'?: string[];
'filter[enrollment_categories][]'?: string[];
'filter[exclude_enrollment_categories][]'?: string[];
'filter[member_ids][]'?: string[];
'filter[exclude_member_ids][]'?: string[];
'filter[employer_ids][]'?: string[];
'filter[exclude_employer_ids][]'?: string[];
'filter[broker_ids][]'?: string[];
'filter[exclude_broker_ids][]'?: string[];
'filter[tag_ids][]'?: string[];
'filter[exclude_tag_ids][]'?: string[];
'filter[carrier_names][]'?: string[];
'filter[exclude_carrier_names][]'?: string[];
'filter[plan_years][]'?: string[];
'filter[exclude_plan_years][]'?: string[];
'filter[submission_methods][]'?: string[];
'filter[exclude_submission_methods][]'?: string[];
'filter[employment_statuses][]'?: string[];
'filter[exclude_employment_statuses][]'?: string[];
'filter[created_at]'?: string;
'filter[after_date]'?: string;
'filter[before_date]'?: string;
'filter[reimbursement_only]'?: string;
'filter[vip_employer]'?: string;
};

export type GetBrokersBrokerAttentionNeededItemsParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
'filter[statuses][]'?: string[];
'filter[exclude_statuses][]'?: string[];
'filter[reasons][]'?: string[];
'filter[exclude_reasons][]'?: string[];
'filter[enrollment_types][]'?: string[];
'filter[exclude_enrollment_types][]'?: string[];
'filter[enrollment_categories][]'?: string[];
'filter[exclude_enrollment_categories][]'?: string[];
'filter[member_ids][]'?: string[];
'filter[exclude_member_ids][]'?: string[];
'filter[employer_ids][]'?: string[];
'filter[exclude_employer_ids][]'?: string[];
'filter[broker_ids][]'?: string[];
'filter[exclude_broker_ids][]'?: string[];
'filter[tag_ids][]'?: string[];
'filter[exclude_tag_ids][]'?: string[];
'filter[carrier_names][]'?: string[];
'filter[exclude_carrier_names][]'?: string[];
'filter[plan_years][]'?: string[];
'filter[exclude_plan_years][]'?: string[];
'filter[submission_methods][]'?: string[];
'filter[exclude_submission_methods][]'?: string[];
'filter[employment_statuses][]'?: string[];
'filter[exclude_employment_statuses][]'?: string[];
'filter[created_at]'?: string;
'filter[after_date]'?: string;
'filter[before_date]'?: string;
'filter[reimbursement_only]'?: string;
'filter[vip_employer]'?: string;
'sort[state]'?: GetBrokersBrokerAttentionNeededItemsSortState;
'sort[created_at]'?: GetBrokersBrokerAttentionNeededItemsSortCreatedAt;
};

export type GetBrokersBrokerAttentionNeededItemsSortState = typeof GetBrokersBrokerAttentionNeededItemsSortState[keyof typeof GetBrokersBrokerAttentionNeededItemsSortState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersBrokerAttentionNeededItemsSortState = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersBrokerAttentionNeededItemsSortCreatedAt = typeof GetBrokersBrokerAttentionNeededItemsSortCreatedAt[keyof typeof GetBrokersBrokerAttentionNeededItemsSortCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersBrokerAttentionNeededItemsSortCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTasksParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
'filters[statuses][]'?: string[];
'filters[execution_methods][]'?: string[];
'filters[handlers][]'?: string[];
'filters[member_ids][]'?: string[];
'filters[broker_ids][]'?: string[];
'filters[carrier_names][]'?: string[];
'filters[enrollment_categories][]'?: string[];
'filters[task_types][]'?: string[];
/**
 * Filter by task categories (submission, payment, autopay)
 */
'filters[task_categories][]'?: string[];
/**
 * Filter for V2 tasks only
 */
'filters[v2_only]'?: boolean;
'filters[after_date]'?: string;
'filters[before_date]'?: string;
'sort[state]'?: GetBrokersTasksSortState;
'sort[created_at]'?: GetBrokersTasksSortCreatedAt;
'sort[execution_method]'?: GetBrokersTasksSortExecutionMethod;
};

export type GetBrokersTasksSortState = typeof GetBrokersTasksSortState[keyof typeof GetBrokersTasksSortState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTasksSortState = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTasksSortCreatedAt = typeof GetBrokersTasksSortCreatedAt[keyof typeof GetBrokersTasksSortCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTasksSortCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTasksSortExecutionMethod = typeof GetBrokersTasksSortExecutionMethod[keyof typeof GetBrokersTasksSortExecutionMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTasksSortExecutionMethod = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTasksTaskTypesParams = {
/**
 * Show only task types with active tasks
 */
active_only?: boolean;
/**
 * Filter tasks created after this date (YYYY-MM-DD)
 */
after_date?: string;
/**
 * Filter tasks created before this date (YYYY-MM-DD)
 */
before_date?: string;
/**
 * Filter to specific task type class names
 */
'task_types[]'?: string[];
};

export type PostBrokersTasksTaskTypesTaskTypeExecute201 = { [key: string]: unknown };

export type GetBrokersTasksV2StatisticsParams = {
/**
 * Filter tasks created after this date (YYYY-MM-DD)
 */
after_date?: string;
/**
 * Filter tasks created before this date (YYYY-MM-DD)
 */
before_date?: string;
};

export type GetBrokersTasksV2HoldsParams = {
/**
 * Filter by task type
 */
task_type?: string;
/**
 * Filter by cleared status
 */
cleared?: boolean;
/**
 * Show only active holds
 */
active_only?: boolean;
};

export type GetBrokersTasksByIdTaskIdPlaywrightCommandParams = {
/**
 * Include the safety flag when generating the command
 */
safety?: boolean;
/**
 * Ignore on_hold status when generating the command (for debugging/testing)
 */
ignore_hold?: boolean;
};

export type DeleteBrokersTasksByIdTaskIdLeaseParams = {
/**
 * Force clear even if the lease has not yet expired
 */
force?: boolean;
};

export type GetBrokersCoverageAuditLogsParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
/**
 * Filter by member IDs
 */
'filters[member_ids][]'?: string[];
/**
 * Filter by enrollment ID
 */
'filters[enrollment_id]'?: string;
/**
 * Filter by target ID
 */
'filters[target_id]'?: string;
/**
 * Filter by reasons
 */
'filters[reasons][]'?: string[];
/**
 * Filter by actions
 */
'filters[actions][]'?: string[];
/**
 * Filter by target types
 */
'filters[target_types][]'?: string[];
/**
 * Filter by created by broker IDs
 */
'filters[created_by_broker_id][]'?: string[];
/**
 * Filter by corrected by broker IDs
 */
'filters[corrected_by_broker_id][]'?: string[];
/**
 * Filter by created after date
 */
'filters[after_date]'?: string;
/**
 * Filter by created before date
 */
'filters[before_date]'?: string;
'sort[created_at]'?: GetBrokersCoverageAuditLogsSortCreatedAt;
};

export type GetBrokersCoverageAuditLogsSortCreatedAt = typeof GetBrokersCoverageAuditLogsSortCreatedAt[keyof typeof GetBrokersCoverageAuditLogsSortCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersCoverageAuditLogsSortCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
/**
 * If true, evaluates task execution readiness (expensive). If false, uses simple status checks (faster for list views). Background jobs update task readiness every 15 minutes.
 */
evaluate_readiness?: boolean;
/**
 * Filter by workflow statuses
 */
'filters[statuses][]'?: GetBrokersTaskWorkflowsFiltersStatusesItem[];
/**
 * Filter by workflow types
 */
'filters[workflow_types][]'?: GetBrokersTaskWorkflowsFiltersWorkflowTypesItem[];
/**
 * Filter by enrollment IDs
 */
'filters[enrollment_ids][]'?: string[];
/**
 * Filter by member IDs
 */
'filters[member_ids][]'?: string[];
/**
 * Filter by broker IDs (assigned brokers)
 */
'filters[broker_ids][]'?: string[];
/**
 * Filter by brokerage IDs
 */
'filters[brokerage_ids][]'?: string[];
/**
 * Filter by carrier names
 */
'filters[carrier_names][]'?: string[];
/**
 * Filter by enrollment categories
 */
'filters[enrollment_categories][]'?: string[];
/**
 * Filter workflows created after date
 */
'filters[after_date]'?: string;
/**
 * Filter workflows created before date
 */
'filters[before_date]'?: string;
/**
 * Filter workflows by coverage start date after
 */
'filters[coverage_start_after_date]'?: string;
/**
 * Filter workflows by coverage start date before
 */
'filters[coverage_start_before_date]'?: string;
/**
 * Filter by employer IDs
 */
'filters[employer_ids][]'?: string[];
/**
 * Filter by employer review statuses
 */
'filters[employer_review_statuses][]'?: GetBrokersTaskWorkflowsFiltersEmployerReviewStatusesItem[];
/**
 * Filter by enrollment event types
 */
'filters[enrollment_event_types][]'?: GetBrokersTaskWorkflowsFiltersEnrollmentEventTypesItem[];
/**
 * Filter by coverage types
 */
'filters[coverage_types][]'?: GetBrokersTaskWorkflowsFiltersCoverageTypesItem[];
/**
 * Filter workflows with failed tasks
 */
'filters[has_failed_tasks]'?: boolean;
/**
 * Filter by workflow source (enrollment_event or qualifying_life_event)
 */
'filters[source][]'?: GetBrokersTaskWorkflowsFiltersSourceItem[];
/**
 * Filter by next task execution method
 */
'filters[next_task_execution_methods][]'?: GetBrokersTaskWorkflowsFiltersNextTaskExecutionMethodsItem[];
/**
 * Filter by next task execution context
 */
'filters[next_task_execution_contexts][]'?: GetBrokersTaskWorkflowsFiltersNextTaskExecutionContextsItem[];
/**
 * Filter by next task status
 */
'filters[next_task_statuses][]'?: GetBrokersTaskWorkflowsFiltersNextTaskStatusesItem[];
/**
 * Filter workflows containing specific task types (e.g., 'Tasks::V2::SubmitEnrollmentTask')
 */
'filters[workflow_task_types][]'?: string[];
/**
 * Filter workflows where tasks have these statuses (used with workflow_task_types)
 */
'filters[workflow_task_statuses][]'?: GetBrokersTaskWorkflowsFiltersWorkflowTaskStatusesItem[];
/**
 * Filter workflows where tasks have these execution methods
 */
'filters[workflow_task_execution_methods][]'?: GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionMethodsItem[];
/**
 * Filter workflows where tasks have these execution contexts
 */
'filters[workflow_task_execution_contexts][]'?: GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionContextsItem[];
/**
 * Filter workflows containing tasks of these categories
 */
'filters[workflow_task_categories][]'?: GetBrokersTaskWorkflowsFiltersWorkflowTaskCategoriesItem[];
'sort[status]'?: GetBrokersTaskWorkflowsSortStatus;
'sort[created_at]'?: GetBrokersTaskWorkflowsSortCreatedAt;
'sort[workflow_type]'?: GetBrokersTaskWorkflowsSortWorkflowType;
'sort[started_at]'?: GetBrokersTaskWorkflowsSortStartedAt;
'sort[coverage_start_date]'?: GetBrokersTaskWorkflowsSortCoverageStartDate;
'sort[member_name]'?: GetBrokersTaskWorkflowsSortMemberName;
'sort[employer_dba]'?: GetBrokersTaskWorkflowsSortEmployerDba;
'sort[carrier_name]'?: GetBrokersTaskWorkflowsSortCarrierName;
'sort[event_type]'?: GetBrokersTaskWorkflowsSortEventType;
};

export type GetBrokersTaskWorkflowsFiltersStatusesItem = typeof GetBrokersTaskWorkflowsFiltersStatusesItem[keyof typeof GetBrokersTaskWorkflowsFiltersStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersStatusesItem = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  canceled: 'canceled',
  paused: 'paused',
} as const;

export type GetBrokersTaskWorkflowsFiltersWorkflowTypesItem = typeof GetBrokersTaskWorkflowsFiltersWorkflowTypesItem[keyof typeof GetBrokersTaskWorkflowsFiltersWorkflowTypesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersWorkflowTypesItem = {
  submission: 'submission',
  renewal: 'renewal',
  plan_change: 'plan_change',
  dependent_change: 'dependent_change',
  plan_change_and_dependent_change: 'plan_change_and_dependent_change',
  off_thatch: 'off_thatch',
  cancellation: 'cancellation',
  offboarding: 'offboarding',
  medicare: 'medicare',
} as const;

export type GetBrokersTaskWorkflowsFiltersEmployerReviewStatusesItem = typeof GetBrokersTaskWorkflowsFiltersEmployerReviewStatusesItem[keyof typeof GetBrokersTaskWorkflowsFiltersEmployerReviewStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersEmployerReviewStatusesItem = {
  pending: 'pending',
  approved: 'approved',
  denied: 'denied',
  inactive_duplicate: 'inactive_duplicate',
  inactive_withdrawn: 'inactive_withdrawn',
  inactive_ineligible: 'inactive_ineligible',
  inactive_churned: 'inactive_churned',
} as const;

export type GetBrokersTaskWorkflowsFiltersEnrollmentEventTypesItem = typeof GetBrokersTaskWorkflowsFiltersEnrollmentEventTypesItem[keyof typeof GetBrokersTaskWorkflowsFiltersEnrollmentEventTypesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersEnrollmentEventTypesItem = {
  special_enrollment: 'special_enrollment',
  open_enrollment_new: 'open_enrollment_new',
  open_enrollment_renewal: 'open_enrollment_renewal',
  ichra_invite: 'ichra_invite',
} as const;

export type GetBrokersTaskWorkflowsFiltersCoverageTypesItem = typeof GetBrokersTaskWorkflowsFiltersCoverageTypesItem[keyof typeof GetBrokersTaskWorkflowsFiltersCoverageTypesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersCoverageTypesItem = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
} as const;

export type GetBrokersTaskWorkflowsFiltersSourceItem = typeof GetBrokersTaskWorkflowsFiltersSourceItem[keyof typeof GetBrokersTaskWorkflowsFiltersSourceItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersSourceItem = {
  enrollment_event: 'enrollment_event',
  qualifying_life_event: 'qualifying_life_event',
} as const;

export type GetBrokersTaskWorkflowsFiltersNextTaskExecutionMethodsItem = typeof GetBrokersTaskWorkflowsFiltersNextTaskExecutionMethodsItem[keyof typeof GetBrokersTaskWorkflowsFiltersNextTaskExecutionMethodsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersNextTaskExecutionMethodsItem = {
  automated: 'automated',
  manual: 'manual',
} as const;

export type GetBrokersTaskWorkflowsFiltersNextTaskExecutionContextsItem = typeof GetBrokersTaskWorkflowsFiltersNextTaskExecutionContextsItem[keyof typeof GetBrokersTaskWorkflowsFiltersNextTaskExecutionContextsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersNextTaskExecutionContextsItem = {
  thatch: 'thatch',
  member: 'member',
} as const;

export type GetBrokersTaskWorkflowsFiltersNextTaskStatusesItem = typeof GetBrokersTaskWorkflowsFiltersNextTaskStatusesItem[keyof typeof GetBrokersTaskWorkflowsFiltersNextTaskStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersNextTaskStatusesItem = {
  pending: 'pending',
  processing: 'processing',
  blocked: 'blocked',
  completed: 'completed',
  canceled: 'canceled',
  excluded: 'excluded',
  failed: 'failed',
} as const;

export type GetBrokersTaskWorkflowsFiltersWorkflowTaskStatusesItem = typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskStatusesItem[keyof typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersWorkflowTaskStatusesItem = {
  pending: 'pending',
  processing: 'processing',
  blocked: 'blocked',
  completed: 'completed',
  canceled: 'canceled',
  excluded: 'excluded',
  failed: 'failed',
} as const;

export type GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionMethodsItem = typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionMethodsItem[keyof typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionMethodsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionMethodsItem = {
  automated: 'automated',
  manual: 'manual',
} as const;

export type GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionContextsItem = typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionContextsItem[keyof typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionContextsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersWorkflowTaskExecutionContextsItem = {
  thatch: 'thatch',
  member: 'member',
} as const;

export type GetBrokersTaskWorkflowsFiltersWorkflowTaskCategoriesItem = typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskCategoriesItem[keyof typeof GetBrokersTaskWorkflowsFiltersWorkflowTaskCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsFiltersWorkflowTaskCategoriesItem = {
  submission: 'submission',
  payment: 'payment',
  autopay: 'autopay',
} as const;

export type GetBrokersTaskWorkflowsSortStatus = typeof GetBrokersTaskWorkflowsSortStatus[keyof typeof GetBrokersTaskWorkflowsSortStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortStatus = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortCreatedAt = typeof GetBrokersTaskWorkflowsSortCreatedAt[keyof typeof GetBrokersTaskWorkflowsSortCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortWorkflowType = typeof GetBrokersTaskWorkflowsSortWorkflowType[keyof typeof GetBrokersTaskWorkflowsSortWorkflowType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortWorkflowType = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortStartedAt = typeof GetBrokersTaskWorkflowsSortStartedAt[keyof typeof GetBrokersTaskWorkflowsSortStartedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortStartedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortCoverageStartDate = typeof GetBrokersTaskWorkflowsSortCoverageStartDate[keyof typeof GetBrokersTaskWorkflowsSortCoverageStartDate];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortCoverageStartDate = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortMemberName = typeof GetBrokersTaskWorkflowsSortMemberName[keyof typeof GetBrokersTaskWorkflowsSortMemberName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortMemberName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortEmployerDba = typeof GetBrokersTaskWorkflowsSortEmployerDba[keyof typeof GetBrokersTaskWorkflowsSortEmployerDba];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortEmployerDba = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortCarrierName = typeof GetBrokersTaskWorkflowsSortCarrierName[keyof typeof GetBrokersTaskWorkflowsSortCarrierName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortCarrierName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsSortEventType = typeof GetBrokersTaskWorkflowsSortEventType[keyof typeof GetBrokersTaskWorkflowsSortEventType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBrokersTaskWorkflowsSortEventType = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetBrokersTaskWorkflowsIdParams = {
/**
 * If true, evaluates task execution readiness (ensures fresh data). If false, uses simple status checks (faster but may be stale).
 */
evaluate_readiness?: boolean;
};

export type GetQuotingProspectsParams = {
/**
 * Owner ID (admin-only parameter)
 */
owner_id?: string;
/**
 * Partner ID (admin-only parameter)
 */
partner_id?: string;
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetQuotingProspectsProspectIdQuotesParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetQuotingProspectsProspectIdCensusParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter by census status
 */
'filter[status]'?: string;
};

export type GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetQuotingQuoteResultsQuoteIdResultsParams = {
/**
 * Metal tier
 */
metal_tier: GetQuotingQuoteResultsQuoteIdResultsMetalTier;
/**
 * Coverage percentile
 * @minimum 1
 * @maximum 100
 */
coverage_percentile: number;
};

export type GetQuotingQuoteResultsQuoteIdResultsMetalTier = typeof GetQuotingQuoteResultsQuoteIdResultsMetalTier[keyof typeof GetQuotingQuoteResultsQuoteIdResultsMetalTier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuotingQuoteResultsQuoteIdResultsMetalTier = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
} as const;

export type GetQuotingQuoteResultsQuoteIdPlansParams = {
/**
 * ZIP code
 */
zip: string;
/**
 * State abbreviation (if not provided, will be guessed from ZIP)
 */
state?: string;
/**
 * JSON array of ages for covered participants
 */
ages: string;
/**
 * JSON array of relationships for covered participants
 */
relationships: string;
/**
 * Plan year (if not provided, defaults to next year if past October, current year otherwise)
 */
year?: number;
/**
 * Monthly allowance amount
 */
allowance?: string;
};

export type GetQuotingPricesQuoteIdParams = {
/**
 * Workflow type for pricing
 */
workflow_type: GetQuotingPricesQuoteIdWorkflowType;
};

export type GetQuotingPricesQuoteIdWorkflowType = typeof GetQuotingPricesQuoteIdWorkflowType[keyof typeof GetQuotingPricesQuoteIdWorkflowType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuotingPricesQuoteIdWorkflowType = {
  self_serve: 'self_serve',
  sales: 'sales',
  broker: 'broker',
  public: 'public',
  renewal: 'renewal',
} as const;

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams = {
/**
 * Include ineligible participants if available, will only work for the enrollment event that supports plan selection metadata
 */
include_ineligible?: boolean;
};

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams = {
/**
 * Filter by expected plan utilization. With oop_budget, it will trigger the generation of recommended plans.
 */
expected_plan_utilization?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansExpectedPlanUtilization;
/**
 * Filter by out-of-pocket budget (in dollars per month). With expected_plan_utilization, it will trigger the generation of recommended plans.
 */
oop_budget?: number;
/**
 * Filter by metal tier.
 */
'metal_tier[]'?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansMetalTierItem[];
/**
 * Filter by plan type.
 */
'plan_type[]'?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansPlanTypeItem[];
/**
 * Filter by carrier name
 */
'carrier_name[]'?: string[];
/**
 * Field(s) to sort plans by
 */
'sort[]'?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansSortItem[];
/**
 * Get the plan information with given provider NPIs
 */
'provider_npis[]'?: string[];
/**
 * Flag to generate recommendations for the member
 */
generate_recommendations?: boolean;
/**
 * Array of plan IDs to check for availability in the returned plans
 */
'plans_for_comparison[]'?: string[];
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansExpectedPlanUtilization = typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansExpectedPlanUtilization[keyof typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansExpectedPlanUtilization];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansExpectedPlanUtilization = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansMetalTierItem = typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansMetalTierItem[keyof typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansMetalTierItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansMetalTierItem = {
  catastrophic: 'catastrophic',
  bronze: 'bronze',
  expanded_bronze: 'expanded_bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
} as const;

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansPlanTypeItem = typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansPlanTypeItem[keyof typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansPlanTypeItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansPlanTypeItem = {
  hmo: 'hmo',
  ppo: 'ppo',
  epo: 'epo',
  pos: 'pos',
} as const;

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansSortItem = typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansSortItem[keyof typeof GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansSortItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansSortItem = {
  actuarial_value: 'actuarial_value',
  '-actuarial_value': '-actuarial_value',
  bucketed_premium: 'bucketed_premium',
  '-bucketed_premium': '-bucketed_premium',
  deductible: 'deductible',
  '-deductible': '-deductible',
  premium: 'premium',
  '-premium': '-premium',
  provider_count: 'provider_count',
  '-provider_count': '-provider_count',
} as const;

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams = {
/**
 * List of Plan IDs
 */
'plan_ids[]': string[];
/**
 * Plan year filter to be used in case this plan ID should be found from a different plan year from the current plan selection ichra config
 */
plan_year?: number;
};

export type GetMemberOnboardingRecommendedPlansParams = {
/**
 * Plan year used for the recommendation
 */
year?: number;
};

export type GetMemberOnboardingProofOfCoverageMostRecentParams = {
/**
 * The plan year of the proof of coverage document
 */
plan_year?: number;
};

export type GetPayrollAdpConnectCallbackParams = {
/**
 * Authorization code from ADP
 */
code?: string;
/**
 * State parameter from OAuth flow
 */
state?: string;
/**
 * Optional OAuth scope to request
 */
scope?: string;
/**
 * Error provided by ADP consent manager
 */
error?: string;
/**
 * Error description provided by ADP consent manager
 */
error_description?: string;
/**
 * Error code provided by ADP consent manager
 */
'x-ca-err'?: string;
};

export type GetPayrollConsistentDeductionsParams = {
/**
 * Pay period ID
 */
pay_period_id: string;
};

export type GetPayrollPayPeriodsParams = {
/**
 * Pay schedule ID
 */
pay_schedule_id: string;
};

export type GetPayrollPaySchedulesParams = {
/**
 * Comma-separated list of pay schedule IDs
 */
ids?: string;
/**
 * Hide default schedules if they have no employees and there are other active, verified pay schedules
 */
hide_default?: boolean;
};

export type GetPayrollPaySchedulesPreviewParams = {
frequency: GetPayrollPaySchedulesPreviewFrequency;
bank_closure_strategy: GetPayrollPaySchedulesPreviewBankClosureStrategy;
reference_pay_date?: string;
/**
 * @minimum 1
 * @maximum 31
 */
first_day?: number;
/**
 * @minimum 1
 * @maximum 31
 */
second_day?: number;
start_date?: string;
end_date?: string;
is_verified?: boolean;
};

export type GetPayrollPaySchedulesPreviewFrequency = typeof GetPayrollPaySchedulesPreviewFrequency[keyof typeof GetPayrollPaySchedulesPreviewFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPayrollPaySchedulesPreviewFrequency = {
  monthly: 'monthly',
  semi_monthly: 'semi_monthly',
  bi_weekly: 'bi_weekly',
  weekly: 'weekly',
} as const;

export type GetPayrollPaySchedulesPreviewBankClosureStrategy = typeof GetPayrollPaySchedulesPreviewBankClosureStrategy[keyof typeof GetPayrollPaySchedulesPreviewBankClosureStrategy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPayrollPaySchedulesPreviewBankClosureStrategy = {
  before: 'before',
  after: 'after',
  closest: 'closest',
  ignore: 'ignore',
} as const;

export type DeletePayrollPaySchedulesDeactivateParams = {
pay_schedule_id: string;
};

export type DeletePayrollPaySchedulesRemoveEmployeeParams = {
pay_schedule_id: string;
employee_id: string;
};

/**
 * Reimbursement type
 */
export type PostReimbursementsBodyOneType = typeof PostReimbursementsBodyOneType[keyof typeof PostReimbursementsBodyOneType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostReimbursementsBodyOneType = {
  HSA: 'HSA',
  ICHRA: 'ICHRA',
} as const;

/**
 * Purpose
 */
export type PostReimbursementsBodyOnePurpose = typeof PostReimbursementsBodyOnePurpose[keyof typeof PostReimbursementsBodyOnePurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostReimbursementsBodyOnePurpose = {
  medical: 'medical',
  dental: 'dental',
  vision: 'vision',
  qme: 'qme',
  premium: 'premium',
} as const;

export type PostReimbursementsBodyOne = {
  /** Amount */
  amount: number;
  /** Member description */
  member_description: string;
  /** Reimbursement type */
  type: PostReimbursementsBodyOneType;
  /** Purpose */
  purpose?: PostReimbursementsBodyOnePurpose;
  /** Receipts */
  'receipts[]'?: Blob[];
  /** Transaction date */
  transaction_date?: string;
};

export type GetMarketplaceProductsParams = {
/**
 * Sort order
 */
sort?: string;
};

export type GetEmployersEmployeesParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Search by name or email
 */
search?: string;
/**
 * Filter by payroll synced employees
 */
payroll_synced?: boolean;
};

export type GetEmployersEmployeesPaySchedulesPayScheduleIdParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Search by name or email
 */
search?: string;
};

export type GetEmployersEmployeesDuplicatesParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
};

export type GetEmployersRenewalsRenewalConfigsIdEmployeesParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter by name
 */
'filter[name]'?: string;
/**
 * Filter by employment types
 */
'filter[employment_types][]'?: GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEmploymentTypesItem[];
/**
 * Filter by enrollment statuses
 */
'filter[enrollment_statuses][]'?: GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEnrollmentStatusesItem[];
/**
 * Exclude offboarded employees
 */
'filter[exclude_offboarded_employees]'?: boolean;
/**
 * Include employees with missing required information
 */
'filter[include_employees_with_missing_required_information]'?: boolean;
};

export type GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEmploymentTypesItem = typeof GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEmploymentTypesItem[keyof typeof GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEmploymentTypesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEmploymentTypesItem = {
  part_time: 'part_time',
  full_time: 'full_time',
} as const;

export type GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEnrollmentStatusesItem = typeof GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEnrollmentStatusesItem[keyof typeof GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEnrollmentStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEnrollmentStatusesItem = {
  enrolled: 'enrolled',
  declined: 'declined',
  not_invited: 'not_invited',
  offboarded: 'offboarded',
  not_accepted: 'not_accepted',
} as const;

export type GetPartnersEmployersParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Filter by whether the employer's onboarding is in progress
 */
'filter[in_progress]'?: boolean;
/**
 * Filter by assignee ID
 */
'filter[assignee_ids][]'?: string[];
/**
 * Filter by onboarding status
 */
'filter[statuses][]'?: string[];
/**
 * Filter by employer name (case insensitive search on name or DBA)
 */
'filter[name]'?: string;
};

export type GetPartnersPartnerIdPartnerAdminsParams = {
/**
 * Filter partner admins by name (case insensitive)
 */
'filter[name]'?: string;
/**
 * Filter partner admins by email (case insensitive)
 */
'filter[email]'?: string;
/**
 * Filter partner admins by name or email (case insensitive)
 */
'filter[name_or_email]'?: string;
/**
 * Filter partner admins by roles
 */
'filter[roles][]'?: string[];
/**
 * Filter partner admins by status
 */
'filter[status]'?: string;
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * Sort order
 */
sort?: string;
};

export type GetMembersTransactionsParams = {
/**
 * Page number
 * @minimum 1
 */
'page[number]'?: number;
/**
 * Number of items per page. Must be between 1 and 1,000 (inclusive). Defaults to 20.
 * @minimum 1
 * @maximum 1000
 */
'page[size]'?: number;
/**
 * The plan year to get transactions for
 */
plan_year: number;
/**
 * Filter by transaction categories (can specify multiple)
 */
'categories[]'?: GetMembersTransactionsCategoriesItem[];
/**
 * Search in transaction description
 */
description?: string;
};

export type GetMembersTransactionsCategoriesItem = typeof GetMembersTransactionsCategoriesItem[keyof typeof GetMembersTransactionsCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMembersTransactionsCategoriesItem = {
  employer_allowance: 'employer_allowance',
  insurance_premium: 'insurance_premium',
  healthcare_expense: 'healthcare_expense',
  other: 'other',
} as const;

export type GetMembersTransactionsBalanceAndBreakdownsParams = {
/**
 * The plan year to get the balance or deduction for
 */
plan_year: number;
};

export type GetMembersDepositAccountDetailsParams = {
/**
 * The plan year to get the deposit account details for
 */
plan_year: number;
};

export type GetMembersEnrollmentsParams = {
/**
 * Plan year
 */
plan_year: number;
};

export type GetMembersInstructionsParams = {
/**
 * Filter instructions by responsibility
 */
responsibility?: GetMembersInstructionsResponsibility;
/**
 * Filter instructions by status (comma-separated values)
 */
status?: string;
};

export type GetMembersInstructionsResponsibility = typeof GetMembersInstructionsResponsibility[keyof typeof GetMembersInstructionsResponsibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMembersInstructionsResponsibility = {
  member: 'member',
  thatch: 'thatch',
} as const;

export type GetMembersReimbursementsParams = {
/**
 * Page number
 */
page?: number;
/**
 * Items per page
 */
items?: number;
'sort[state]'?: GetMembersReimbursementsSortState;
'sort[created_at]'?: GetMembersReimbursementsSortCreatedAt;
'filter[states][]'?: string[];
'filter[purposes][]'?: string[];
'filter[enrollment_categories][]'?: string[];
'filter[has_receipts]'?: string;
'filter[member_description]'?: string;
'filter[after_date]'?: string;
'filter[before_date]'?: string;
'filter[plan_year]'?: number;
};

export type GetMembersReimbursementsSortState = typeof GetMembersReimbursementsSortState[keyof typeof GetMembersReimbursementsSortState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMembersReimbursementsSortState = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetMembersReimbursementsSortCreatedAt = typeof GetMembersReimbursementsSortCreatedAt[keyof typeof GetMembersReimbursementsSortCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMembersReimbursementsSortCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetFeedbackPromptsNextParams = {
/**
 * Filter by prompt keys
 */
'keys[]'?: string[];
};

export type GetUsersSidebarPromoCardsActiveParams = {
/**
 * Target audience (employer, member, or partner)
 */
audience: GetUsersSidebarPromoCardsActiveAudience;
};

export type GetUsersSidebarPromoCardsActiveAudience = typeof GetUsersSidebarPromoCardsActiveAudience[keyof typeof GetUsersSidebarPromoCardsActiveAudience];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersSidebarPromoCardsActiveAudience = {
  employer: 'employer',
  member: 'member',
  partner: 'partner',
} as const;

